import { Component, OnInit, ViewChild, Renderer2, ElementRef, Inject, ChangeDetectorRef, OnDestroy, Input, QueryList, EventEmitter, Output, HostListener, ViewChildren, OnChanges, SimpleChanges, AfterViewInit, AfterViewChecked} from '@angular/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { MessageService } from 'src/app/services/message/message.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {MatPaginator} from '@angular/material/paginator';
import { MatButton, MatMenuTrigger, MatOption, MatSelect } from '@angular/material';
import { MatMenu } from '@angular/material/menu';
import {forkJoin, merge, Observable, of as observableOf, of, Subject, Subscription} from 'rxjs';
import {catchError, filter, map, startWith, switchMap, takeUntil, tap} from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import { requiredFileType } from '../../../app-file-upload/upload-file-validators';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ErrorStateMatcher} from '@angular/material/core';
import { ConfirmationDialogComponent } from '../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import { Lightbox } from 'ngx-lightbox';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SubjectsListComponent } from '../subjects-list/subjects-list.component';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { SocketService } from 'src/app/services/socket/socket.service';
import { Message } from 'src/app/services/socket/model/message';
import { Event } from 'src/app/services/socket/model/event';
import { AbstractControl, FormArray} from '@angular/forms';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { DomSanitizer } from '@angular/platform-browser';
import { OutsideClickDirective } from './outsideClickDirective';
import { v4 as uuidv4 } from 'uuid';
import {franc} from 'franc-min';
/// <reference path="src/typings/media-recorder.d.ts" />
import * as lamejs from 'lamejs';

import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { OtherOptionsComponent } from '../other-options/other-options.component';
import { LoadingScreenService } from 'src/app/services/loading-screen/loading-screen.service';
import { DashboardDialogNotif, DashboardDialogProjectNotif } from 'src/app/components/dashboard-menu/dashboard-menu.component';
import { SubjectDuppComponent } from '../subject-dupp/subject-dupp.component';
import { element } from 'protractor';
import { ProfileComponent, croppedimagedialog } from 'src/app/pages/profile/profile.component';
import { TransferComponent } from './transfer/transfer.component';
import { CoreServiceService } from 'src/app/services/core/core-service.service';
import { TranslationService } from 'src/app/services/translate/translation.service';
import { ConfirmdialogComponent } from '../confirmdialog/confirmdialog.component';
import { AiService } from 'src/app/services/ai/ai.service';
import { PaymentComponent } from '../payment/payment.component';
import { PackComponent } from '../pack/pack.component';
import { SubjectMapComponent } from '../subject-map/subject-map.component';
import { AngularEditorComponent, AngularEditorConfig } from '@kolkov/angular-editor';
import { ProjectStateService } from 'src/app/services/project-state.service';
import { HttpEventType } from '@angular/common/http';

export interface Participant {
  id: number;
  nom: string;
  avatar: string;
}

export interface searchFilter {
  transmitter: string;
  recipient: string;
  copy: string;
  projectId: string;
  dateBefore: any;
  dateDeadline: any;
  dateDeadlineAfter: any;
  dateAfter: any;
  tag: string;
  statut: boolean;
  type: string;
  keyWord: string;
  smartNumber: string;
  drive?: boolean,
  isGeneral?: any,
  isThematic?: any,
  isTask?: any
}

export interface searchFilterInstant {
  transmitterinstant: string;
  typeinstant: string;
  dateBeforeinstant: any;
  dateAfterinstant: any;
  keyWordinstant: string;
  smartNumber: string;
}

export interface CardTag {
  icon: string;
  label: string;
}
 
export interface WelcomeCard {
  number: number;
  title: string;
  description: string;
  icon: string;      // clé de l'icône principale de la carte
  badge?: string;     // ex: 'Recommandé'
  theme: 'green' | 'blue';
  tags: CardTag[];
}

@Component({
  selector: 'app-single-project',
  templateUrl: './single-project.component.html',
  styleUrls: ['./single-project.component.scss'],
  animations: [
    trigger('rotateIcon', [
      state('normal', style({
        transform: 'rotate(0deg)'
      })),
      state('rotated', style({
        transform: 'rotate(135deg)'
      })),
      transition('normal => rotated', animate('0.2s')),
      transition('rotated => normal', animate('0.2s'))
    ]),
    // Nouvelle animation pour glisser les messages
    trigger('slideOut', [
      // Animation lors de la sortie du message (glissement vers la droite)
      transition(':leave', [
        animate('1500ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ transform: 'translateX(100%)  scale(0.9)', opacity: 0 }))
      ])
    ])
  ]
})
export class SingleProjectComponent implements OnInit, OnDestroy, AfterViewChecked {
 
 
  toggleTache() {
    //this.transformerEnTache = !this.transformerEnTache;
    this.relance_enabled = !this.relance_enabled;
    this.echeance = null;
  }

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '80px',
    placeholder: this.translateService.instant('map.placeholder'),//'Commencez votre échange',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Inter',
    toolbarHiddenButtons: [
    [
      'strikeThrough',
      'subscript',
      'superscript',
      'justifyLeft',
      'justifyCenter',
      'justifyRight',
      'justifyFull',
      'indent',
      'outdent',
      'insertUnorderedList',
      'insertOrderedList',
      'heading',
      'fontName',
      'fontSize',
      'textColor',
      'backgroundColor',
      'customClasses',
      'insertImage',
      'insertVideo',
      'insertHorizontalRule',
      'removeFormat',
      'toggleEditorMode'
    ]
    ]
  };
  displayedColumns: string[] = ['Message'];
  @Input() ged: boolean = false;
  public minDate = new Date();
  public minDateRelance = new Date();
  deadline: Date | null;
  deadlineRelanceOne: Date | null;
  private subscriptions: Subscription[] = [];
  private destroy$ = new Subject<void>();
  private cancelRequest$ = new Subject<void>();
  private cancelInstantRequest$ = new Subject<void>();
  openedIndex: number | null = null;
  openedIndexAnswer: boolean = null;
  openedIndexComment: number | null = null;

  isLoadingResults = true;
  isRateLimitReached = false;
  instanttype: string = 'Valeur de mon champ';
  private _album = [];
  searchContact: any;
  writeMode = -1; // 1 = write answer, 2 = comment
  openWriteFace = false;
  showMessages = true;
  divopened = false;
  icons = ["ok.png", "merci.png", "non.png", "pas-dac.png"]

  toggleFiles(index: number, answer = false, comment = null) 
  {
    console.log("comment "+comment)
    console.log("index "+index)
    if(comment != null) {
      this.openedIndexComment = comment;
      this.openedIndex = this.openedIndex === index ? null : index;
    } else if(answer) {
      this.openedIndexAnswer = answer;
      this.openedIndex = this.openedIndex === index ? null : index;
    } else this.openedIndex = this.openedIndex === index ? null : index;
  }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('divHeaderTable', {static: false}) divHeaderTable: ElementRef;
  @ViewChild('divComSpecMsg', {static: false}) divComSpecMsg: ElementRef;
  @ViewChild('theForm', {static: true}) theForm: FormGroupDirective;
  @ViewChild('theFormInstant', {static: true}) theFormInstant: FormGroupDirective;
  @ViewChild('inputMedia', {static: false}) inputMedia: ElementRef;
  @ViewChild('scrollMechat', { static: false }) scrollMechat: ElementRef;
  isAtBottom = true;
  isAtBottomResult = true;
  isAutoScrolling = false;
  chrono_mode = true;
  @ViewChild('readmsgdiv', { static: false }) readmsgdiv: ElementRef;
  @ViewChild('scrollResultchat', { static: false }) scrollResultchat: ElementRef;
  //@ViewChild('writeMsg') writeMsg: ElementRef;
  inCopy = new FormControl();
  @ViewChild('allSelected', {static: false}) private allSelected: MatOption;
  @ViewChild('selectRecipient', {static: true}) private selectRecipient: MatSelect;
  @ViewChild('selectCopies', {static: true}) private selectCopies: MatSelect;
  @ViewChild('selectSubject', {static: false}) private selectSubject: MatSelect;
  @ViewChild('oneToOneOption', {static: true}) private oneToOneOption: MatOption;
  @ViewChild('descp', {static: false}) descp: AngularEditorComponent;
  @ViewChild('commenttext', {static: false}) commenttext: ElementRef;
  @ViewChild('commentresponsetext', {static: false}) commentresponsetext: ElementRef;
  @ViewChild('inputMessage2', {static: false}) inputMessage2: ElementRef;
  @ViewChild('sendmsgdiv', {static: false}) sendmsgdiv: ElementRef;
  @ViewChild('allmsg', {static: false}) allmsg: ElementRef;
  @ViewChild('topface', {static: false}) topface: ElementRef;
  @ViewChild('typeprojectin', {static: false}) typeprojectin: ElementRef;
  @ViewChild('allmsg2', {static: false}) allmsg2: ElementRef;
  @ViewChild('typeproject', {static: false}) checkproject: ElementRef;
  @ViewChild('messageBloc', {static: false}) messageBloc: ElementRef;
  @ViewChild('missionname', {static: false}) missionname: ElementRef;
  @ViewChild('generaluser', {static: true}) private general: MatOption;
  @ViewChild('General', {static: true}) private generalmission: MatOption;
  @ViewChild("selectNotify", {static: true}) selectNotify: MatSelect;
  selectedoption = false;
  

  hideSelectCopy = true;
  hideSelectCopyMenu = false;
  resultsLength = 0;
  resultsLengthIns = 0;
  searchresLength = 0;
  searchresLengthInst = 0;
  targetValue: number = 0;
  targetValueIns: number = 0;
  intervalId: any;
  perPage = 30;
  limitmsg = 20;
  offsetmsg = 0;
  pageIndex = 0;
  dataloaded = false;
  loadingMessagesTop = false;
  startedPoint = false;
  scollheight = 0;
  scrollposition = 0;
  canload = false;
  nbrloadmsg = 0;
  userAdmin = false;
  dataSource : any[] = [];
  messagenotif: string = 'tous vos messages sont traités';
  isVisible: boolean = false;
  messagesInstant : any[];
  messagesInstantSent : any[];
  messagesResults : any[];//ss
  firstDate : any = "";
  specMsg: any;
  specCom: any;
  specComment = false;
  openmsg: any;
  idmsg: any;
  opened = false;
  specMsgType: any;
  ID: any;
  projectFull: any;
  projectUsers = [];
  userscolor: Map<string, any> = new Map();
  projectmembers = "";
  currentuserProject : any;
  arrayUserCopy = [];
  projectTags  = [];
  onlyUserTags  = [];
  arrayQuickAnswer = [];
  newTagsArray: any;
  project: string;
  isCommentActivated = true;
  messageInfo: any;
  chosenFilterProject = null;
  expanded: boolean = true;
  readmsg = 0;
  visibleDivIndex: number | null = null;
  //@Input() ongletId: string;
  ongletId = this.messageService.getOngletId();
  index_msg = 0;
  limit: number = 190;
  limitcomment: number = 105;
  hasMessage = false;
  currentUser: any;
  currentUserInfo: any;
  sendMessageForm: FormGroup;
  tempMember = [];
  temporarySelectedValues: any[] = [];
  allSelect = false
  sendMessageFormInstant: FormGroup;
  msgsent = false;
  facesent = false;
  sendanswerForm: FormGroup;
  formComment: FormGroup;
  formCommentResponse: FormGroup;
  currentDate = null;
  localDate : String;
  yesterdayDate : String;
  submitted = false;
  menuOuvert = false;
  popupVisible = false;
  @ViewChild('toggleLink', {static: false}) toggleLink: ElementRef;
  private closeTimeout: any;
  typefileselected = "photo";
  secteur = "";
  firstConnection = null;
  currentCompany = null;
  files: any = [];
  filesinstant: any = [];
  msgAnswered: any = null;
  numdoc: number = null;
  selectedPdf = null;
  multipleRecipient = false;
  tempMemberUser = [];
  tempRecipientUser = [];
  tempRecipientSelected = [];
  tempCopyUsers = [];
  tempCopyUsersInit = [];
  lastFaceNumber = 1;
  showRedBar = false;
  showTool = false;
  hiddenSearchEngin = true;
  room = 'room1'; // Exemple de room
  userId = 'user1'; // ID de l'utilisateur actuel
  isTyping = false; // Etat pour savoir si l'utilisateur est en train de taper
  typingUser: any | null = null; // Utilisateur qui est en train de taper
  uploadProgress = 0;

  stopTypingTimeout: any;
  hiddenSearchEngindrive  = true;
  ISendMessage = false;
  senderror = false;
  copiesusers = [];
  copyvalidate = false;
  addmissionclicked = 0;
  newProjectSubject = "";
  selectedOptiontag = "";
  selectAll = false;
  searchResults: number[] = [];
  currentIndex = 0; 
  search = false;
  state = 'normal';
  notificationsCount = 0;
  msgInstantRetry = null;
  filesInstantRetry : any = [];
  inviteBadge = 10;
  //sentNotifCount = 0;
  notifiedmode = false;
  receiveNotifCount = 0;
  copyNotifCount = 0;
  commentNotifCount = 0;
  sentNotifProjectCount = 0;
  total = 0;
  receiveNotifProjectCount = 0;
  copyNotifProjectCount = 0;
  commentNotifProjectCount = 0;
  //private sentNotifCountSubscription: Subscription;
  notifyValue = "ALL";
  updclicked = false;
  updateSubject = "";
  deadlineSubject = null;
  @ViewChildren('bullContaine') myDivs!: QueryList<ElementRef>;
  showEmojiPicker: boolean = false;
  langue = "en";
  languages = [
    { code: 'af', name: 'Afrikaans', image: 'https://flagcdn.com/w320/za.png' },
    { code: 'sq', name: 'Albanais', image: 'https://flagcdn.com/w320/al.png' },
    { code: 'de', name: 'Allemand', image: 'https://flagcdn.com/w320/de.png' },
    { code: 'am', name: 'Amharique', image: 'https://flagcdn.com/w320/et.png' },
    { code: 'en', name: 'Anglais', image: 'https://flagcdn.com/w320/us.png' },
    { code: 'ar', name: 'Arabe', image: 'https://flagcdn.com/w320/sa.png' },
    { code: 'hy', name: 'Arménien', image: 'https://flagcdn.com/w320/am.png' },
    { code: 'bn', name: 'Bengali', image: 'https://flagcdn.com/w320/bd.png' },
    { code: 'bs', name: 'Bosnien', image: 'https://flagcdn.com/w320/ba.png' },
    { code: 'bg', name: 'Bulgare', image: 'https://flagcdn.com/w320/bg.png' },
    { code: 'ca', name: 'Catalan', image: 'https://flagcdn.com/w320/es.png' },
    { code: 'zh-CN', name: 'Chinois simplifié', image: 'https://flagcdn.com/w320/cn.png' },
    { code: 'zh-TW', name: 'Chinois traditionnel', image: 'https://flagcdn.com/w320/tw.png' },
    { code: 'ko', name: 'Coréen', image: 'https://flagcdn.com/w320/kr.png' },
    { code: 'hr', name: 'Croate', image: 'https://flagcdn.com/w320/hr.png' },
    { code: 'da', name: 'Danois', image: 'https://flagcdn.com/w320/dk.png' },
    { code: 'es', name: 'Espagnol', image: 'https://flagcdn.com/w320/es.png' },
    { code: 'eo', name: 'Espéranto', image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Flag_of_Esperanto.svg/langfr-225px-Flag_of_Esperanto.svg.png' }, // Pas de drapeau spécifique pour l'Espéranto
    { code: 'et', name: 'Estonien', image: 'https://flagcdn.com/w320/ee.png' },
    { code: 'tl', name: 'Filipino', image: 'https://flagcdn.com/w320/ph.png' },
    { code: 'fi', name: 'Finnois', image: 'https://flagcdn.com/w320/fi.png' },
    { code: 'fr', name: 'Français', image: 'https://flagcdn.com/w320/fr.png' },
    { code: 'cy', name: 'Gallois', image: 'https://flagcdn.com/w320/gb.png' },
    { code: 'ka', name: 'Géorgien', image: 'https://flagcdn.com/w320/ge.png' },
    { code: 'el', name: 'Grec', image: 'https://flagcdn.com/w320/gr.png' },
    { code: 'gu', name: 'Gujarati', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'hi', name: 'Hindi', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'he', name: 'Hébreu', image: 'https://flagcdn.com/w320/il.png' },
    { code: 'hu', name: 'Hongrois', image: 'https://flagcdn.com/w320/hu.png' },
    { code: 'is', name: 'Islandais', image: 'https://flagcdn.com/w320/is.png' },
    { code: 'it', name: 'Italien', image: 'https://flagcdn.com/w320/it.png' },
    { code: 'ja', name: 'Japonais', image: 'https://flagcdn.com/w320/jp.png' },
    { code: 'jw', name: 'Javanais', image: 'https://flagcdn.com/w320/id.png' },
    { code: 'km', name: 'Khmer', image: 'https://flagcdn.com/w320/kh.png' },
    { code: 'la', name: 'Latin', image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Latin_Empire_Flag.svg/800px-Latin_Empire_Flag.svg.png' }, // Pas de drapeau spécifique pour le Latin
    { code: 'lv', name: 'Letton', image: 'https://flagcdn.com/w320/lv.png' },
    { code: 'lt', name: 'Lituanien', image: 'https://flagcdn.com/w320/lt.png' },
    { code: 'ml', name: 'Malayalam', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'mr', name: 'Marathi', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'nl', name: 'Néerlandais', image: 'https://flagcdn.com/w320/nl.png' },
    { code: 'ne', name: 'Népalais', image: 'https://flagcdn.com/w320/np.png' },
    { code: 'no', name: 'Norvégien', image: 'https://flagcdn.com/w320/no.png' },
    { code: 'pl', name: 'Polonais', image: 'https://flagcdn.com/w320/pl.png' },
    { code: 'pt', name: 'Portugais', image: 'https://flagcdn.com/w320/pt.png' },
    { code: 'pa', name: 'Punjabi', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'ro', name: 'Roumain', image: 'https://flagcdn.com/w320/ro.png' },
    { code: 'ru', name: 'Russe', image: 'https://flagcdn.com/w320/ru.png' },
    { code: 'sr', name: 'Serbe', image: 'https://flagcdn.com/w320/rs.png' },
    { code: 'si', name: 'Sinhala', image: 'https://flagcdn.com/w320/lk.png' },
    { code: 'sk', name: 'Slovaque', image: 'https://flagcdn.com/w320/sk.png' },
    { code: 'sl', name: 'Slovène', image: 'https://flagcdn.com/w320/si.png' },
    { code: 'su', name: 'Sundanese', image: 'https://flagcdn.com/w320/id.png' },
    { code: 'sv', name: 'Suédois', image: 'https://flagcdn.com/w320/se.png' },
    { code: 'sw', name: 'Swahili', image: 'https://flagcdn.com/w320/ke.png' },
    { code: 'ta', name: 'Tamoul', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'cs', name: 'Tchèque', image: 'https://flagcdn.com/w320/cz.png' },
    { code: 'te', name: 'Télougou', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'th', name: 'Thaïlandais', image: 'https://flagcdn.com/w320/th.png' },
    { code: 'tr', name: 'Turc', image: 'https://flagcdn.com/w320/tr.png' },
    { code: 'uk', name: 'Ukrainien', image: 'https://flagcdn.com/w320/ua.png' },
    { code: 'ur', name: 'Urdu', image: 'https://flagcdn.com/w320/pk.png' },
    { code: 'vi', name: 'Vietnamien', image: 'https://flagcdn.com/w320/vn.png' },
    { code: 'wo', name: 'Wolof', image: 'https://flagcdn.com/w320/sn.png' },
    { code: 'xh', name: 'Xhosa', image: 'https://flagcdn.com/w320/za.png' },
    { code: 'yi', name: 'Yiddish', image: 'https://flagcdn.com/w320/il.png' },
    { code: 'zu', name: 'Zoulou', image: 'https://flagcdn.com/w320/za.png' }
  ];
  

  vibrantColors = [
    "#e7e0ff", // bleu très clair
    "#caf1ee", // vert très clair
    "#fff0d3", // orange clair
    "#fbd8dc", // rose clair  #fdc1c8
    "#d8fdd2", // violet clair
    "#f4ded1", // turquoise clair   fdc1c8
    "#d1e8ff", // mauve clair
    "#cbf2ef"
  ];

  colorMap: Record<string, string> = {
    '#e7e0ff': '#5d45de', // bleu → violet foncé
    '#caf1ee': '#008476', // vert → vert foncé
    '#fff0d3': '#9d6b2b', // orange → brun
    '#fbd8dc': '#cd0635', // rose → bordeaux
    '#d8fdd2': '#1c8555', // vert → vert foncé
    '#f4ded1': '#855436', // beige → marron
    '#d1e8ff': '#0060d3', // bleu → bleu foncé
    '#cbf2ef': '#008379'  // turquoise → turquoise foncé
  };
  selectedProjectType: string = 'face';
  showNoResultPopup = false;

  openNoResultPopup(): void {
    this.showNoResultPopup = true;
  }

  closeNoResultPopup(): void {
    this.showNoResultPopup = false;
  }


  private refreshPageObs = new Subject();
  private refreshSearchObs = new Subject();
  private refreshSearchObsIns = new Subject();
  public refreshPageObs$ = this.refreshPageObs.asObservable(); 
  public isReady:boolean = false;
  lang='fr';
  public curUser = null;


  public iDProjet: any;

  @Output() EventLaunchSearch = new EventEmitter();
  @Output() EventLaunchSearchDoc = new EventEmitter();
  @Output() transmittersLoaded = new EventEmitter<any[]>();
  @Output() recipientsLoaded = new EventEmitter<any[]>();
  @Output() copiesLoaded = new EventEmitter<any[]>();
  @Output() tagsLoaded = new EventEmitter<any[]>();
  @Output() typesLoaded = new EventEmitter<any[]>();
  
  @Output() sendersLoadedInstant = new EventEmitter<any[]>();
  @Output() typesLoadedInstant = new EventEmitter<any[]>();

  transmitter = null;
  recipient = null;
  copy = null;
  projectId = null;
  dateBefore = null;
  dateDeadline = null;
  dateDeadlineAfter = null;
  dateAfter = null;
  tag = null;
  statut = null;
  type = null;
  typemsg = null;
  typebloc = null;
  isGeneral = null;
  isThematic = null;
  keyWord = null;
  smartNumber = null;
  modeDoc = false;
  isSearch = false;
  sujectPlaceholder : any;
  optionselected : any;
  typeproject = "MESSAGES INSTANTANES";
  subscription: Subscription;
  relance_enabled: boolean = false;
  
  transmitterinstant: string;
  typeinstant: string;
  dateBeforeinstant: any;
  dateAfterinstant: any;
  keyWordinstant = "";
  //contacts: Array<any> = [];
  contactsExp: Array<any> = [];
  contactsDest: Array<any> = [];
  contactsCopy: Array<any> = [];
  //statusanswered = true;
  //statusnotanswered = true;
  projectLists: Array<any> = [];
  userData : any;
  chosenFilter: searchFilter;
  chosenFilterSearch: searchFilter;
  chosenFilterSearchIns: searchFilterInstant;
  chosenFilterInstant: searchFilterInstant;
  public recipientCtrl: FormControl = new FormControl();
  public copyCtrl: FormControl = new FormControl();
  public recipientSearch: FormControl = new FormControl();
  public copySearch: FormControl = new FormControl();
  public themeCtrl: FormControl = new FormControl();
  public transmitterCtrl: FormControl = new FormControl();
  public subjectCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  saveCtc = null;
  saveCopySearch = null;
  saveCtcTransmitter = null;
  saveRecipient = null;
  saveCopy = null;
  saveTheme = null;
  saveSubject = null;
  echeance = null;
  relance = null;
  private = true;
  //-start claude
  @ViewChild('fileInput', {static: false}) fileInput: ElementRef;
 
  selectedType: 'message' | 'tache' = 'message';
  currentStep = 1;
 
  form = {
    mission: '',
    destinataire: '',
    enCopie: '',
    dateReponse: '',
    contenu: ''
  };
 
  missions = [
    { id: '1', label: 'Mission principale' },
    { id: '2', label: 'Mission secondaire' },
    { id: '3', label: 'Projet Test' }
  ];
 
  destinataires = [
    { id: '1', label: 'Jean Dupont' },
    { id: '2', label: 'Marie Martin' },
    { id: '3', label: 'Pierre Bernard' }
  ];
 
  membres = [
    { id: '1', label: 'Alice Durand' },
    { id: '2', label: 'Bob Leroy' },
    { id: '3', label: 'Claire Moreau' }
  ];
  //-end claude
  selectprivate = false;
  selectcopies = false;
  selectteam = false;
  nbrcopies = 0;
  hideSelectCopy2 = true;
  relanceOne = null;
  relanceTwo = null;
  relanceOneDate = null;
  relanceTwoDate = null;
  firstLoad = true;
  socket_service_connection: Subscription;
  socket_service_disconnected: Subscription;
  socket_service_onMessage: Subscription;
  ioConnection: any;
  project_isparent = "PARENT";
  arraySubject = [];
  isUpdate : any;
  isAdmin = false;
  focus_text = true;
  allcopies = false;
  generalselected = false;
  selectedOptions: any[] = [];
  options = this.getUserListWithNoCurrentUser().map(item => item.user.id);
  selectedUsers: any[] = [];
  showselect: boolean = true;
  showsubject: boolean = true;
  libsubject = "";
  instant = null;
  totalnotif = 0;
  searchinstant = false;
  searchface = false;
  searchstep = "init";
  searchstepface = "init";
  searchsender = "Émetteur";
  searchsenderface = "Éxpéditeur";
  searchrecipientface = "Destinataire";
  searchcopyface = "Membre en Copie";
  searchthemeface = "Canal";
  searchtypeface = "Type de Document";
  searchtypemsgface = "Type d'échanges";
  searchtypebloc = "Type de bloc";
  searchdateface = "Face";
  searchstatusface = "Statut des faces";
  searchnumface = "Numéro du face";
  searchtype = "Type de Document";
  searchtypes = [];
  searchtypesblocs = [];
  searchtypesfilter = [
    {id: "pdf", nom: "Pdf", image: "search-pdf"},
    {id: "excel", nom: "Excel", image: "search-excel"},
    {id: "word", nom: "Word", image: "search-word"},
    {id: "presentation", nom: "Présentation", image: "search-presentation"},
    {id: "image", nom: "image", image: "search-image"},
    {id: "video", nom: "Vidéo", image: "search-video"},
    {id: "http", nom: "Lien", image: "search-lien"}
  ]
  searchtypesApi = [];
  searchtypesInsApi = [];
  searchtypesIns = [];
  searchtypesInsfilter = [
    {id: "pdf", nom: "Pdf", image: "search-pdf"},
    {id: "excel", nom: "Excel", image: "search-excel"},
    {id: "word", nom: "Word", image: "search-word"},
    {id: "presentation", nom: "Présentation", image: "search-presentation"},
    {id: "image", nom: "image", image: "search-image"},
    {id: "video", nom: "Vidéo", image: "search-video"},
    {id: "http", nom: "Lien", image: "search-lien"}
  ]
  filtersenderins = "alpha";
  filtersenderf = "alpha";
  filterrecipientf = "alpha";
  filtercopyf = "alpha";
  filtertagf = "date";
  searchSender = null;
  searchSenderF = null;
  searchRecipientF = null;
  searchCopyF = null;
  searchTagF = null;
  projectSenders = [];
  projectDocSenders = [];
  projectSendersInit = [];
  projectDocSendersInit = [];
  searchRecipientInit = [];
  searchCopyInit = [];
  searchSenderInit = [];
  searchTagInit = [];
  searchTags= [];
  drive = false;
  messages : any = [];
  searchItem = false;
  tooltipVisible = false;
  showTooltipMode = false;
  tooltipTimeout: any;
  showScroll: boolean = true;
  hideNav = Number(localStorage.getItem('hideNav'));
  notifNbr = 0;
  show_translate = true;
  translationenabed = true;
  isTaskMsg = null;
  statusMsg = null;
  isTaskMode = null;
  isTaskSearch = null;

  textmode = true;
  mediaRecorder: any; // Pour gérer l'enregistrement
  private audioChunks: any[] = [];  // Pour stocker les données audio enregistrées
  public isRecording: boolean = false;  // Pour savoir si l'enregistrement est en cours
  public isAudioProcessing: boolean = false;  // Pour savoir si l'enregistrement est en cours
  public waitingVocal: boolean = false;  // Pour savoir si l'enregistrement est en cours
  public audioUrl: string = '';
  public currentTime: number = 0;
  public playTime: number = 0; // Temps écoulé en secondes
  public playTimeSecondes: number = 0;
  public duration: number = 0; // Durée totale de l'enregistrement
  private timer: any; // Timer pour mettre à jour le temps écoulé
  private audio: HTMLAudioElement | null = null;
  private progressInterval: any;
  private countdownInterval: any;
  isPlaying: boolean = false;
  audioBlob: Blob | null = null;
  translatesuccess = null;
  translatenosuccess = null;
  name: string;
  profile: string;
  commonRef: string;
  isMenuOpen: boolean[] = [];
  @ViewChildren(MatMenuTrigger) matMenuTriggers: QueryList<MatMenuTrigger> | undefined;
  //modulesList: Array<any>;
  enteredButton = false;
  isMatMenuOpen = false;
  isMatMenu2Open = false;
  prevButtonTrigger;
  isExpanded = false;
  public typingDots: string = '';
  currentUserProject = null;
  userMessage: string = '';
  suggestions: string[] = [];
  previousMessages: string[] = [];
  private reinitalizeTimeout: any = null;
  selctedRecipient = null;
  selctedRecipientImg = null;
  selctedRecipientColor = null;
  hoveredOption: 'chat' | 'face' | null = null;

  cards: WelcomeCard[] = [
    {
      number: 1,
      title: 'Créer un plan de <br> collaboration',
      description: 'Organisez votre projet avant d\'échanger : créez vos canaux, assignez les responsables et planifiez les échéances.',
      icon: '../../../../assets/img/clipboard.png',
      badge: 'Recommandé',
      theme: 'green',
      tags: [
        { icon: 'target', label: 'Définir les canaux' },
        { icon: 'person', label: 'Assigner les responsables' },
        { icon: 'calendar', label: 'Planifier les échéances' },
        { icon: 'trending', label: 'Suivre l\'avancement' }
      ]
    },
    {
      number: 2,
      title: 'Écrire un <br> échange ciblé',
      description: 'Adressez un message structuré à une personne : créez un canal précis, choisissez le destinataire et échangez.',
      icon: '../../../../assets/img/super-canal.png',
      theme: 'green',
      tags: [
        { icon: 'tag', label: 'Créer un canal' },
        { icon: 'person', label: 'Destinataire unique' },
        { icon: 'users', label: 'Copie facultative' }
      ]
    },
    {
      number: 3,
      title: 'Écrire un <br> message collectif',
      description: 'Échangez avec tous les participants du projet en mode conversation.',
      icon: '../../../../assets/img/collectif-accueil.png',
      theme: 'blue',
      tags: [
        { icon: 'users', label: 'Visible par tous' },
        { icon: 'bolt', label: 'Réponses en temps réel' },
        { icon: 'paperclip', label: 'Pièces jointes' }
      ]
    }
  ];
  // état d'ouverture du menu principal
  showStatutMenu = false;
  emptyproject = false;

  // sous-menu actif : 'taches' | 'messages' | null
  activeSubMenu: string | null = null;

  selectedStatus: string = null;

  isOpen = false;

  select_options = [
    { label: 'Mode Travail', value: true, description: 'Travailler aujourd\'hui', subdescription: 'Le plus récent en premier', icon: '../../../../assets/img/tri-date.png' },
    { label: 'Mode Histoire', value: false, description: 'Comment on est arrivé là', subdescription: 'Le plus ancien en premier', icon: '../../../../assets/img/tri-livre.png' }
  ];
  selected = true;
  isMessage = false;
  isTache = false;
  isDocument = false;
  isAlltype = true;

  //start send msg
  @Output() fermer = new EventEmitter<void>();
  @Output() envoyer = new EventEmitter<any>();
  @ViewChild('editeur', { static: true }) editeur: ElementRef<HTMLDivElement>;

  canaux = ['Juridique', 'Finance', 'RH', 'Commercial'];
  visibilites = [
    { value: 'prive', label: 'En Privé', sub: 'Entre les participants', icon: 'lock' },
    { value: 'public', label: 'Public', sub: 'Visible par le canal', icon: 'globe' }
  ];
  contacts = ['Claude koné', 'Awa Traoré', 'Karim Ben Ali'];
 
  participants: Participant[] = [
    { id: 1, nom: 'Ghada. C', avatar: 'assets/img/default-avatar.png' },
    { id: 2, nom: 'Firas.M', avatar: 'assets/img/default-avatar.png' },
    { id: 3, nom: 'Paul. F', avatar: 'assets/img/default-avatar.png' }
  ];
 
  fichiers: File[] = [];
  survol = false;
  form2: FormGroup;
  @ViewChild('statutBtn', {static: false}) statutBtn?: ElementRef;
  @ViewChild('statutMenu', {static: false}) statutMenu?: ElementRef;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.showStatutMenu) return;

    const target = event.target as Node;
    const clickInsideBtn = this.statutBtn && this.statutBtn.nativeElement.contains(target);
    const clickInsideMenu = this.statutMenu && this.statutMenu.nativeElement.contains(target);

    if (!clickInsideBtn && !clickInsideMenu) {
      this.showStatutMenu = false;
    }
  }

  // Bonus : fermer avec la touche Échap
  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.showStatutMenu = false;
  }
 
  get visibiliteCourante() {
    return this.visibilites.find(v => v.value === this.form2.value.visibilite);
  }
 
  exec(cmd: string, event: any) {
    event.preventDefault();
    document.execCommand(cmd, false, null);
    this.maj();
  }
 
  maj() {
    const html = this.editeur.nativeElement.innerHTML;
    const vide = !this.editeur.nativeElement.innerText.trim();
    this.form2.patchValue({ message: vide ? '' : html });
  }
 
  retirer(p: Participant) {
    this.participants = this.participants.filter(x => x.id !== p.id);
  }
 
  ajouterParticipant() {
    // à brancher sur votre sélecteur / modale de participants
  }
 
  basculerEquipe() {
    this.form2.patchValue({ toutesEquipe: !this.form2.value.toutesEquipe });
  }
 
  onDrop(ev: DragEvent) {
    ev.preventDefault();
    this.survol = false;
    this.ajouterFichiers(ev.dataTransfer.files);
  }
 
  onDragOver(ev: DragEvent) {
    ev.preventDefault();
    this.survol = true;
  }
 
  retirerFichier(i: number) {
    this.fichiers.splice(i, 1);
  }
 
  soumettre() {
    if (this.form2.invalid) {
      this.form2.markAllAsTouched();
      return;
    }
    this.envoyer.emit({
      ...this.form2.value,
      participants: this.participants,
      fichiers: this.fichiers
    });
  }
  //end send msg

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(value: boolean) {
    this.selected = value;
    this.isOpen = false; // on referme après sélection
  }

  // ferme le menu si on clique en dehors
  closeDropdown() {
    this.isOpen = false;
  }

  toggleStatutMenu(): void {
    this.showStatutMenu = !this.showStatutMenu;
    if (!this.showStatutMenu) {
      this.activeSubMenu = null;
    }
  }

  openSubMenu(type: string, event: Event): void {
    //event.stopPropagation();
    this.activeSubMenu = this.activeSubMenu === type ? null : type;
  }

  chooseStatus(value: string): void {
    this.selectedStatus = value;
    this.showStatutMenu = false;
    this.activeSubMenu = null;
    // ici tu peux émettre un event vers le parent, appeler un canal, etc.
    console.log('Statut choisi :', value);
  }

  // ferme le menu si on clique en dehors
  closeAll(): void {
    console.log("cliqued")
    this.showStatutMenu = false;
    this.activeSubMenu = null;
  }

  openPlan(){
    //this.closeMsgBloc();
    this.fctMapSuject();
  }

  onCardClick(card: WelcomeCard): void {
    if(card.number == 1){
      if(this.divopened === true) this.closeMsgBloc();
      this.fctMapSuject();
    } else if(card.number == 2){
      this.closeMsgBloc();
    } else {
      this.changeDiscussionFormat(true);
      //this.closeMsgBloc(true);
    }
    // A brancher sur le routing / l'action associée à chaque carte
    console.log('Carte cliquée :', card.title);
  }
 
  onHelpClick(): void {
    this.authService.selectProject.emit("help");
    console.log('Ouverture de l\'aide');
  }

  testHover(val: string) {
    console.log('hover:', val);
  }
  
  constructor(
    private ren: Renderer2,
    private cdRef: ChangeDetectorRef,
    private translateService: TranslateService,
    private authService: AuthService,
    private projectState: ProjectStateService,
    private translationService: TranslationService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public  dialog: MatDialog,
    private messageService: MessageService,
    private coreService: CoreServiceService,
    private socketService: SocketService,
    private loadingScreenService: LoadingScreenService,
    private translate: TranslateService,
    private overlay: Overlay,
    private fb: FormBuilder,
    private renderer: Renderer2,
    protected _sanitizer: DomSanitizer,
    private aiService: AiService,
    private _lightbox: Lightbox) {
    
    this.userData = JSON.parse(localStorage.getItem('currentUser'))

    this.echeance = null;
    this.isTaskMsg = null;
    this.statusMsg = null;
    this.isMessage = false;
    this.isTache = false;
    this.isDocument = false;
    this.isAlltype = true;
    this.isTaskSearch = null;
    this.isMessage = false;
    this.dataSource = [];
    //this.divopened = true;
    this.form2 = this.fb.group({
      canal: ['Juridique', Validators.required],
      visibilite: ['prive', Validators.required],
      destinataire: ['Claude koné', Validators.required],
      toutesEquipe: [false],
      message: ['', Validators.required],
      tache: [false]
    });
    this.sendMessageForm = this.formBuilder.group({
      subProject: ['', Validators.required],
      newSubProject: '',
      //recipient: ['', Validators.required],
      recipient: '',
      //inCopy: [],
      inCopy: new FormControl([]),
      private: false,
      notify: "ALL",
      deadLine: null,
      general: null,
      thematic: null,
      relanceOne: null,
      relanceTwo: null,
      relanceTree: null,
      messageToSend: '',
      //messageToSend: ['', [Validators.required, Validators.minLength(1)]],
      files: [null, [requiredFileType(['png','jpeg','jpg','mov','mp4'])]]
    });

    this.sendMessageFormInstant = this.formBuilder.group({
      messageToSend: ['', [Validators.required, Validators.minLength(1)]],
      files: [null, [requiredFileType(['png','jpeg','jpg','mov','mp4'])]]
    });

    this.sendanswerForm = this.formBuilder.group({
      answerMessage: ['', [Validators.required, Validators.minLength(1)]],
      files: [null, [requiredFileType(['png','jpeg','jpg','mov','mp4'])]]
    });

    this.formComment = this.formBuilder.group({
      commentMessage: ['', [Validators.required, Validators.minLength(1)]],
      files: [null, [requiredFileType(['png','jpeg','jpg','mov','mp4'])]]
    });

    this.formCommentResponse = this.formBuilder.group({
      commentMessage: ['', [Validators.required, Validators.minLength(1)]],
      files: [null, [requiredFileType(['png','jpeg','jpg','mov','mp4'])]]
    });

    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    delete currentUser.token;
    delete currentUser.refresh_token;
    delete currentUser.roles;
    this.curUser = currentUser;

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id'];
    this.currentUserInfo = JSON.parse(localStorage.getItem('currentUser'));

  }

  suggestResponse(userMessage = null) {
    if(userMessage == null) return;
    this.aiService.getSuggestions(userMessage, this.previousMessages).subscribe((response) => {
      this.suggestions = response.choices.map((choice) => choice.message.content);
    });
  }

  menuenter() {
    this.isMatMenuOpen = true;
    if (this.isMatMenu2Open) {
      this.isMatMenu2Open = false;
    }
  }

  menuLeave(trigger, button) {
    setTimeout(() => {
      if (!this.isMatMenu2Open && !this.enteredButton) {
        this.isMatMenuOpen = false;
        trigger.closeMenu();
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
      } else {
        this.isMatMenuOpen = false;
      }
    }, 80)
  }

  menu2enter() {
    this.isMatMenu2Open = true;
  }

  menu2Leave(trigger1, trigger2, button) {
    setTimeout(() => {
      if (this.isMatMenu2Open) {
        trigger1.closeMenu();
        this.isMatMenuOpen = false;
        this.isMatMenu2Open = false;
        this.enteredButton = false;
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
      } else {
        this.isMatMenu2Open = false;
        trigger2.closeMenu();
      }
    }, 100)
  }

  onRelanceEnableChange(newValue: boolean) {
    this.relance_enabled = newValue;
  }

  buttonEnter(trigger) {
    setTimeout(() => {
      if(this.prevButtonTrigger && this.prevButtonTrigger != trigger){
        this.prevButtonTrigger.closeMenu();
        this.prevButtonTrigger = trigger;
        this.isMatMenuOpen = false;
        this.isMatMenu2Open = false;
        trigger.openMenu();
        this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-program-focused');
      }
      else if (!this.isMatMenuOpen) {
        this.enteredButton = true;
        this.prevButtonTrigger = trigger
        trigger.openMenu();
        this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(trigger.menu.items.first['_elementRef'].nativeElement, 'cdk-program-focused');
      }
      else {
        this.enteredButton = true;
        this.prevButtonTrigger = trigger
      }
    })
  }

  buttonLeave(trigger, button) {
    setTimeout(() => {
      if (this.enteredButton && !this.isMatMenuOpen) {
        trigger.closeMenu();
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
      } if (!this.isMatMenuOpen) {
        trigger.closeMenu();
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
      } else {
        this.enteredButton = false;
      }
    }, 300)
  }

  toggleComment() {
    this.isExpanded = !this.isExpanded;
  }

  openMenu(trigger: MatMenuTrigger) {
    trigger.openMenu(); // Ouvre le menu au survol
  }

  // Méthode pour fermer le menu
  closeMenu(trigger: MatMenuTrigger) {
    trigger.closeMenu(); // Ferme le menu lorsque la souris quitte
  }

  onMouseEnter(index: number): void {
    if (this.matMenuTriggers && this.matMenuTriggers.toArray()[index]) {
        this.matMenuTriggers.toArray()[index].openMenu(); // Ouvre le menu pour cet élément
      }
  }
  
  // Méthode pour fermer le menu lorsque le curseur quitte
  onMouseLeave(index: number): void {
    if (this.matMenuTriggers && this.matMenuTriggers.toArray()[index]) {
        this.matMenuTriggers.toArray()[index].closeMenu(); // Ferme le menu pour cet élément
      }
  }
  
  


  // Démarre l'enregistrement
  startRecording() {
    if(this.audio) this.deleteAudio();
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        const mimeType = 'audio/webm';
        this.mediaRecorder = new MediaRecorder(stream, { mimeType });

        this.audioChunks = [];
        this.currentTime = 0; // Réinitialiser le temps écoulé
        this.isRecording = true;
        this.isAudioProcessing = true;

        // Démarrer le compte à rebours
        this.startCountdown();

        // Démarrer la mise à jour de la barre de progression
        //this.startProgressUpdate();

        // Collecter les données audio pendant l'enregistrement
        this.mediaRecorder.ondataavailable = (event: any) => {
          this.audioChunks.push(event.data);
        };

        // Lorsque l'enregistrement est arrêté, créer un objet URL pour l'écouter
        this.mediaRecorder.onstop = () => {
          this.audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
          this.audioUrl = URL.createObjectURL(this.audioBlob);
          this.audioChunks = [];
          this.audio = new Audio(this.audioUrl); // Initialiser l'objet audio

          // Attendre que les métadonnées de l'audio soient chargées pour obtenir la durée
          this.audio.onloadedmetadata = () => {
            this.duration = Math.floor(this.audio.duration); // Définir la durée de l'audio enregistré
            this.isAudioProcessing = false;
              this.filesinstant = [];
              const audioFile = new File([this.audioBlob], 'audio_recording.mp3', {
                type: 'audio/mp3',
                lastModified: Date.now()
              });
              this.filesinstant.push(audioFile);
              this.cdRef.detectChanges();
              this.waitingVocal = false;
            //}
          };
          
        };

        this.mediaRecorder.start();
      })
      .catch((err) => {
        console.error('Erreur d\'accès au microphone : ', err);
      });
  }

  // Méthode pour convertir le fichier wav en mp3
convertWavToMp3(wavFile: File) {
  const reader = new FileReader();

  reader.onload = (e: any) => {
    const wavData = e.target.result;
    
    const wav = lamejs.WavHeader.readHeader(new DataView(wavData));
    const samples = new Int16Array(wavData, wav.dataOffset, wav.samples / 2);
    
    // Initialiser l'encodeur MP3 avec les paramètres nécessaires
    const mp3Encoder = new lamejs.Mp3Encoder(1, wav.sampleRate, 128); // 128 kbps
    const mp3Data = [];
    
    // Convertir les échantillons WAV en MP3
    const maxSamples = 1152; // Nombre maximum d'échantillons dans une tranche
    for (let i = 0; i < samples.length; i += maxSamples) {
      const sampleChunk = samples.subarray(i, i + maxSamples);
      const mp3buf = mp3Encoder.encodeBuffer(sampleChunk);
      mp3Data.push(mp3buf);
    }

    const mp3buf = mp3Encoder.flush(); // Finaliser le MP3
    mp3Data.push(mp3buf);

    // Créer un fichier blob pour le fichier MP3
    const mp3Blob = new Blob(mp3Data, { type: 'audio/mp3' });
    const mp3Url = URL.createObjectURL(mp3Blob);

    const mp3File = new File([mp3Blob], 'audio_recording.mp3', {
      type: 'audio/mp3',
      lastModified: Date.now()
    });

    // Ajouter le fichier MP3 aux fichiers joints
    this.filesinstant.push(mp3File);
    this.cdRef.detectChanges();  // Assurez-vous que les changements sont détectés dans Angular
  };

  reader.readAsArrayBuffer(wavFile);
}

  // Arrêter l'enregistrement
  stopRecording() {
    //this.mediaRecorder.stop();
    this.isRecording = false;
    this.waitingVocal = true;
    this.playTime = 0;
    this.stopCountdown(); 
    if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
      this.mediaRecorder.stop(); // Arrêter l'enregistrement
      
      
    }
  }

  // Démarre le compte à rebours de 30 secondes
  startCountdown() {
    if(this.isRecording && this.currentTime == 0){
      this.countdownInterval = setInterval(() => {
        if (this.currentTime < 300) {
          this.currentTime++;
          this.duration = this.currentTime;
        }
        if (this.currentTime >= 300) {
          // Arrêter l'enregistrement après 30 secondes
          this.stopRecording();
        }
      }, 100); // Mise à jour toutes les secondes
    }
  }

  // Arrête le compte à rebours
  stopCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  // Supprimer l'audio
  deleteAudio() {
    this.audioUrl = '';
    this.audio = null;
    this.duration = null;
    this.currentTime = 0;
    this.isPlaying = false;
    this.isAudioProcessing = false;
    this.playTime = 0;
    this.isRecording = false;
    this.stopCountdown();
    this.textmode = true;
    this.audioBlob = null;
    this.filesinstant = [];
    this.waitingVocal = false;
    //this.stopProgressUpdate(); // Arrêter la mise à jour de la barre de progression si audio supprimé
  }

  changeTextMode(){
    this.waitingVocal = false;
    this.textmode = !(this.textmode);
    if(!this.textmode) {
      this.filesinstant = [];
      this.startRecording();
    } else {
      if(this.isPlaying && this.playTime < this.currentTime) this.togglePlayPause();
      this.deleteAudio();
    }
  }

  // Met à jour la barre de progression à chaque changement de temps
  updateProgress() {
  }

  // Démarre l'intervalle pour mettre à jour la barre de progression pendant la lecture
  startProgressUpdate() {
    this.progressInterval = setInterval(() => {
      this.updateProgress();
    }, 100); // Mettre à jour toutes les 100 ms
  }

  // Arrête l'intervalle de mise à jour de la barre de progression
  stopProgressUpdate() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
  }

  togglePlayPause() {
    if (this.isPlaying) {
      this.audio.pause();  // Mettre en pause la lecture
    } else {
      this.audio.play();  // Commencer à lire
    }

    // Mettez à jour l'état de lecture
    this.isPlaying = !this.isPlaying;

    // Lorsque l'audio est joué, mettez à jour la barre de progression
    this.audio.ontimeupdate = () => {
      //this.playTime = Math.floor(this.audio.currentTime);  // Temps actuel de l'audio
      this.updateProgressBar();
    };
  }

  // Mise à jour de la barre de progression en continu pendant la lecture
  updateProgressBar() {
    if (this.audio && !this.audio.paused && !this.audio.ended) {
      this.playTime = this.audio.currentTime;
      this.cdRef.detectChanges();
      requestAnimationFrame(() => this.updateProgressBar()); // Appel récursif pour continuer à mettre à jour
    }
  }

  formatTime(seconds: number): string {
    const roundedSeconds = Math.floor(seconds);
    const minutes = Math.floor(roundedSeconds / 60);  // Calcul des minutes
    const remainingSeconds = roundedSeconds % 60;     // Calcul des secondes restantes
  
    // Formater en ajoutant un zéro devant si nécessaire (par exemple 5 devient 05)
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : `${remainingSeconds}`;
  
    return `${formattedMinutes}:${formattedSeconds}`;
  }

  formatTimeCurrent(seconds: number): string {
    const roundedSeconds = Math.floor(seconds/10);
    const minutes = Math.floor(roundedSeconds / 60);  // Calcul des minutes
    const remainingSeconds = roundedSeconds % 60;     // Calcul des secondes restantes
  
    // Formater en ajoutant un zéro devant si nécessaire (par exemple 5 devient 05)
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : `${remainingSeconds}`;
  
    return `${formattedMinutes}:${formattedSeconds}`;
  }
  
  getInitials(libelle: string): string {
      const words = libelle.split(' ');
      //return "rrr";
      const getFirstChar = (word: string): string => {
        return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
      };
      const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point
      return initials;
  }
  

  // Fonction pour passer au résultat suivant
  nextResult() {
    if (this.currentIndex < this.searchResults.length - 1) {
      this.currentIndex++;
      var messageId = this.searchResults[this.currentIndex]['id'];
      this.scrollToMessage(messageId);
    }
  }

  getProjectUsersOrdered(){
    this.projectSendersInit = this.projectSenders;
  }

  onSearchSender() {
    if (this.searchSender.trim() === '' || this.searchSender == null) {
      this.searchSender = null;
      this.projectSendersInit = this.projectSenders;
      this.filterSenders(this.filtersenderins);
    } else {
      var search = this.searchSender.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.projectSendersInit = this.projectSenders.filter(bank => bank.fullName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  onSearchSenderF() {
    if (this.searchSenderF.trim() === '' || this.searchSenderF == null) {
      this.searchSenderF = null;
      this.searchSenderInit = this.contactsExp;
      this.filterSendersF(this.filtersenderf);
    } else {
      var search = this.searchSenderF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchSenderInit = this.contactsExp.filter(bank => bank.fullName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  onSearchRecipientF() {
    if (this.searchRecipientF.trim() === '' || this.searchRecipientF == null) {
      this.searchRecipientF = null;
      this.searchRecipientInit = this.contactsDest;
      this.filterRecipientF(this.filterrecipientf);
    } else {
      var search = this.searchRecipientF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchRecipientInit = this.contactsDest.filter(bank => bank.fullName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  onSearchCopyF() {
    if (this.searchCopyF.trim() === '' || this.searchCopyF == null) {
      this.searchCopyF = null;
      this.searchCopyInit = this.contactsCopy;
      this.filterCopyF(this.filtercopyf);
    } else {
      var search = this.searchCopyF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchCopyInit = this.contactsCopy.filter(bank => bank.fullName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  onSearchTagF() {
    if (this.searchTagF.trim() === '' || this.searchTagF == null) {
      this.searchTagF = null;
      this.searchTagInit = this.searchTags;
      this.filterTagF(this.filtertagf);
    } else {
      var search = this.searchTagF.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchTagInit = this.searchTags.filter(bank => bank.libelle.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1);
    }
  }

  filterSenders(val : any){
    this.filtersenderins = val;
    if(val == "date"){
        this.projectSendersInit.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.projectSendersInit.sort((a, b) => {
        if ( a.fullName.toLowerCase() < b.fullName.toLowerCase() ){
          return -1;
        }
        if ( a.fullName.toLowerCase() > b.fullName.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }
 
  filterSendersF(val : any){
    this.filtersenderf = val;
    if(val == "date"){
        this.searchSenderInit.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.searchSenderInit.sort((a, b) => {
        if ( a.fullName.toLowerCase() < b.fullName.toLowerCase() ){
          return -1;
        }
        if ( a.fullName.toLowerCase() > b.fullName.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  filterRecipientF(val : any){
    this.filterrecipientf = val;
    if(val == "date"){
        this.searchRecipientInit.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.searchRecipientInit.sort((a, b) => {
        if ( a.fullName.toLowerCase() < b.fullName.toLowerCase() ){
          return -1;
        }
        if ( a.fullName.toLowerCase() > b.fullName.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  filterCopyF(val : any){
    this.filtercopyf = val;
    if(val == "date"){
        this.searchCopyInit.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.searchCopyInit.sort((a, b) => {
        if ( a.fullName.toLowerCase() < b.fullName.toLowerCase() ){
          return -1;
        }
        if ( a.fullName.toLowerCase() > b.fullName.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  filterTagF(val : any){
    this.filtertagf = val;
    if(val == "date"){
        this.searchTagInit.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.searchTagInit.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  toggleDiv(index: number): void {
    if (this.visibleDivIndex === index) {
      // Si le div est déjà visible, le masquer
      this.visibleDivIndex = null;
    } else {
      // Sinon, afficher le div
      this.visibleDivIndex = index;
    }
  }

  openProfileDialog(){
    const dialogRef = this.dialog.open(ProfileupdDialog, {
      panelClass: 'transferclass',
      backdropClass: 'custom-backdrop',
      height: "height: calc(-80px + 100vh);",
      data:{idProjet: this.ID, libelle : this.projectFull.libelle, img : this.projectFull.imageUrl}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        //TO Do dialog ajout membre 
        //this.fctAddMember();
        (<HTMLInputElement>document.getElementById('project_'+this.ID)).innerHTML = result.libelle;
        if(result.libelle != this.projectFull.libelle){
          /*this.socketService.sendInstant({
            id: "",
            action: this.ID, // ID du projet
            type: "RENAMEPROJECT",
            author: this.currentUser, // peu importe 
            recipient: this.ongletId, // peu importe 
            text: "",
            copy: "",
            private: false,
            res: result.libelle, // le nouveau nom
            date: ""
          });*/
        }
        if (result.imagechanged) {
          const imageElement = document.getElementById('project_' + this.ID + '_images') as HTMLImageElement;
          if(imageElement) imageElement.src = this.getAvatarlUrl(result.imageUrl);
        }
          this.messageService.setLibelleProject(result.libelle);
          this.projectFull = result;
          this.projectLists.forEach((value,index)=>{
            if(value.id==this.ID) this.projectLists[index].libelle = result.libelle;
          });
      } 
    });
  }

  openPackComponentDialog(type = 0, currentPack = 'free'){
    const dialogRef = this.dialog.open(PackComponent, {
      panelClass: 'packclass',
      backdropClass: 'custom-backdrop-pack',
      height: "height: calc(-80px + 100vh);",
      data: { type: type, currentPack: currentPack}
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openPaymentDialog(){
    const dialogRef = this.dialog.open(PaymentComponent, {
      panelClass: 'transferclass',
      backdropClass: 'custom-backdrop',
      height: "height: calc(-80px + 100vh);"
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onDeleteMsg(msgId){
      const dialogRef = this.dialog.open(ConfirmdialogComponent, {
        data: { 
          message: 'Vous voulez vraiment suppprimer le message ',
          title: 'Confirmation'
        },
        panelClass: 'confirmclass',
        backdropClass: 'custom-backdrop'
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.authService.archiveMessageInstant(msgId).subscribe((res) => {
            for (var i = 0; i < this.messagesInstant.length; i++) {
              if(msgId ===  this.messagesInstant[i]['id']){
                this.messagesInstant[i].isArchived = true;
                //this.messagesInstant.splice(i, 1); 
              }
            }
          });
        } else {
          //console.log('L\'utilisateur a annulé la suppression');
        }
      });
  }

  onDeleteMsgByfake(msgId){
    for (var i = this.messagesInstant.length - 1; i >= 0 ; i--) {
        if(msgId ===  this.messagesInstant[i]['fakeId']){
          this.messagesInstant.splice(i, 1); 
          break;
        }
    }
  }

  redirectToAnswer(message: any){
    var id = message.parentItem.id;
    if(message.indexdoc){
      id = message.parentItem.filegeneric[message.indexdoc].id;
    }
    // message_ddef970e-07f9-4ca9-8835-8c9bc0e439d7
    var targetMessage = document.getElementById("message_"+id);
    //var targetMessage = document.getElementById(id);

    if (targetMessage) {
        // Trouver la div scrollable (qui contient les messages)
        var scrollContainer = document.getElementById('scrollMechat');
        var targetDiv = targetMessage.querySelector('.forresponse');

        if (scrollContainer) {
            // Faire défiler la div scrollable jusqu'au message
            targetMessage.scrollIntoView({
                behavior: 'smooth',   // Défilement fluide
                block: 'center'       // Centrer l'élément
            });
            if (targetDiv) {
              targetDiv.classList.add('highlight');

                // Retirer la classe après 2 secondes
                setTimeout(() => {
                    targetDiv.classList.remove('highlight');
                }, 2000); 
              }
        } else {
            console.error("La div contenant les messages (scrollMechat) n'a pas été trouvée.");
        }
    } else {
        console.error("Le message avec l'ID " + id + " n'a pas été trouvé.");
    }
  }

  scrollToUnread() {
    const diff = this.readmsgdiv.nativeElement.parentElement.offsetTop;
    setTimeout(() => {
      this.scrollMechat.nativeElement.scrollTop = diff;
    }, 200);

    // Scroll to the top of the unread indicator
    //messageContainer.scrollTop = unreadIndicator.offsetTop;
    //this.scrollMechat.nativeElement.scrollTop = this.scrollMechat.nativeElement.scrollHeight - this.readmsgdiv.nativeElement.scrollHeight;
    //this.scrollMechat.nativeElement.scrollTop = 200;
  }

  onDeleteFile(msgId, docId){
    this.authService.deleteFileInstant(msgId, docId).subscribe((res) => {
      if(res){
        for (var i = 0; i < this.messagesInstant.length; i++) {
          if(msgId ===  this.messagesInstant[i]['id'])
            this.messagesInstant[i] = res; 
        }
      }
    });
  }

  updDialog(): void{
    this.updclicked = !this.updclicked;
  }

  deleteTag(sub){
      const dialogRef = this.dialog.open(ConfirmdialogComponent, {
        data: { 
          message: 'Voulez vraiment suppprimer le canal '+sub.libelle,
          title: 'Confirmation'
        },
        panelClass: 'confirmclass',
        backdropClass: 'custom-backdrop'
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.authService.deleteTag(sub.id).then((res)=>{
            const index = this.projectTags.findIndex(item => item.id === sub.id);
                if (index !== -1) {
                  const elementAaa = this.projectTags.splice(index, 1)[0];
                }
          }).catch(err=>console.log(err))
        } else {
        }
      });
  }

  showUpdateTag(sub, i){
    this.projectTags.find(item => item.id === sub.id).updated = true;
    this.updateSubject = sub.libelle;
    this.deadlineSubject = sub.deadLine;
  }

  userIsAdmin(){
    if (this.projectFull && this.projectFull.creator.id == this.currentUser) {
        return 'admin';
    } else if(this.projectFull){
    var member = this.projectFull['userProject'];
      for (var i = 0; i < member.length; i++) {
        if(member[i].user && member[i].user.id == this.currentUser && member[i].isAdmin == true){
          return 'co-admin';
        }
      }
    }
    return 'membre';
  }


    onDateSelected(event: any): void {
    const selectedDate = event.value; // ✅ utiliser event.value, pas event.target.value

    if (selectedDate) {
      // Format avec moment
      this.echeance = moment(selectedDate).format('DD-MM-YYYY').toLocaleString();
      this.relance = moment(selectedDate).subtract(1, 'days').format('DD-MM-YYYY');

      // Mettre à jour la valeur dans ton form
      this.sendMessageForm.get('deadLine').setValue(selectedDate);

      // Calcul du lendemain pour la relance
      const nextDay = new Date(selectedDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.minDateRelance = nextDay;
    }
  }


  onRelanceSelected(event: any): void {
    const selectedDate = event.target.value;
    if(selectedDate){
      this.relanceOneDate = moment(selectedDate).format('DD-MM-YYYY').toLocaleString( );
    }
    this.sendMessageForm.get('relanceOne').setValue(selectedDate); 
  }

  transferDocs(transfermsg, iddoc, typeDialog){
    this.dialog.closeAll();
    if (this.showTool == true) {
      this.showTool = false;
      this.messageService.setShowNotifTuto(false);
    }
  }
  goToDashboard(){
    this.router.navigate(['/dashboard'], { queryParams: { projet: this.ID } });
  }

  goToDashboardInstant(){
    this.router.navigate(['/dashboardinst'], { queryParams: { projet: this.ID } });
  }

  transferMessage(transfermsg, idmsg, typeDialog, iddoc = null){
    this.dialog.closeAll();
    if (this.showTool == true) {
      this.showTool = false;
      this.messageService.setShowNotifTuto(false);
    }

    const dialogRef = this.dialog.open(TransferComponent, {
      //width: '350px',
      data: { projectUsers: this.projectUsers, projectTags: this.projectTags, idprojet: this.ID, project: this.project, transfermsg: transfermsg, idmsg: idmsg, typeDialog: typeDialog, iddoc },
      panelClass: 'transferclass',
      backdropClass: 'custom-backdrop'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.id == this.ID)
      {
        if(result.type == "instant"){
          this.messagesInstant.push(result.res);
          if (!this.messagesInstant.some(msg => msg.id === result.res["id"])) {
            this.messagesInstant.push(result.res);
          }
          setTimeout(() => {
            this.scrollToBottom();
          }, 300);
        } else {
          this.total +=1 ;
          this.changeDiscussionFormat();
        }
      } else if(result && result.id){
        if(result.type == "face"){
          this.router.navigate(['/project/'+result.id]);
        } else {
          this.router.navigate(['/project/'+result.id+'/openmsg']);
        }
      }
    });
    
  }

  scrollToProject() {
    //this.checkproject.nativeElement.scrollIntoView({block: "center"});
  }

  scrollToTop() {
    if (this.messageBloc) {
      this.messageBloc.nativeElement.scrollIntoView({ block: "start" });
    } else {
      console.error('messageBloc is not defined');
    }
      /*const element = document.querySelector('.messageBloc');
        if (element) {
          console.log("Element found using querySelector", element);
          (element as HTMLElement).scrollTop = 0;
        } else {
          console.error('Element is not found');
        }*/
  }

  scrollToBottomtChat() {
    this.cdRef.detectChanges();
    const container = this.scrollMechat.nativeElement;
    container.scrollTop = container.scrollHeight;
    this.isAtBottom = true;
    this.cdRef.detectChanges();
    this.reinitalizeInstantNotif();
    //}
  }

  scrollToBottomtChatSearch() {
    this.cdRef.detectChanges();
    const container = this.scrollResultchat.nativeElement;
    container.scrollTop = container.scrollHeight;
    this.isAtBottomResult = true;
    this.cdRef.detectChanges();
    //this.reinitalizeInstantNotif();
    //}
  }

  scrollToBottomtChat2() {
    //console.log("scroll down down")
    this.cdRef.detectChanges();
    setTimeout(() => {
      const container = this.scrollMechat.nativeElement;
    container.scrollTop = container.scrollHeight;
    this.isAtBottom = true;
    }, 500);
  }

  scrollToBottomtChatMsg() {
    console.log("scroll down 0 : "+document.getElementById('scrollMechat').scrollHeight);
    const chatContainer = document.getElementById('scrollMechat');  // Assure-toi que c'est le bon ID ou classe
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;  // Scrolle jusqu'en bas
      //console.log("scroll down 2 : "+document.getElementById('scrollMechat').scrollHeight);
    }
  }

  ngAfterViewChecked(): void {
    if(this.scrollMechat){
      const scrollElement = this.scrollMechat.nativeElement;
      const scrollPosition = scrollElement.scrollTop;
      const maxScroll = scrollElement.scrollHeight - scrollElement.clientHeight;
      this.isAtBottom = (scrollPosition === maxScroll);
    }
  }

  // Fonction pour passer au résultat précédent
  previousResult() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      var messageId = this.searchResults[this.currentIndex]['id'];
      this.scrollToMessage(messageId);
    }
  }

  scrollToMessage(messageId: number) {
    const element = document.getElementById('message_'+messageId);
    const elementbody = document.getElementById('body_'+messageId);
    this.renderer.addClass(elementbody, 'active');
    setTimeout(() => {
      this.renderer.removeClass(elementbody, 'active');
    }, 1000);
    if (element) {
      element.classList.add('smooth-scroll');
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      element.scrollTop -= 60;
      element.classList.remove('smooth-scroll'); // Retirez la classe après l'animation
    }
  }

  replaceAllCaseInsensitive(text: string, keyword: string): string {
    const regex = new RegExp(`(${keyword})`, 'gi');
  // Remplacer les mots-clés par du texte avec un fond jaune
  return text.replace(regex, (match) => {
    return `<span style="background-color: yellow" class="recherchee">${match}</span>`;
  });
  }

  clearAllCaseInsensitive(message: string, searchTerm: string): string {
    const regex = new RegExp(searchTerm, 'gi'); // 'g' pour global (toutes les occurrences), 'i' pour insensible à la casse
    return message.replace(regex, searchTerm);
  }

  get currentResult(): Message | null {
    const currentId = this.searchResults[this.currentIndex];
    return this.messages.find(message => message.id === currentId) || null;
  }

  showTooltip() {
    this.tooltipVisible = true;
    console.log("visible : "+this.tooltipVisible)
  }

  hideTooltip() {
    this.tooltipVisible = false;
  }

  hideTooltipMode() {
    clearTimeout(this.tooltipTimeout);
    this.showTooltipMode = false;
  }

  showTooltipWithDelay() {
    console.log("enter enter");
    this.tooltipTimeout = setTimeout(() => {
      console.log("enter enter 1");
      this.showTooltipMode = true;
      console.log("enter "+this.showTooltipMode)
      this.cdRef.detectChanges();
    }, 500);
  }

  closeSearch() {
    // Logique pour fermer le composant de recherche
    // Par exemple, réinitialiser les résultats et le champ de recherche
    //this.searchResults = [];
    this.searchItem = false;
    this.currentIndex = 0;
    this.scrollToBottom();
    // Autres actions pour fermer le composant
  }


  selectAllOptions() {
    this.selectedOptions = this.options.map(option => option.id);
  }

  openModal(libelle){
    
  }


  private getNombreObjets(control: AbstractControl): number {
    if (control instanceof FormGroup) {
      return Object.keys(control.controls).length;
    } else if (control instanceof FormArray) {
      return control.controls.length;
    }
    return 0;
  }

  resetforminstant(){
    const textarea = document.getElementById('tchat-text') as HTMLTextAreaElement;
      this.sendMessageFormInstant.get('messageToSend').setValue('');
      this.sendMessageFormInstant.get('files').setValue(null);
      this.sendMessageFormInstant.get('files').setValidators([requiredFileType(['png','jpeg','jpg','mov','mp4'])]); 
      this.sendMessageFormInstant.get('files').updateValueAndValidity();
      this.filesinstant = [];
    if (textarea) {
      textarea.value = '';
    }
  }

  changeDiscussionFormat(instant = null){
    this.msgsent = false;
    this.menuOuvert = false;
    if(instant != null && this.instant === instant) {
      if(this.instant == true && instant == true) {
        return;
      } else if((!this.instant && !this.modeDoc && !this.divopened && (this.dataSource.length > 0) && (this.specMsg || this.chosenFilter || this.authService.isNotified || this.authService.isAnsweredNotified))){
        //this.loadAllMessage();
        this.resetSearch();
        return;
      }
    }
    if(this.instant == false){
      this.scrollToTop();
      this.writeMode = -1;
      this.divopened = false;
      this.instant = !(this.instant);
    } else this.instant = !(this.instant);
    this.projectState.setInstantMode(this.instant);
    this.searchinstant = false;
    this.drive = false;
    this.modeDoc = false;
    this.hiddenSearchEngin = true;
    if(this.instant == true){
      this.authService.setMode('collaboratif');
      this.messagesInstant = [];
      this.typeproject = "MESSAGES INSTANTANES";
      this.authService.obreceiveType.next(this.ID);
      this.EventLaunchSearch.emit(this.chosenFilter);
      this.perPage = 30;
      this.startedPoint = false;
      this.pageIndex = 0;
      this.limitmsg = 20;
      this.nbrloadmsg = 0;
      this.offsetmsg = 0;
      this.canload = false;
      this.getMessagesInstant();
      this.CountMessagesInstant(0);
      this.loadSendersIns();
      this.authService.onScrollTop.next("1");
      localStorage.setItem('notified', "all");
      this.authService.initNotifInstant.next(this.ID);
      this.socketService.sendInstant({
        id: '',
        action: this.ID,
        type: "READMSG",
        author: this.currentUser,
        author_name: '',
        recipient: '',
        text: '',
        copy: "",
        private: false,
        res: '',
        project_lib: '',
        date: ''
      });
    } else {
      this.authService.setMode('cooperatif');
      this.notifiedmode = false;
      localStorage.setItem('notified', "all");
      this.resetforminstant();
      this.resetSearch();
      this.resetAllmsgbloc();
      this.selectedOptiontag = "";
      this.notificationsCount = 0;
      this.typeproject = "MESSAGES ORGANISES";
      
      this.getUserSubjects();

      this.showFileSelector();
      if(this.firstConnection !== 'true'){
        this.firstConnection = 'true';
        localStorage.setItem('firstConnection', 'true');
        this.authService.setUserFirstConnection();
      }
      this.showRedBar = false;
      //this.launchSearch();
      this.chosenFilterProject = null;
      this.authService.onScrollTop.emit("1");
      //if(!instant && !modeDoc && !divopened && (dataSource.length > 0) && (specMsg || chosenFilter || authService.isNotified || authService.isAnsweredNotified))
    }
  }

  updateNewProjectNotifications(id) {
    var total = 0;
    const observables = [
      this.authService.getAllProjectNotification(0, 1, 10, id)
    ]
    return forkJoin(observables).pipe(
      map((responses: any[]) => { // Définir le type explicite ici
        let total = 0;
        responses.forEach((res) => {
          total += res['hydra:member']['all'];
        });
        return total;
    }));

  }


  openDialogProjectNotif(){
    this.dialog.closeAll();
    if (this.showTool == true) {
      this.showTool = false;
      this.messageService.setShowNotifTuto(false);
    }

    const dialogRef = this.dialog.open(DashboardDialogProjectNotif, {
      width: '1400px',
      data: { sentNotifCount: this.sentNotifProjectCount, receiveNotifCount: this.receiveNotifProjectCount, copyNotifCount: this.copyNotifProjectCount, commentNotifCount: this.commentNotifProjectCount, idprojet: this.ID }
    });

    dialogRef.afterClosed().subscribe(result => {
       //console.log({result:result});
      if (result)
      {
        if (result.type == 'COMMENT')
        {
          this.router.navigate(['/project/details/' + result.id + '/' + result.number + '/' + result.type]);
        }
        else
        {
          this.router.navigate(['project/details/' + result.id + '/' + result.consult + '/' + result.type]);
        }
      }
    });
    
  }

  changeDriveFormat(){
    this.drive = true;
    this.searchinstant = false;
    this.modeDoc = true;
    this.instant = true;
    
    //this.hiddenSearchEngin = true;
    this.modeDoc = true;

    this.chosenFilter = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      copy: this.copy,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateAfter: this.dateAfter,
      dateDeadline: this.dateDeadline,
      dateDeadlineAfter: this.dateDeadlineAfter,
      tag: this.tag,
      statut: this.statut,
      type: this.type, 
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber, 
      drive: this.drive
    };
    //console.log(' launchSearchDoc '+ JSON.stringify(this.chosenFilter) );
    this.EventLaunchSearchDoc.emit(this.chosenFilter);
  }

  verifAll(){

    if (this.arrayUserCopy.length === this.sendMessageForm.get("inCopy").value.filter(item => item != "0").length) {
      this.showselect = false;
      //this.selectSubject.open();
    }
    this.selectCopies.close();
    setTimeout(() => {
        this.selectSubject.open();
    }, 2);
    
    //console.log("shoen "+this.showselect);
  }

  toggleAll(){
    this.projectUsers.forEach(element => {
      if(this.currentUser != element.user.id){
        this.tempMember.push(element);
        this.copiesusers.push(element.user);
        //console.log("us "+element.user.fullName);
      }
    });
  }

  toggleAllSelection() {
    //console.log("length array before "+this.arrayUserCopy.length);
    //console.log("length selected before"+this.sendMessageForm.get("inCopy").value.filter(item => item !== "0").length);
    //if (this.arrayUserCopy.length === this.sendMessageForm.get("inCopy").length) {
      if (this.arrayUserCopy.length === this.sendMessageForm.get("inCopy").value.filter(item => item != "0").length) {
        this.allSelect = false;
        this.sendMessageForm.controls.inCopy.patchValue([]);
      } else {
        this.allSelect = true;
        this.sendMessageForm.controls.inCopy.patchValue([...this.getUserListWithNoCurrentUser().map(item => item.user.id)]);
      }
  }

  toggleAllSelectionNew(matSelect: MatSelect) {
    const isSelected: boolean = matSelect.options
      // The "Select All" item has the value 0
      .filter((item: MatOption) => item.value === 0)
      // Get the selected property (this tells us whether Select All is selected or not)
      .map((item: MatOption) => item.selected)[0];
    // Get the first element (there should only be 1 option with the value 0 in the select)

    if (isSelected) {
      matSelect.options.forEach((item: MatOption) => item.select());
      const allUserIds = this.getUserListWithNoCurrentUser().map(item => item.user.id);
      allUserIds.push(0);
      //this.sendMessageForm.controls.inCopy.patchValue(allUserIds);
      //this.allSelect = true;
      //this.sendMessageForm.controls.inCopy.patchValue([...this.getUserListWithNoCurrentUser().map(item => item.user.id)]);
    } else {
      matSelect.options.forEach((item: MatOption) => item.deselect());
      //this.allSelect = false;
        //this.sendMessageForm.controls.inCopy.patchValue([]);
    }
  }

  validateSelection(){
    this.sendMessageForm.controls.inCopy.patchValue([...this.temporarySelectedValues]);
    this.copiesusers = [];
    this.copyvalidate = true;
    for (let indexCopy = 0; indexCopy < this.sendMessageForm.value.inCopy.length; indexCopy++) {
        for (let j = 0; j < this.arrayUserCopy.length; j++) {
          if(this.arrayUserCopy[j].user.id ==  this.sendMessageForm.value.inCopy[indexCopy]){
          this.copiesusers.push(this.arrayUserCopy[j].user);
        }
        }
    }
  }

  changeCopies(event: any) {
    this.temporarySelectedValues = event.value.filter(item => (item != 0 && item != undefined));
  }

  getIndexByLibelle(libelle){
    //alert("okkk");
    const index = this.projectTags.findIndex(element => element.libelle === libelle);
    //console.log("index "+index);
    return index+1;
  }

  deletecopy(user, matSelect: MatSelect){
    const index = this.sendMessageForm.value.inCopy.indexOf(user.id);
    if (index !== -1) {
      this.sendMessageForm.value.inCopy.splice(index, 1);
      //alert(JSON.stringify(this.sendMessageForm.value.inCopy))
    }
    const index2 = this.tempMemberUser.indexOf(user);
    if (index2 !== -1) {
      this.tempMemberUser.splice(index, 1);
    }
  }
  
  changeRecipient(){
      this.generalselected = false;
    this.private = false;
    this.sendMessageForm.controls.inCopy.patchValue([]);
    this.copiesusers = [];
    this.allSelect = false;
    this.getUserListWithNoCurrentUser();
  }


  openSelect(){
    this.showselect = true;

    setTimeout(() => {
      this.selectCopies.open();
  }, 0.5);
    
  }

  resetMsgForm(){
    this.sendanswerForm.get('files').clearValidators();
    this.sendanswerForm.get('files').updateValueAndValidity();
    this.relance_enabled = false;
    this.files = [];
    const elementtous: HTMLElement = document.getElementById('divtous') as HTMLElement
    elementtous.innerHTML = '';
    this.copiesusers = [];
    this.sendMessageForm.controls.inCopy.patchValue([]);
    this.sendMessageForm.reset();
  }

  converterDate(datestring){
    return datestring.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
  }

  onSelectClosed(){
    this.addmissionclicked =0;
    //this.updclicked = false;
    if(this.sendMessageForm.value.subProject.libelle){
      this.showsubject = false;
      setTimeout(() => {
        const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
        libsubjectvalue.innerHTML = this.sendMessageForm.value.subProject.libelle;
      }, 0.5);
    }
  }

  changeChronoMode(){
    this.selected = !this.selected;
    this.isOpen = false;
    this.chrono_mode = !this.chrono_mode;
    this.messageService.messageRefreshConv()
    //this.EventLaunchSearch.emit(this.chosenFilter);
  }

  closeMsgBloc(collectif = null){
    this.selectedOptiontag = "";
    this.resetQuestionFrom();
    this.scrollToTop();
    this.divopened = !this.divopened;
    this.hiddenSearchEngin = true;
    this.private = false;
    if(this.modeDoc && this.divopened){
      this.resetSearch();
    }
    if(this.divopened === true){
      this.showScroll = false;
      this.scrollToProject();
      if(this.projectFull.isPrivate){
        var otheruser = null;
        otheruser = this.projectUsers.find(userProject => {
          return userProject.user && userProject.user.id != this.currentUser;
        });
        if(otheruser){
          this.sendMessageForm.patchValue({
            recipient: otheruser.user.id
          });
          setTimeout(() => {
            if(otheruser.user.familyName) otheruser.user.givenName = otheruser.user.givenName +" "+otheruser.user.familyName;
            this.selctedRecipient = otheruser.user.givenName;
            this.selctedRecipientImg = otheruser.user.imageUrl;
            this.selctedRecipientColor = otheruser.user.color;
            const librecipientvalue: HTMLElement = document.getElementById('librecipientvalue') as HTMLElement
            librecipientvalue.innerHTML = otheruser.user.givenName +" "+otheruser.user.familyName;
          }, 0.5);
        }
        //this.fctListeSuject(new MouseEvent('click', {bubbles: true, cancelable: true}));
      } else if(collectif){
        this.selectedProjectType = "general";
        const generalTag = this.projectTags.find(tag => tag.libelle === 'general');
          this.sendMessageForm.patchValue({
                subProject: generalTag
          });
          //this.tempRecipientSelected = [];
            this.getUserListWithNoCurrentUser().map(item=> {
              if (item.user.id !== this.currentUser) {
                this.tempMemberUser.push(item.user);
              }
            })
          this.sendMessageForm.patchValue({recipient: this.currentUser});
          this.sendMessageForm.controls.inCopy.patchValue([...this.getUserListWithNoCurrentUser().map(item => item.user.id)]);
          this.sendMessageForm.controls.general.patchValue(true);
          this.sendMessageForm.controls.thematic.patchValue(false);
          setTimeout(() => {
                const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
                libsubjectvalue.innerHTML = "Note générale";
                if(this.descp) this.descp.focus();
              }, 0.5);
      }
      
      setTimeout(() => {
          //this.fctListeRecipient(new MouseEvent('click', {bubbles: true, cancelable: true}));
          //this.selectRecipient.open();
      }, 0.1);
    } else {
      this.showScroll = true;
      this.writeMode = -1;
    }
  }

  addProjectToArray(){
    // this.arraySubject.push({libelle:this.newProjectSubject})
    //var newProjectSubject = (<HTMLInputElement>document.getElementById("missionname")).value;
    var newProjectSubject = this.missionname.nativeElement.value;
    if(newProjectSubject.trim() == "" || newProjectSubject.trim().length == 0){
      alert("Veuillez entrer un canal"+this.project);
      return;
    }
    this.authService.addTagToProject({
      libelle:newProjectSubject,
      project:this.project
    }).then((res)=>{
      this.newProjectSubject = "";
      this.missionname.nativeElement.value = "";
      newProjectSubject = "";
      this.addmissionclicked = 0;
      this.projectTags.push(res);
      this.projectTags.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
      this.sendMessageForm.get('subProject').setValue(res); 
      this.showValue();
      this.selectSubject.close();
      setTimeout(() => {
        if(this.descp) this.descp.focus();

        }, 0);
      
      this.socketService.sendInstant({
        id: "",
        action: this.ID,
        type: "ADDSUBJECT",
        author: this.currentUser,
        recipient: "",
        text: "",
        copy: "",
        private: false,
        res: res,
        date: ""
      });
      //this.getProjectInfo();
    }).catch(err=>{
    });
  }

  autoResizeTextarea() {
    const textarea = this.inputMessage2.nativeElement as HTMLTextAreaElement;

    // Reset hauteur à une ligne
    textarea.style.height = '20px';

    const style = window.getComputedStyle(textarea);
    const lineHeight = parseFloat(style.lineHeight || '20');
    const scrollHeight = textarea.scrollHeight;
    //console.log("scrollHeight : "+scrollHeight)
    //console.log("lineHeight : "+lineHeight)

    const currentLines = Math.floor((scrollHeight - 13 ) / lineHeight);
    //console.log("currentLines : "+currentLines)

    if (currentLines > 1 && textarea.value.length > 0) {
      textarea.style.height = Math.min(scrollHeight, 96) + 'px';
      //console.log("plus d'une ligne (" + currentLines + ")");
    } else {
      //console.log("1ere ligne");
      textarea.style.height = '31px';
    }
  }

  FocusWriteMsg(){
    
    setTimeout(() => this.inputMessage2.nativeElement.focus(), 0);
  }

  showValue(){
    this.showsubject = false;
    setTimeout(() => {
      const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
      libsubjectvalue.innerHTML = this.sendMessageForm.value.subProject.libelle;
    }, 0.5);
    
    setTimeout(() => {
        if(this.descp) this.descp.focus()

    }, 0);
  }


  changesub(){
    
  }

  openSubject(){
    this.showsubject = true;
    this.selectSubject.open()
  }

  updateProjectNotifications() {
    this.total = 0;
    this.authService.getOnlyProjectNotification(0, 1, 1000, this.ID).subscribe((res) => {
      this.sentNotifProjectCount = res['hydra:totalItems'];
      this.total += this.sentNotifProjectCount;
    });

    this.authService.getOnlyProjectNotification(1, 1, 1000, this.ID).subscribe((res) => {
      this.receiveNotifProjectCount = res['hydra:totalItems'];
      this.total += this.receiveNotifProjectCount;
    });

    this.authService.getOnlyProjectNotification(2, 1, 1000, this.ID).subscribe((res) => {
      this.copyNotifProjectCount = res['hydra:totalItems'];
      this.total += this.copyNotifProjectCount;
    });

    this.authService.getOnlyProjectNotification(3, 1, 1000, this.ID).subscribe((res) => {
      this.commentNotifProjectCount = res['hydra:totalItems'];
      this.total += this.commentNotifProjectCount;
    });

  }

  

  getMessagesColor(){

    switch (this.statusMsg) {
      case 'Répondus':
        return '#58af31';

      case 'Non répondus':
        return '#e53935';
      
      case 'Annulés':
        return '#888';

      default:
        return '#000';
    }
  }

  getTasksColor(){

    switch (this.statusMsg) {

      case 'Échéance non dépassée':
        return '#5e93bf';

      case 'Échéance dépassée':
        return '#e53935';

      case 'Terminées':
        return '#58af31';

      case 'Annulées':
        return '#888';

      default:
        return '#000';
    }
  }

  getstatusColor(){

    switch (this.statusMsg) {
      case 'Répondu':
        return '#58af31';

      case 'Non répondu':
        return '#e53935';

      case 'Échéance non dépassée':
        return '#5e93bf';

      case 'Échéance dépassée':
        return '#e53935';

      case 'Terminée':
        return '#58af31';

      case 'Annulée':
        return '#888';
      
      case 'Annulé':
        return '#888';

      default:
        return '#000';
    }
  }
  

  ngAfterViewInit() { 
    /*
    // 1️⃣ Récupérer l’élément root du composant éditeur
    const editorEl = this.descp.nativeElement;

    // 2️⃣ Récupérer la toolbar
    const toolbar = editorEl.querySelector('angular-editor-toolbar');

    // 3️⃣ Récupérer le wrapper textarea
    const wrapper = editorEl.querySelector('.angular-editor-wrapper');

    // 4️⃣ Créer ta div custom
    const customDiv = this.renderer.createElement('div');
    this.renderer.addClass(customDiv, 'my-custom-header');

    customDiv.innerHTML = `
        <div style="display:flex; justify-content:space-between; align-items:center;">
            <div>
                À terminer avant le :
                <input type="date">
            </div>
            <label style="cursor:pointer; font-size:22px;">
                📎
                <input type="file" hidden />
            </label>
        </div>
    `;

    // 5️⃣ Insérer la div entre toolbar et textarea
    this.renderer.insertBefore(editorEl, customDiv, wrapper);*/
  }



  ngOnDestroy() {
    this.projectState.setInProject(false);
    console.log("destroyed");
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.destroy$.next();
    this.destroy$.complete();
    this.cancelRequest$.next();
    this.cancelRequest$.complete();
    this.cancelInstantRequest$.next();
    this.cancelInstantRequest$.complete();
  }

  clickaddmission(){
    this.addmissionclicked = 1;
    setTimeout(() => this.missionname.nativeElement.focus(), 200);
  }

  cancelSubject(){
    this.addmissionclicked = 0;
  }

  cancelUpdSubject(){
    this.updclicked = false;
    this.updateSubject = "";
    this.projectTags.map((value, index) => {
      value.updated = false;
    });
  }

  updateTag(tag, i){
    this.updateSubject = (<HTMLInputElement>document.getElementById("updateSubject")).value;
    if (this.updateSubject.trim().length == 0) {
      alert("Veuillez entrer un canal");
      return;
    }
    this.authService.updateTag(tag.id,{libelle:this.updateSubject}).then((res)=>{
      this.projectTags[i].libelle = this.updateSubject;
      this.cancelUpdSubject();
      this.socketService.sendInstant({
        id: "",
        action: this.ID,
        type: "RENAMESUBJECT",
        author: this.currentUser,
        recipient: "",
        text: "",
        copy: "",
        private: false,
        res: res,
        date: ""
      });
    }).catch(err=>console.log(err))
  }


  protected themeProject() {
    
    if(this.saveSubject == null){
      this.saveSubject = this.projectTags;
    }

    let search = this.themeCtrl.value;
    if (!search) {
      this.projectTags = this.saveSubject;
      return;
    } else {
      search = search.toLowerCase();
      this.projectTags = this.saveSubject.filter(bank => bank.libelle.toLowerCase().indexOf(search) > -1);
    }
  }

  protected filterSubjectSearch() {
    if(this.saveTheme == null){
      this.saveTheme = this.projectTags;
    }

    let search = this.subjectCtrl.value;
    if (!search) {
      this.projectTags = this.saveTheme;
      return;
    } else {
      search = search.toLowerCase();
      this.projectTags = this.saveTheme.filter(bank => bank.libelle.toLowerCase().indexOf(search) > -1);
    }
  }

  protected filterRecipient() {
    if(this.saveCtc == null){
      this.saveCtc = this.contactsDest;
    }

    let search = this.recipientCtrl.value;
    if (!search) {
      this.contactsDest = this.saveCtc;
      return;
    } else {
      search = search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.contactsDest = this.saveCtc.filter(bank => bank.givenName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  protected filterCopy() {
    
    if(this.saveCopySearch == null){
      this.saveCopySearch = this.projectUsers;
    }

    let search = this.copyCtrl.value;
    if (!search) {
      this.projectUsers = this.saveCopySearch;
      return;
    } else {
      search = search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.projectUsers = this.saveCopySearch.filter(bank => bank.user.givenName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.user.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  protected filterRecipientSearch(){
    if(this.saveRecipient == null){
      this.saveRecipient = this.projectUsers;
    }

    let search = this.recipientSearch.value;
    if (!search) {
      this.projectUsers = this.saveRecipient;
      return;
    } else {
      search = search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.projectUsers = this.saveRecipient.filter(bank => bank.user.givenName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.user.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  protected filterCopytSearch(){
    if(this.saveCopy == null){
      this.saveCopy = this.getUserListWithNoCurrentUser().map(item => item.user.id);
    }

    let search = this.copySearch.value;
    //alert("search "+search)
    if (!search) {
      this.arrayUserCopy = this.getUserListWithNoCurrentUser();
      return;
    } else {
      search = search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.arrayUserCopy = this.arrayUserCopy.filter(bank => bank.user.givenName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.user.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  protected filterTransmitter(){
    if(this.saveCtcTransmitter == null){
      this.saveCtcTransmitter = this.contactsExp;
    }

    let search = this.transmitterCtrl.value;
    if (!search) {
      this.contactsExp = this.saveCtcTransmitter;
      return;
    } else {
      search = search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.contactsExp = this.saveCtcTransmitter.filter(bank => bank.givenName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  getBrowserLanguages() {
    const languages = navigator.languages || [navigator.language];
  }

  cancelTranslateComment(index, indexcomment){
    this.dataSource[index].comment[indexcomment].translated = null;
  }

  translateComment(text = null, index, indexcomment){
    this.translationenabed = (this.currentCompany === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
    if(text == null || !this.translationenabed) return;
    var lang_discuss = this.authService.lang_discuss;
    //this.detectLanguage("hello from tunisia");
    const subscription = this.translationService.translateText(text, lang_discuss).pipe(takeUntil(this.cancelInstantRequest$)).subscribe(
      (response) => {
        if (response && response.data && response.data.translations) {
          var translated = response.data.translations[0].translatedText;
          this.dataSource[index].comment[indexcomment].translated = translated;
        }
      },
      (error) => {
      }
    );
    this.subscriptions.push(subscription);
  }

  cancelTranslateText(index, answer = false){
    if(answer){
      this.dataSource[index].answer.translated = null;
    } else this.dataSource[index].translated = null;
  }

  cancelTranslateAnswers(){
    for(var i=0; i < this.arrayQuickAnswer.length; i++) {
      this.arrayQuickAnswer[i].translated = null;
    };
  }

  async translateQuickAnswers() {
    const lang_discuss = this.authService.lang_discuss;
    if(this.arrayQuickAnswer[0].translated) {
      this.cancelTranslateAnswers();
      return;
    } 
    let tempQuickAnswer = [...this.arrayQuickAnswer];
    for (var i = 0; i < this.arrayQuickAnswer.length; i++) {
      try {
        // Attendez la réponse de la traduction pour chaque message
        const response = await this.translationService.translateText(tempQuickAnswer[i].message, lang_discuss).toPromise();
        
        // Vérifiez si la réponse contient des traductions
        if (response && response.data && response.data.translations) {
          var translated = response.data.translations[0].translatedText;
          
          // Mettez à jour l'élément du tableau avec la traduction
          tempQuickAnswer[i].translated = translated;
        }
      } catch (error) {
        console.error('Erreur de traduction pour le message : ', this.arrayQuickAnswer[i].message, error);
      }
    }
    this.arrayQuickAnswer = tempQuickAnswer;
  }

  translateText(text = null, index, answer = false){
    this.translationenabed = (this.currentCompany === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
    if(text == null || !this.translationenabed) return;
    var lang_discuss = this.authService.lang_discuss;
    //this.detectLanguage("hello from tunisia");
    const subscription = this.translationService.translateText(text, lang_discuss).pipe(takeUntil(this.cancelInstantRequest$)).subscribe(
      (response) => {
        if (response && response.data && response.data.translations) {
          var translated = response.data.translations[0].translatedText;
          if(answer){
            this.dataSource[index].answer.translated = translated;
          } else this.dataSource[index].translated = translated;
        }
      },
      (error) => {
        console.error('Erreur de traduction', error);
      }
    );
    this.subscriptions.push(subscription);
  }

  cancelTranslateTextIns(index){
    this.messagesInstant[index].translated = null;
  }

  translateTextIns(text = null, index){
    this.translationenabed = (this.currentCompany === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
    if(text == null || !this.translationenabed) return;
    var lang_discuss = this.authService.lang_discuss;
    //this.detectLanguage("hello from tunisia");
    const subscription = this.translationService.translateText(text, lang_discuss).pipe(takeUntil(this.cancelInstantRequest$)).subscribe(
      (response) => {
        if (response && response.data && response.data.translations) {
          var translated = response.data.translations[0].translatedText;
          this.messagesInstant[index].translated = translated;
        }
      },
      (error) => {
        console.error('Erreur de traduction', error);
      }
    );
    this.subscriptions.push(subscription);
  }

  translateWord(text = null, i = false){
    this.translationenabed = (this.currentCompany === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
    if(text == null || !this.translationenabed) return;
    var lang_discuss = this.authService.lang_discuss;
    const subscription = this.translationService.translateText(text, lang_discuss).pipe(takeUntil(this.cancelInstantRequest$)).subscribe(
      (response) => {
        if (response && response.data && response.data.translations) {
          if(i) this.translatenosuccess = response.data.translations[0].translatedText;
          else this.translatesuccess = response.data.translations[0].translatedText;
        }
      },
      (error) => {
        console.error('Erreur de traduction', error);
      }
    );
    this.subscriptions.push(subscription);
  }

  async updateTranslationFlags() {
    this.translationenabed = (this.currentCompany === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
    if(!this.translationenabed) return;
    var lang_discuss = this.authService.lang_discuss;
    if(this.dataSource == undefined || this.dataSource.length == 0) return;
    for (let i = 0; i < this.dataSource.length; i++) {
      const element = this.dataSource[i];
      if(element == undefined) continue;
      if(!element.text){
        this.dataSource[i].willtranslate = false;
      } else if(this.isLink(element.text)) {
        this.dataSource[i].willtranslate = false;
      } else if(element.isLangdetected && element.langmsg == lang_discuss) {
        this.dataSource[i].willtranslate = false;
      } else if(this.dataSource[i]){
        
        try {
          const shouldTranslate = await this.detectLanguage(element.text, lang_discuss);
          if(shouldTranslate) this.dataSource[i].willtranslate = shouldTranslate;  // true si le message doit être traduit, sinon false
          else this.dataSource[i].willtranslate = false;
        } catch (error) {
          if(this.dataSource[i]) this.dataSource[i].willtranslate = false;  // Si une erreur se produit, ne pas traduire
        }
      }
  
      if (element.answer) {
        if(!element.answer.text){
          this.dataSource[i].willtranslate = false;
        } else if(this.isLink(element.answer.text)) {
          this.dataSource[i].answer.willtranslate = false;
        } else if(element.answer.isLangdetected && element.answer.langmsg == lang_discuss) {
          this.dataSource[i].answer.willtranslate = false;
        } else if(this.dataSource[i]){
          try {
            const shouldTranslate = await this.detectLanguage(element.answer.text, lang_discuss);
            this.dataSource[i].answer.willtranslate = shouldTranslate;  // Si la réponse doit être traduite, mettre à jour la même propriété
          } catch (error) {
            if(this.dataSource[i]) this.dataSource[i].answer.willtranslate = false;
          }
        }
      }
      if (element.comment) {
        for (let j = 0; j < element.comment.length; j++) {
          const comment = element.comment[j];
          if(!element.comment[j].text){
            this.dataSource[i].comment[j].willtranslate = false;
          } else if(this.isLink(element.comment[j].text)) {
            this.dataSource[i].comment[j].willtranslate = false;
          } else if(element.comment[j].isLangdetected && element.comment[j].langmsg == lang_discuss) {
            this.dataSource[i].comment[j].willtranslate = false;
          } else if(this.dataSource[i]){
            try {
              const shouldTranslate = await this.detectLanguage(element.comment[j].text, lang_discuss);
              //console.log("réponse : "+i+" : "+shouldTranslate);
              this.dataSource[i].comment[j].willtranslate = shouldTranslate;  // Si la réponse doit être traduite, mettre à jour la même propriété
            } catch (error) {
              //console.error('Erreur lors de la détection de la langue pour la réponse:', error);
              if(this.dataSource[i]) this.dataSource[i].comment[j].willtranslate = false;
            }
          }
        }
      }
    }
  }

  async cancelTranslationFlags() {
    var lang_discuss = this.authService.lang_discuss;
    for (let i = 0; i < this.dataSource.length; i++) {
      const element = this.dataSource[i];
      this.dataSource[i].willtranslate = false;
      this.dataSource[i].translated = null;

      if (element.answer) {
        this.dataSource[i].answer.willtranslate = false;
        this.dataSource[i].answer.translated = null;
      }
      if (element.comment) {
        for (let j = 0; j < element.comment.length; j++) {
          this.dataSource[i].comment[j].willtranslate = false;
          this.dataSource[i].comment[j].translated = null;
        }
      }
    }
  }

  cancelTranslationFlagsIns() {
    for (let i = 0; i < this.messagesInstant.length; i++) {
      this.messagesInstant[i].willtranslate = false;
      this.messagesInstant[i].translated = null;
    }
  }

  async updateTranslationFlagsIns() {
    this.translationenabed = (this.currentCompany === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
    if(this.messagesInstant == undefined || this.messagesInstant.length == 0) return;
    var lang_discuss = this.authService.lang_discuss;
    for (let i = 0; i < this.messagesInstant.length; i++) {
      const element = this.messagesInstant[i];
      if(element == undefined) continue;
      if(!element.text){
        this.messagesInstant[i].willtranslate = false;
      } else if(this.isLink(element.text)) {
        this.messagesInstant[i].willtranslate = false;
      } else if(element.isLangdetected && element.langmsg == lang_discuss) {
        this.messagesInstant[i].willtranslate = false;
      } else {
        this.messagesInstant[i].willtranslate = true;
      }
    }
  }

  
  async detectMsgLanguage(text: string): Promise<string> {
    this.translationenabed = (this.currentCompany === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
    if(!this.translationenabed) return;
    if (!text || this.isLink(text)) {
      return "false"; // Retourne immédiatement si le texte est vide
    }
  
    try {
      // Utilisation de `toPromise()` pour convertir l'observable en promesse
      const response = await this.translationService.detectLanguage(text).toPromise();
      const language = response['data']['detections'][0][0].language;
      //console.log("laaang 0 " + language);
      return language; // Retourne la langue détectée
    } catch (error) {
      console.error('Erreur dans la détection de la langue', error);
      return "false"; // Retourne "false" en cas d'erreur
    }
  }
  

  detectLanguage(text: string, lang_site = "fr"): Promise<boolean> {
    this.translationenabed = (this.currentCompany === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
    if(!this.translationenabed) return;
    return new Promise((resolve, reject) => {
      if (!text) {
        reject('Aucun texte fourni');
        return;
      }
  
      var subscription = this.translationService.detectLanguage(text).pipe(takeUntil(this.destroy$)).subscribe(
        (response) => {
          const language = response['data']['detections'][0][0].language;
          //console.log("Langue détectée : ", language);
          resolve(language !== lang_site);  
        },
        (error) => {
          //console.error('Erreur lors de la détection de la langue', error);
          reject(error);
        }
      );
      this.subscriptions.push(subscription);
    });
  }

  changeTask(){
    this.statusMsg = null;
    this.isTaskMsg = !this.isTaskMsg;
    if(this.isTaskMsg){
      console.log("is task");
      this.editorConfig = {
          ...this.editorConfig,
          placeholder: this.translate.instant('map.placeholdertask')
      };
    } else {
      console.log("no task");
      this.editorConfig = {
          ...this.editorConfig,
          placeholder: this.translate.instant('map.placeholder')
      };
    }
  }

  initEditorConfig(){
    this.translate.get('map.placeholder').subscribe((text: string) => {
      this.editorConfig = {
        editable: true,
        spellcheck: true,
        height: '80px',
        placeholder: text,
        translate: 'no',
        defaultParagraphSeparator: 'p',
        defaultFontName: 'Inter',
    toolbarHiddenButtons: [
    [
      'strikeThrough',
      'subscript',
      'superscript',
      'justifyLeft',
      'justifyCenter',
      'justifyRight',
      'justifyFull',
      'indent',
      'outdent',
      'insertUnorderedList',
      'insertOrderedList',
      'heading',
      'fontName',
      'fontSize',
      'textColor',
      'backgroundColor',
      'customClasses',
      'insertImage',
      'insertVideo',
      'insertHorizontalRule',
      'removeFormat',
      'toggleEditorMode'
    ]
    ]
      };
    });
  }

  ngOnInit() {
    this.authService.initHeader.emit("project");
    this.projectState.setInProject(true);
    this.projectState.setInstantMode(false);
    this.chrono_mode = true;
    this.textmode = true;
    this.searchface = null;
    this.facesent = false;
    this.msgsent = false;
    this.isExpanded = false;
    this.initEditorConfig();
    this.translate.onLangChange.subscribe(() => {
    this.initEditorConfig();
  });
    //var same = this.currentUserInfo.translate;
    var same = (this.currentCompany === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
    this.translationenabed = same;
    this.messageService.getTranslateDiscuss().subscribe((data) => {
      this.translationenabed = (this.authService.lang_translate && same);
      if(this.translationenabed == true){
        this.translateWord("Traduire");
        this.translateWord("Original", true);
        this.updateTranslationFlags();
        this.updateTranslationFlagsIns();
      } else {
        this.translateWord("Traduire");
        this.translateWord("Original", true);
        this.cancelTranslationFlags();
        this.cancelTranslationFlagsIns();
      }
    });
    
    this.getBrowserLanguages();
    this.show_translate = this.authService.lang_translate && (this.authService.lang_discuss !== this.authService.lang_site);
    var language = this.languages.find(language => language.code === this.authService.lang_discuss);
    if(language) this.langue = language.image;
    //---------------------------
    this.messageService.getTranslate().subscribe((data) => {
      this.show_translate = this.authService.lang_translate && (this.authService.lang_discuss !== this.authService.lang_site);
      if(this.show_translate) {
        this.updateTranslationFlags();
        this.updateTranslationFlagsIns();
      }
    });
    this.messageService.getTranslateDiscuss().subscribe((data) => {
      this.show_translate = this.authService.lang_translate  && (this.authService.lang_discuss !== this.authService.lang_site);
      var language = this.languages.find(language => language.code === this.authService.lang_discuss);
      if(language) this.langue = language.image;
      if(this.show_translate) {
        this.updateTranslationFlags();
        this.updateTranslationFlagsIns();
      }
    });

    this.messageService.getEnableTranslate().subscribe((data) => {
      this.show_translate = this.authService.lang_translate && (this.authService.lang_discuss !== this.authService.lang_site);
      var language = this.languages.find(language => language.code === this.authService.lang_discuss);
      if(language) this.langue = language.image;
      if(this.show_translate) {
        this.updateTranslationFlags();
        this.updateTranslationFlagsIns();
      }
    });
    //---------------------------
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    
    this.secteur = localStorage.getItem('secteur');
    this.firstConnection = localStorage.getItem('firstConnection');

    this.currentDate = dd + '/' + mm + '/' + yyyy;
    this.localDate = dd + '/' + mm + '/' + yyyy;

    const hier = new Date(today);
    hier.setDate(today.getDate() - 1);

    const jourHier = hier.getDate().toString().padStart(2, '0');
    const moisHier = (hier.getMonth() + 1).toString().padStart(2, '0');
    const anneeHier = hier.getFullYear();

    this.yesterdayDate = `${jourHier}/${moisHier}/${anneeHier}`;

    this.route.paramMap.subscribe(params => {
      this.divopened = false;
      this.ID = params.get('ID');
      this.facesent = false;
      this.specComment = false;
      this.iDProjet = params.get('ID');
      this.messageService.setProjectid(this.ID)
      this.authService.currentProjectId.next(this.ID);
      this.specMsg = params.get('specMsg');
      this.openmsg = params.get('openmsg');
      this.idmsg = params.get('idmsg');

      

    
    this.authService.obNotifiedMode.subscribe((res: any) =>{ 
      this.totalnotif = res["total"];
      this.notifNbr = res["total"];
      if(res["total"]) this.totalnotif = res["total"];
      this.ID = res['id'];
      this.instant = false;
      this.cdRef.detectChanges();
    });
    this.notifiedmode = this.authService.isNotified || this.authService.isAnsweredNotified;
      this.specMsgType = params.get('type');
      if (this.specMsg) {
        this.instant = false;
        this.showRedBar = true;
        this.authService.obprojectChosen.next(this.specMsg);
      }
      this.isSearch = false;
      if (this.openmsg == "openmsg") {
        this.instant = true;
        this.projectState.setInstantMode(true);
      }
      this.getCurrentProject();
      if (this.openmsg == "openmsg") {
        this.modeDoc = false;
        this.hiddenSearchEngin = true;
        this.searchinstant = false;
        this.messagesInstant = [];
        this.perPage = 30;
        this.startedPoint = false;
        this.pageIndex = 0;
        this.limitmsg = 20;
        this.nbrloadmsg = 0;
        this.canload = false;
        this.offsetmsg = 0;
        //console.log("getMessagesInstant")
        this.getMessagesInstant(null, true);
        this.CountMessagesInstant(0);
        this.resetSearchInstant();
        if(this.notificationsCount > 20) {
          var rest = Math.floor(this.notificationsCount / 20);
          this.limitmsg = 20 * (rest + 1);
        }
        if(this.idmsg){
          this.scrollToMsg(this.idmsg);
        }
      }
      // init instant format
      this.drive = false;
      if(this.instant == true){
        this.authService.setMode('collaboratif');
        this.loadSendersIns();
        this.loadTypesIns();
        this.loadDocsSendersIns();
        this.typeproject = "MESSAGES INSTANTANES";
        this.authService.obreceiveType.next(this.ID);
        this.socketService.sendInstant({
          id: '',
          action: this.ID,
          type: "READMSG",
          author: this.currentUser,
          author_name: '',
          recipient: '',
          text: '',
          copy: "",
          private: false,
          res: '',
          project_lib: '',
          date: ''
        });
      } else {
        this.authService.setMode('cooperatif');
        this.getUserSubjects();
        this.getTags();
        this.getCopy();
        this.loadTypes();
        this.loadTypesBlocs();
        this.typeproject = "MESSAGES ORGANISES";
        this.getProjectExp();
        this.getProjectDest();
        //this.updateProjectNotifications();
      }

      if(this.menuOuvert == true){
        this.showFileSelector();
      }

      // end init instant 
      this.resetQuestionFrom();
      this.resetAnswerFrom();
      this.resetCommentForm();
      this.writeMode = -1;
      this.openWriteFace = false;
      this.senderror = false;
      this.showMessages = true;
      this.submitted = false;
      this.paginator.pageIndex = 0;
      this.dataSource = [];
      this.messagesInstant = [];
      this.resultsLength = 0; 
      this.searchresLength = 0;
      this.searchresLengthInst = 0;
      this.lastFaceNumber = 1;
      this.chosenFilterProject = null;
      this.isReady = false;
      this.userAdmin = false;

      if (this.messageService.getShowCreateProjectTuto() == false) {
        this.showTool = this.messageService.getShowProjectTutobis();
      }
      this.selectedOptiontag = "";
      this.showsubject = true;
      
      this.updateCurrentNotifications(this.ID).subscribe((total) => {
        this.notifNbr=total;
      });


      this.hiddenSearchEngin = true;

      setTimeout(() => {
       window.scroll(0,0);
      }, 500);
    });
    this.expanded = true;
    this.ged = false;
    this.getAnswerListe();
    
    this.authService.obreadMessage.subscribe((indexMessage: number) =>{ 
      this.readmsg = indexMessage;
    });

    this.authService.closeBloc.subscribe((term) =>{ 
      if(term == 1){
        this.resetSearch();
      }
    });

    this.authService.scrollTop.subscribe((term) =>{ 
      if(term == 1){
        this.scrollToTop();
      }
    });

    this.messageService.chosenProject$.subscribe((idProject) => {
      this.projecthasChange(idProject);
    });

    this.messageService.getImageProject().subscribe((url) => {
      this.projectImageChanged(url);
    });
    
    this.recipientCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterRecipient();
      });

    this.copyCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCopy();
      });

    this.transmitterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterTransmitter();
    });

    
    this.themeCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.themeProject();
      });

    this.recipientSearch.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterRecipientSearch();
    });

    this.copySearch.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCopytSearch();
    });
    
    this.subjectCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterSubjectSearch();
    });


    this.messageService.getShowCreateProjectTutoIsFalse().subscribe(( ) =>{ 
      this.showTool = this.messageService.getShowProjectTutobis();
    });

    this.messageService.getTranslate().subscribe((data) => {
      this.lang = data;
    });

    this.authService.changeModeProject.subscribe((res) => {
      console.log("change project")
        this.changeDiscussionFormat();
    });

    this.messageService.getChosenProject().subscribe((data) => {
      if(data != this.ID){
        this.messagesInstant = [];
        this.cancelInstantRequest$.next();
        this.cancelInstantRequest$ = new Subject<void>();
      }
    });

    this.messageService.getLibelleProject().subscribe((data) => {
      if(this.projectFull){
        this.projectFull.libelle = data;
      } else {
        const projectfulllib: HTMLElement = document.getElementById('projectfulllib') as HTMLElement
        if(projectfulllib) projectfulllib.innerHTML = data;
      }
    });

    this.messageService.getNotifProject().subscribe((total) => {
      if(total){
        this.totalnotif = total;
        this.notifNbr = total;
      }
    });

    this.coreService.toggleSidebar.subscribe((res) => {
      this.hideNav = Number(res);
    });


    //this.divHeaderTable.nativeElement.scrollIntoView();
    
    

    this.messageService.getWriteMessage()
    .subscribe(
      (data)=>{
        // this.fctEcrire();
      }
    )

    this.authService.obprojectChosen.subscribe((idMessage) =>{ 
      this.smartNumber = idMessage;
      //console.log('dans le smarnumber idmessage ==> '+idMessage);
    });

    this.authService.obreceiveAsread.subscribe((idProject) => {
      //console.log("read from single")
      if(this.total > 0){
        this.total -= 1;
      }
      //this.updateProjectNotifications();
    });

    this.authService.obchangeinterface.subscribe((instant) => {
      this.changeDiscussionFormat();
    });


    this.authService.obreceiveMessage.subscribe((res) =>{ 
      if (!res["id"]) {
        return;
      }
      var length = this.messagesInstant.length;
      var index = length - 1;
      if(length > 1 && (this.messagesInstant[index].id == res["id"] || this.messagesInstant[index -1 ].id == res["id"])){
        return;
      } else if(length > 0 && (this.messagesInstant[index].id == res["id"])){
        return;
      }
      this.offsetmsg += 1;
      //this.messagesInstant.push(res);
      if (!this.messagesInstant.some(msg => msg.id === res["id"])) {
        this.messagesInstant.push(res);
      }
          if(this.instant == true){
            setTimeout(() => {
              this.notificationsCount = 0;
              this.stopTyping();
              this.scrollToBottom();
            }, 200);
      }
    });

    this.authService.obreceiveFace.subscribe((res) =>{ 
      if(this.dataSource[0] && this.dataSource[0].id == res["id"]){
        return;
      }
      this.getMessageFace(res);
      this.getProjectExp();
      this.getProjectDest();
    });

    this.authService.obreceiveComment.subscribe((idMessage) =>{ 
      const index = this.dataSource.findIndex(message => message.id === idMessage);
      if (index !== -1) {
        this.getMessageComment(idMessage, index);
        this.notifNbr++;
      }
    });

    this.authService.obreceiveResponse.subscribe((idMessage) =>{ 
      const index = this.dataSource.findIndex(message => message.id === idMessage);
      if (index !== -1) {
        this.getMessageComment(idMessage, index);
      }
    });

    this.authService.obreceiveAdmin.subscribe((res) =>{ 
      this.userAdmin = true;
    });

    this.authService.obDeletedmin.subscribe((res) =>{ 
      this.userAdmin = false;
    });

    this.authService.obResponseLu.subscribe((idMessage) =>{ 
      const index = this.dataSource.findIndex(message => (message.answer && (message.answer.id === idMessage)));
      if (index !== -1) {
        this.dataSource[index].answer.isRecipientRead = true;
      }
    });

    this.authService.obQuestionCpyLu.subscribe((idMessage) =>{ 
      const index = this.dataSource.findIndex(message => (message && (message.id === idMessage)));
      if (index !== -1) {
        for (var i = 0; i < this.dataSource[index].copy.length; i++) {
          if((this.dataSource[index].copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (this.dataSource[index].copy[i].isRead == false)){
            this.dataSource[index].copy[i].isRead = true;
            break;
            //this.deleteMsgNotified(this.dataSource[indexmsg], indexmsg);
          }
        }
        //to do copie
      }
    });

    this.authService.obResponseCpyLu.subscribe((idMessage) =>{ 
      const index = this.dataSource.findIndex(message => (message.answer && (message.answer.id === idMessage)));
      if (index !== -1) {
        for (var i = 0; i < this.dataSource[index].answer.copy.length; i++) {
          if((this.dataSource[index].answer.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (this.dataSource[index].answer.copy[i].isRead == false)){
            this.dataSource[index].answer.copy[i].isRead = true;
            break;
            //this.deleteMsgNotified(this.dataSource[indexmsg], indexmsg);
          }
        }
        //to do copie
      }
    });

    

    this.authService.obQuestionLu.subscribe((idMessage) =>{ 
      const index = this.dataSource.findIndex(message => message.id === idMessage);
      if (index !== -1) {
        this.dataSource[index].isRecipientRead = true;
      }
    });

    this.authService.obCommentLu.subscribe((message : any) =>{ 
      const index = this.dataSource.findIndex(item => item.id === message.id);
      if (index !== -1) {
        const indexcom  = this.dataSource[index].comment.findIndex(comment => comment.id === message.res);
        if (indexcom !== -1) {
          //element.copy[i].isRead
          this.dataSource[index].comment[indexcom].copy.forEach(element => {
            element.isRead = true;
          });
          //.isRecipientRead = true;
        }
      }
      //this.dataSource[indexmsg].comment[indexcmt].copy[i].isRead = true;
    });

    this.authService.obSubAdd.subscribe((message : any) =>{ 
      const index = this.projectTags.findIndex(item => item.id === message.id);
      if (index == -1) {
        this.projectTags.push(message);
        this.projectTags.sort((a, b) => {
          if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
            return -1;
          }
          if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
            return 1;
          }
          return 0;
        })
      }
    });

    this.authService.obSubRename.subscribe((message : any) =>{ 
      const index = this.projectTags.findIndex(item => item.id === message.id);
      if (index !== -1) {
          this.projectTags[index].libelle = message.libelle ;
      }
      for (var i = 0; i < this.dataSource.length; i++) {
          if(this.dataSource[i].tags[0].id == message.id){
            this.dataSource[i].tags[0].libelle = message.libelle;
          }
      }
    });
    

    this.messageService.getMessageIsSend().subscribe(() => {
       this.showTool = false; 
       this.messageService.setShowProjectTutobis(false);
    });

    this.hiddenSearchEngin = true;

    this.authService.obUpdateProfile.subscribe((res) => {
      if(res === '1'){
        this.getCurrentUser();
      } 
    });

    // Écouter quand un autre utilisateur est en train de taper
    this.socketService.onUserTyping().subscribe((data) => {
      if(this.ID == data.room) {//TO DO verify if room = current project
        this.typingUser = data;
        this.startTypingDotsAnimation();
      } //else this.typingUser = null;
      if(this.isAtBottom && this.instant && this.ID == data.room) {
        this.scrollToBottomtChat2();
      } 
    });

    // Écouter quand un autre utilisateur arrête de taper
    this.socketService.onUserStopTyping().subscribe((data) => {
      this.typingUser = null;
    });

    this.authService.subjectListAdd.subscribe((res) => {
      this.projectTags.push(res);
      this.projectTags.sort((a, b) => {
        if ( a.updatedAt > b.updatedAt ){
          return -1;
        }
        if ( a.updatedAt < b.updatedAt ){
          return 1;
        }
        return 0;
      })
    });

    this.authService.subjectListDel.subscribe((res) => {
      const index = this.projectTags.findIndex(item => item.id === res);
        if (index !== -1) {
            const elementAaa = this.projectTags.splice(index, 1)[0];
            this.authService.subjectListDel.emit(res);
      }
    });

    this.authService.subjectListUpd.subscribe((res) => {
      const index = this.projectTags.findIndex(item => item.id === res.id);
      if (index !== -1) {
          this.projectTags[index] = res;
      }
    });
    

  }

  getSubject(subject){
    if(subject === "Thématique d'échange"){
      return "Thème d'échange";
      } else return subject;
  }

  getRandomColor(): string {
      const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
      return this.vibrantColors[randomIndex];
    //return color;
  }

  darkenColor(bgColor: string) {
    if (!bgColor) return '#444';
    const key = bgColor.toLowerCase().substring(0, 7);
    return this.colorMap[key] || '#444'
  }

  private startTypingDotsAnimation(): void {
    let dotCount = 0;
    const typingInterval = setInterval(() => {
      if (this.typingUser) {
        if (dotCount === 3) {
          dotCount = 0;
        }
        this.typingDots = '.'.repeat(dotCount + 1);
        dotCount++;
      } else {
        clearInterval(typingInterval);
      }
    }, 500);  // Change la vitesse des points (500ms)
  }

  onKeyPress(event: any) {
    //console.log("onKeyPress")
    var fullName = this.currentUserInfo.givenName+" "+this.currentUserInfo.familyName;
    var imageUrl = this.currentUserInfo.imageUrl;
    // Lorsque l'utilisateur commence à taper
    if (!this.isTyping) {
      //this.isTyping = true;
      this.socketService.typing(this.ID, this.currentUser, fullName, imageUrl); // Notifier le serveur
    }

    // Mettre un timeout pour arrêter la notification de saisie après 3 secondes d'inactivité
    clearTimeout(this.stopTypingTimeout);
    this.stopTypingTimeout = setTimeout(() => {
      this.isTyping = false;
      this.socketService.stopTyping(this.ID, this.currentUser, fullName, imageUrl); // Notifier que l'utilisateur a arrêté de taper
    }, 3000); // 3 secondes de délai
  }

  changeNotifMode(){
    localStorage.setItem('notified', "notified");
    this.notifiedmode = true;
    this.refreshPageObs.next();
  }

  

  updateCurrentNotifications(id) {
    var total = 0;
    const observables = [
      this.authService.getAllProjectNotification(0, 1, 10, id)
    ]
    return forkJoin(observables).pipe(
      map((responses: any[]) => { // Définir le type explicite ici
        let total = 0;
        responses.forEach((res) => {
          total += res['hydra:member']['all'];
        });
        return total;
    }));

  }

  getMessageFace(res) {
    this.dataSource.unshift(res);
    this.loadSelectSearchFace(res);
    if(res.recipient.id == this.currentUser){
      this.total += 1;
      this.notifNbr += 1;
      //this.new_message = true;
        return;
    } else if(res.author.id == this.currentUser){
      this.total += 1;
      this.notifNbr += 1;
        return;
    } else {
      res.copy.forEach(element => {
        if(element.user.id == this.currentUser ){
          this.total += 1;
          this.notifNbr += 1;
          return;
        }
      })
    }
  }

  getMessageComment(idmessage, index) {
    if (!idmessage) {
      return;
    }
    this.authService.getMessageFace(idmessage)
      .subscribe(res => {
       this.dataSource.splice(index, 1);
       this.dataSource.unshift(res['hydra:member'][0]);
      }, (error) => {
    });
  }


  getMessageInstant(idmessage) {

    if (!idmessage) {
      return;
    }

    this.authService.getMessageInstant(idmessage)
      .subscribe(res => {
        //this.messagesInstant.push(res);
        if (!this.messagesInstant.some(msg => msg.id === res["id"])) {
        this.messagesInstant.push(res);
        }
        if(this.instant == true){
          this.stopTyping();
          setTimeout(() => {
            this.notificationsCount = 0;
            this.scrollToBottom();
          }, 200);
        }

      }, (error) => {
    });
  } 

  stopTyping(){
    //console.log("usertyping null")
    this.typingUser = null;
  }

  private initIoConnection(id_project): void {}

  getCurrentUser(){
    var iduser = JSON.parse(localStorage.getItem('currentUser')).id;
     this.authService.getInfoContact(iduser)
     .subscribe( dataContact => {
        this.userData.imageUrl = dataContact['imageUrl'];
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.currentUser.imageUrl = dataContact['imageUrl'];
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
     }, (error) => {
         alert('une erreur est survenue getCurrentUser update profile image');
     });
 
   }


  reloadScreen() {
    //console.log('reloadScreen!!!!');
    this.chosenFilterProject = null;
    this.specMsg = null;
    this.specComment = false;
    this.showRedBar = false;
    this.specMsgType = null;
    this.messageService.messageRefreshConv();//reload message page
    //this.messageService.messageUpdated();//update header notification
    this.messageService.needRefreshFiltre();//update filter elements
  }

  selectChoice(item = "init"){
    if(this.searchstep == "init" && item == "init") {
      this.fcthiddenSearchEngin();
    } else this.searchstep = item;
  }

  selectSender(givenname, familyname, id){
    this.searchsender = givenname +" "+ familyname;
    this.transmitterinstant = id; 
    this.selectChoice("init");
    this.filterMessageCountInst();
    this.loadTypesIns();
  }

  initSender(item = null){
    this.searchsender = "Émetteur";
    this.transmitterinstant = null; 
    if(!item) this.selectChoice("init");
    this.filterMessageCountInst();
    this.loadTypesIns();
  }

  initType(item = null){
    this.searchtype = "Type de Document";
    this.typeinstant = null; 
    if(!item) this.selectChoice("init");
    this.filterMessageCountInst();
  }

  initSenderFace(item = null){
    this.searchsenderface = "Éxpéditeur";
    this.transmitter = null; 
    this.getReceiver(null);
    this.getCopy();
    this.loadTypes();
    //this.getMessageStatus();
    this.initRecipientFace('1');
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  initRecipientFace(item = null){
    this.searchrecipientface = "Destinataire";
    this.recipient = null;
    if(!item) this.selectChoiceFace("init");
    //this.initCopyFace('1');
    //this.initStatusFace('1');
    this.initTypeFace('1');
    this.filterMessageCount();
    this.getCopy();
    this.loadTypes();
    //this.getMessageStatus();
  }

  initCopyFace(item = null){
    this.searchcopyface = "Membre en Copie";
    this.copy = null;
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    //this.getMessageStatus();
    //this.initStatusFace('1');
    this.initTypeFace('1');
  }

  initTypeFace(item = null){
    this.searchtypeface = "Type de Document";
    this.type = null;
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    this.loadTypes();
    //this.initStatusFace('1');
  }

  initTypeMsgFace(item = null){
    this.searchtypemsgface = "Type d'échanges";
    this.typemsg = null;
    this.type = null;
    this.isTaskSearch = null;
    this.isMessage = false;
    this.isTache = false;
    this.isDocument = false;
    this.isAlltype = true;
    //if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
    //this.initStatusFace('1');
  }

  initTypeBloc(item = null){
    this.searchtypebloc = "Type de bloc";
    this.typebloc = null;
    this.isGeneral = null;
    this.isThematic = null;
    this.initTagFace('1');
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  initTagFace(item = null){
    this.searchthemeface = "Canal";
    this.tag = null;
    this.type = null;
    this.isMessage = false;
    this.isTache = false;
    this.isDocument = false;
    this.isAlltype = true;
    this.isTaskSearch = null;
    this.initSenderFace('1');
    this.initRecipientFace('1');
    this.initCopyFace('1');
    //this.initStatusFace('1');
    this.initTypeFace('1');
    this.getProjectExp();
    this.getReceiver();
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  initStatusFace(item = null){
    this.searchstatusface = "Statut de réponse";
    this.statut = null;
    this.initTypeBloc('1');
    this.initTagFace('1');
    this.initSenderFace('1');
    this.initRecipientFace('1');
    this.initCopyFace('1');
    //this.initStatusFace('1');
    this.initTypeFace('1');
    this.getProjectExp();
    this.getReceiver();
    if(!item) this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  resetSearchIns(){
    this.searchsender = "Émetteur";
    this.searchtype = "Type de Document";
  }

  calculateDate(date) {
    var result = 0;
    var today = new Date().setHours(0, 0, 0, 0);
    var yesterday = new Date(new Date().setDate(new Date().getDate()-1)).setHours(0, 0, 0, 0);
    date = new Date(date);
    if (date >= today) {
      result = 1;
    } else if (date >= yesterday) {
      result = 2;
    } else result = 3;
    return result;
  }

  searchResetInstant(){
    this.resetSearchIns();
    //this.resetSearchInstant();
  }

  selectChoiceFace(item = "init"){
    if(this.searchstepface == "init" && item == "init") {
      this.fcthiddenSearchEngin();
    } else this.searchstepface = item;
  }

  selectSenderFace(givenname, familyname, id){
    this.searchsenderface = givenname + familyname;
    this.transmitter = id;
    this.initRecipientFace('1');
    this.selectChoiceFace("init");
    this.filterMessageCount();
    this.getReceiver(id);
    this.getCopy();
    this.loadTypes();
    //this.getMessageStatus();
  }

  selectRecipientFace(givenname, familyname, id){
    this.searchrecipientface = givenname + familyname;
    this.recipient = id;
    this.selectChoiceFace("init");
    this.filterMessageCount();
    this.getCopy();
    this.loadTypes();
    //this.getMessageStatus();
  }

  selectCopyFace(givenname, familyname, id){
    this.searchcopyface = givenname + familyname;
    this.copy = id;
    this.selectChoiceFace("init");
    this.filterMessageCount();
    //this.getMessageStatus();
  }

  selectType(libelle, id){
    this.searchtype = libelle;
    this.selectChoice("init");
    this.typeinstant = id; 
    this.filterMessageCountInst();
  }

  selectTypeFace(libelle, id){
    this.searchtypeface = libelle;
    this.type = id;
    this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  onTypeEchangeChange(value): void {
    if(value == 'message') {
      this.isMessage = true;
      this.isAlltype = false;
      this.isTache = false;
      this.isTaskSearch = null;
    } else if(value == 'task') {
      this.isAlltype = false;
      this.isTache = true;
      this.isTaskSearch = true;
      this.isMessage = false;
    } else if(value == 'all') {
      this.isAlltype = true;
      this.isMessage = false;
      this.isTache = false;
      this.isTaskSearch = null;
    } else {
      // Aucun sélectionné OU les deux sélectionnés
      this.isTaskSearch = null;
    }

    /*else if(this.isDocument && !this.isAlltype && !this.isTache && !this.isMessage){
      this.isTaskSearch = null;
      this.keyWord = "";
    } else if (this.isMessage && !this.isTache) {
      // Message uniquement
      this.isTaskSearch = false;

    } else if (!this.isMessage && this.isTache) {
      // Tâche uniquement
      this.isTaskSearch = true;

    } else {
      // Aucun sélectionné OU les deux sélectionnés
      this.isTaskSearch = null;
    }*/
    console.log('isMessage:', this.isMessage);
    console.log('isTache:', this.isTache);
    console.log('isDocument:', this.isDocument);
    console.log('isAlltype:', this.isAlltype);
    this.filterMessageCount();
  }

  blockLetters(event: KeyboardEvent): void {
    console.log("key don")
    if (['e', 'E', '+', '-'].includes(event.key)) {
      event.preventDefault();
    }
  }

  selectTypeMsgFace(type = null){
    if(type == null) this.searchtypemsgface = 'Type d\'échange';
    else if(type == true) this.searchtypemsgface = 'Tâche';
    else this.searchtypemsgface = 'Message';
    console.log("tyyype : "+this.type)
    this.isTaskSearch = type;
    this.selectChoiceFace("init");
    this.filterMessageCount();
  }

  selectTypeBloc(libelle){
    this.searchtypebloc = libelle;
    if(libelle == 'face'){
      this.isGeneral = false;
      this.isThematic = false;
    } else if(libelle == 'team'){
      this.isGeneral = true;
      this.isThematic = true;
    } else if(libelle == 'general'){
      this.isGeneral = true;
      this.isThematic = false;
    }
    this.selectChoiceFace("init");
    this.getTags();
    this.typebloc = libelle;
    this.filterMessageCount();
    this.getProjectExp();
    this.getReceiver();
    this.getCopy();
    this.loadTypes();
  }

  selectStatusFace(libelle, item, type = null){
    this.statut = item;
    this.searchstatusface = libelle;
    this.isGeneral = false;
    this.isThematic = false;
    if(item == 'comment') {
      this.copy = null;
      this.statut = "comment";
      this.recipient = null;
      this.transmitter = null;

      this.initSenderFace('1');
      this.selectChoiceFace("init");
      this.filterMessageCount();
    } else if(item == 'false' && type == 'copy') {
      this.copy = this.currentUser;
      this.initSenderFace('1');
      this.selectChoiceFace("init");
      this.filterMessageCount();
    } else if(type == 'mine') {
      this.copy = null;
      this.selectSenderFace(this.currentUserInfo.givenName, this.currentUserInfo.familyName, this.currentUser);
    } else if(type == 'received') {
      this.copy = null;
      this.searchsenderface = "Éxpéditeur";
      this.transmitter = null; 
      this.getReceiver(null);
      this.selectRecipientFace(this.currentUserInfo.givenName, this.currentUserInfo.familyName, this.currentUser);
    } else if(type == 'true') {
      this.copy = null;
      this.selectSenderFace(this.currentUserInfo.givenName, this.currentUserInfo.familyName, this.currentUser);
    } else {
      this.copy = null;
      this.selectSenderFace(this.currentUserInfo.givenName, this.currentUserInfo.familyName, this.currentUser);
    }
  }
  
  selectThemeFace(libelle, id){
    this.searchthemeface = libelle;
    this.tag = id;
    this.initSenderFace('1');
    this.initRecipientFace('1');
    this.selectChoiceFace("init");
    this.filterMessageCount();
    this.getProjectExp();
    this.getReceiver();
    this.getCopy();
    this.loadTypes();
    //this.getMessageStatus();
  }

  onDateBeforChange(newDate: any): void {
    this.dateBefore = newDate;
    this.filterMessageCount();
  }

  onDateAfterChange(newDate: any): void {
    this.dateAfter = newDate;
    this.filterMessageCount();
  }

  onDeadlineBeforChange(newDate: any): void {
    this.dateDeadline = newDate;
    this.filterMessageCount();
  }

  onDeadlineAfterChange(newDate: any): void {
    this.dateDeadlineAfter = newDate;
    this.filterMessageCount();
  }

  onDateBeforChangeIns(newDate: any): void {
    this.dateBeforeinstant = newDate;
    this.filterMessageCountInst();
  }

  onDateAfterChangeInst(newDate: any): void {
    this.dateAfterinstant = newDate;
    this.filterMessageCountInst();
  }

  resetSearchFace(){
    this.searchtypeface = "Type de Document";
    this.searchtypemsgface = "Type d'échanges";
    this.searchsenderface = "Éxpéditeur";
    this.searchrecipientface = "Destinataire";
    this.searchcopyface = "Membre en Copie";
    this.searchthemeface = "Canal";
    this.searchtypeface = "Type de Document";
    this.searchdateface = "Faces";
    this.searchstatusface = "Statut des faces";
    this.searchnumface = "Numéro du face";
    this.searchtypebloc = "Type de bloc";
  }

  initAttributes(){
    this.recipient = null;
    this.copy=null,
    this.projectId = null;
    this.dateBefore  = null;
    this.dateAfter  = null;
    this.dateDeadline = null;
    this.dateDeadlineAfter = null;
    this.tag = null;
    this.statut = null;
    this.type = null;
    this.keyWord = null;
    this.smartNumber = null;
    this.isSearch = false;
    this.isGeneral = null;
    this.isTaskSearch = null;
    this.isMessage = false;
    this.isTache = false;
    this.isDocument = false;
    this.isAlltype = true;
    this.isThematic = null;
  }

  changeBetweenBlocsGed(){
    this.chrono_mode = true;
    this.showStatutMenu = false;
    this.initAttributes();
    if(this.modeDoc == false) {
      this.scrollToTop();
      this.writeMode = -1;
      this.divopened = false;
      this.launchSearchDoc();
    } else {
      this.launchSearch();
    }
  }

  changeBetweenFilGed(){
    this.initAttributesInstant();
    if(this.modeDoc == false) {
      this.loadDocsSendersIns();
      this.loadTypesIns();
      this.launchSearchDocInstant();
    } else {
      this.searchItem = true;
      this.modeDoc = false;
      this.EventLaunchSearch.emit(this.chosenFilterInstant);
      //this.launchSearchInstant();
    }
  }

  initAttributesInstant(){
    this.transmitterinstant = null;
    this.dateBeforeinstant  = null;
    this.dateAfterinstant  = null;
    this.typeinstant = null;
    this.keyWordinstant = "";
    this.search = false;
  }

  fcthiddenSearchEngin(){
    if(this.instant == true && this.drive == false) {
      this.searchinstant = !this.searchinstant;
      this.searchstep = "init";
      //this.resetSearchIns();
      if(this.menuOuvert == true){
        this.showFileSelector();
      }
    }
    if(this.instant != true && this.drive == false && !this.modeDoc){
      if(this.searchItem == true) this.searchItem = false;
      this.hiddenSearchEngindrive =false;
        if (this.hiddenSearchEngin == false){
          this.hiddenSearchEngin = true;
          this.searchstepface = "init";
          //this.resetSearchFace();
        } else
          this.hiddenSearchEngin = false;
          this.divopened = false;
          this.writeMode = -1;
    } else {
      this.authService.searchtSubject.next('1');
    }
    /* else if(this.drive == true) {
      this.hiddenSearchEngin =false;
      if (this.hiddenSearchEngindrive == false)
        this.hiddenSearchEngindrive = true;
      else
        this.hiddenSearchEngindrive = false;
    }*/
  }

  fcthiddenSearchEnginDrive(){
    if (this.hiddenSearchEngindrive == false)
      this.hiddenSearchEngindrive = true;
    else
      this.hiddenSearchEngindrive = false;
  }

  fullTextWithLink(value: string): string {
    // Appliquer la surbrillance des mots-clés avant d'ajouter le lien
    if(this.chosenFilterInstant && this.chosenFilterInstant.keyWordinstant && this.instant || this.chosenFilter && this.chosenFilter.keyWord && !this.instant){
      const links = [];
      const textWithoutLinks = value.replace(/(https?:\/\/[^\s]+)/g, (match) => {
        links.push(match); // Enregistrer les liens
        return 'LINK_PLACEHOLDER'; // Remplacer le lien par un espace réservé
      });

      // 2. Appliquer la surbrillance uniquement sur les mots-clés (hors liens)
      const textWithHighlight = this.replaceAllCaseInsensitive(textWithoutLinks, this.chosenFilterInstant.keyWordinstant);

      // 3. Restaurer les liens dans le texte
      let result = textWithHighlight;
      links.forEach((link) => {
        result = result.replace('LINK_PLACEHOLDER', `<a href="${link}" target="__blank">${link}</a>`);
      });

      return result;
    } else return value.replace(/(https?:\/\/[^\s]+)/g, "<a href='$1' target='__blank'>$1</a>");
  }


  highlightText(message: string, termeRecherche: string) {
    const regex = new RegExp(this.chosenFilterInstant.keyWordinstant, 'gi');
    return message.replace(regex, "<p style='background-color: yellow;' class='recherchee'>"+this.chosenFilterInstant.keyWordinstant+"</p>");
  }

  fullTextWithLinkStruc(value: string): string {
      if (!value) return '';

      let escaped = value.replace(/</g, '&lt;').replace(/>/g, '&gt;');

      // Mettre en surbrillance le mot-clé recherché (si présent)
      if (this.chosenFilter && this.chosenFilter.keyWord) {
        const escapedKeyword = this.escapeRegExp(this.chosenFilter.keyWord);
        const highlightRegex = new RegExp(`(${escapedKeyword})`, 'gi');
        escaped = escaped.replace(highlightRegex, '<span style="background: yellow;">$1</span>');
      }

      // Convertir les liens en <a>
      const linkified = escaped.replace(
        /(https?:\/\/[^\s]+)/g,
        "<a href='$1' target='__blank' style='color: blue;'>$1</a>"
      );

      return linkified;
    }

    // Fonction utilitaire pour échapper les caractères spéciaux dans une expression régulière
    escapeRegExp(text: string): string {
      return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
  
  uploadFile(event) {
    const maxSize = 200 * 1024 * 1024; // 128Mo
    let totalSize = this.files.reduce((sum, file) => sum + file.size, 0);
    for (let index = 0; index < event.length; index++) {
      totalSize += event[index].size;
    } 
    if(totalSize > maxSize) {
      alert('La taille totale des fichiers sélectionnés dépasse la limite de 200 Mo.');
      return;
    } 
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push(element);
    } 
    this.inputMedia.nativeElement.value = "";
  }

  onRemoveAnswer(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  selectCopyClosefct(opened: boolean, matSelect: MatSelect){
    if (!opened) {
      this.hideSelectCopy = true;
      this.hideSelectCopyMenu = false;
      this.temporarySelectedValues = [];
    }
  }

  openSelectCopy(){
    this.hideSelectCopy = false;
    this.hideSelectCopyMenu = true;
    this.oneToOneOption.deselect();
    this.allSelected.deselect();
    this.sendMessageForm.controls.inCopy.patchValue([]);
    this.sendMessageForm.get('private').setValue(false);
  }

  loadFilterElement(){
    //console.log("on loadFilterElement");
    if (this.firstLoad == true) {
      //this.getInfoProject();
    }
    this.firstLoad = false;
  }


  pendingDev(){
    if(this.lang == "fr")
      alert("Processus action délai bientôt disponible");
    else
      alert("Deadline action process soon available");
  }

  pendingDevReunion(){
    if(this.lang == "fr")
      alert("Compte rendu de réunion bientôt disponible");
    else
      alert("Meeting minutes coming soon");
  }

  onSelect(ev: any) {
    const selectedFiles = (ev.target as HTMLInputElement).files;
    if (!selectedFiles) return;

    const maxSize = 200 * 1024 * 1024; // 200 Mo

    let totalSize = this.files.reduce(
      (sum, file) => sum + file.size,
      0
    );

    // Calculer la taille des nouveaux fichiers
    Array.from(selectedFiles).forEach((item) => {
      totalSize += item.size;
    });

    if (totalSize > maxSize) {
      alert('La taille totale des fichiers sélectionnés dépasse la limite de 200 Mo.');
      return;
    }
    this.ajouterFichiers(selectedFiles);
  }
 
  private ajouterFichiers(liste: FileList) {
    this.files = [...this.files, ...Array.from(liste)];
  }

  onSelectResponse(event){
    const maxSize = 200 * 1024 * 1024; // Mo
    let totalSize = this.files.reduce((sum, file) => sum + file.size, 0);
    event.addedFiles.map((item)=>{
      totalSize += item.size;
    })  
    if(totalSize > maxSize) {
      alert('La taille totale des fichiers sélectionnés dépasse la limite de 200 Mo.');
      return;
    } 
    event.addedFiles.map((item)=>{
      this.files.push(item);
    })   
  }

  onSelectResponseInstant(event){
    //console.log("executed "+JSON.stringify(event));
    event.addedFiles.map((item)=>{
      this.filesinstant.push(item);
    })   
  }

  fermerMenu() {
    this.menuOuvert = false;
  }

  ouvrirMenu() {
    this.menuOuvert = true;
  }

  rotateIcon() {
    this.state = (this.state === 'normal' ? 'rotated' : 'normal');
  }

  showFileSelector() {
    var i = 0;
    this.menuOuvert = !this.menuOuvert;
    this.state = (this.state === 'normal' ? 'rotated' : 'normal');
    
  }

  togglePopup() {
    this.popupVisible = !this.popupVisible;
  }

  closePopup() {
    this.popupVisible = false;
  }

  choisirType(type) {
    if(type == "contact" || type=="sondage"){
      alert("En cours de développement");
      return;
    }
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    if(type == 'document') {
      this.typefileselected = type;
    } else this.typefileselected = 'photo';
    input.accept = type; // Acceptez les fichiers de type image, vidéo et PDF
    input.onchange = (event) => this.onSelectFiles(event);
    input.click();
  }

  filterMessages(type = 'all'){
      this.statusMsg = null;
      this.isTaskMode = null;
      this.isThematic = null;
      this.isGeneral = null;
      this.statut = null;
      this.dateDeadline = null;
    if(type === 'all'){
    } else if(type === 'message'){
      this.isTaskMode = false;
    } else this.isTaskMode = true;
    
    this.showStatutMenu = false;
    this.activeSubMenu = null;
    this.launchSearch(true);
  }

  filterStatusMessages(libelle = 'status', answered = null, isTaskMode = null){
    this.isTaskMode = isTaskMode;
    this.statusMsg = libelle;
    this.statut = null;
    this.dateDeadline = null;
    this.dateDeadlineAfter = null;
    this.isThematic = null;
    this.isGeneral = null;
    if(answered == null){
      this.isThematic = false;
      this.isGeneral = false;
      this.statut = null;
    }
    if(answered == 'answered' || answered == 'finished') this.statut = true;
    else if(answered == 'notanswered') {
      this.statut = false;
      this.isThematic = false;
      this.isGeneral = false;
    } else if(answered == 'inprogress') {
      this.statut = false;
      this.isThematic = false;
      this.isGeneral = false;
      this.dateDeadlineAfter = new Date();
    } else if(answered == 'cancelled' || answered == 'archived') {
      this.statut = 'archived';
    } else if (answered == 'depassed'){
      this.dateDeadline = new Date();
      this.statut = false;
    }
    this.showStatutMenu = false;
    this.activeSubMenu = null;
    this.launchSearch(true);
  }

  onSelectFiles(event: any) {
    const files = event.target.files;
    const maxSize = 200 * 1024 * 1024; // 128Mo
    let totalSize = this.filesinstant.reduce((sum, file) => sum + file.size, 0);
    for (let index = 0; index < files.length; index++) {
      totalSize += files[index].size;
    }  
    if(totalSize > maxSize) {
      alert('La taille totale des fichiers sélectionnés dépasse la limite de 200 Mo.');
      return;
    } 
    this.filesinstant = Array.from(files);
    this.menuOuvert = false;
  }

  downloadFile(url) {
    const path = environment.server_url+'/media/instant/'+url
    const nomFichier = path; // Remplacez par le nom de votre fichier avec l'extension
    alert("url "+path)
    const a = document.createElement('a');
    a.href = url;
    a.download = nomFichier;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  

  
  
  
  clickSuppMethod() {
      const dialogRef = this.dialog.open(ConfirmdialogComponent, {
        data: { 
          message: 'Voulez vraiment suppprimer le projet '+this.projectFull.libelle,
          title: 'Confirmation'
        },
        panelClass: 'confirmclass',
        backdropClass: 'custom-backdrop'
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.onClickConfirmeDelete();
        } else {
          //console.log('L\'utilisateur a annulé la suppression');
        }
      });
  }

  onClickConfirmeDelete(): void{
    this.authService.deleteProject(this.iDProjet).subscribe(
      res => {  
         //this.authService.obRefreshProjet.next();
         //this.messageService.messageUpdated();
         this.authService.obProjectDeleted.next(this.projectFull);
         this.router.navigate(['/']);
        //this.stepper.selectedIndex = 1;
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  onRemoveInstant(event) {
    this.filesinstant.splice(this.files.indexOf(event), 1);
  }

  chooseCopy(value){
    this.hideSelectCopy2 = false;
  }

 
  fctEcrire(){

    this.writeMode = -1;
    this.resetCommentForm();
    this.resetAnswerFrom();
    this.hideSelectCopy = true;
    this.hideSelectCopyMenu = false;

    if(this.openWriteFace == false)
    {
      this.hiddenSearchEngin = true;
      this.showRedBar = false;
      this.openWriteFace = true;
      this.showMessages = true;
      this.getLastFaceNumber();
      setTimeout(() => {
        if (this.sendmsgdiv) {
          this.selectRecipient.open();
          this.sendmsgdiv.nativeElement.scrollIntoView({block: "center"});
        }
        else{
          this.selectRecipient.open();
          this.sendmsgdiv.nativeElement.scrollIntoView({behavior: "smooth", block: "center"});
        }
      }, 1000);
      
      //this.descp.nativeElement.scrollIntoView({block: "center"});
      //this.sendmsgdiv.nativeElement.scrollIntoView({behavior: "smooth", block: "center"});
    }
    else
    {
      this.resetQuestionFrom();
      this.openWriteFace = false;
      this.showMessages = true;
    }
     
  }


  exiteWriteMode(){
    this.writeMode = -1;
    this.resetCommentForm();
    this.resetAnswerFrom();
    this.resetQuestionFrom();
    this.openWriteFace = false;
    this.showMessages = true;
    this.messageService.getCloseWriteMessage(true);
  }

  getLastFaceNumber(){
     this.authService.getLastFaceNumber(this.ID)
      .subscribe(res => {
        //console.log(' retour getLastFaceNumber => '+res);
        let arrayMessage = res['hydra:member']

        if (arrayMessage.length > 0) {
           this.lastFaceNumber = arrayMessage[0].smartNumber;
        }

        // console.log(this.projectUsers);
        //console.log('fin chargement projet ');
      }, (error) => {
    });   
  }

  onSelectPrivate(){
    if (this.sendMessageForm.controls.private.value === false)
    {
       this.sendMessageForm.get('private').setValue(true); 
    }
    else
    {
      this.sendMessageForm.get('private').setValue(false); 
    } 
  }

  getAnswerListe(){
    this.arrayQuickAnswer = [
      {message: "Génial, merci 👏", title : "Genial, Thanks 👏", esp : "Genial, gracias 👏", translated : null},
      {message: "Noté, merci ! ☺️", title : "Noted, Thanks", esp : "Notado gracias", translated : null},
      {message: "Ok, je suis d'acccord 👍", title : "Ok I agree", esp : "Ok estoy de acuerdo", translated : null},
      {message: "C'est parfait, je m'en occupe", title : "It's perfect, I'll take care of it", esp : "Es perfecto, yo me encargo", translated : null},
      {message: "Désolé je ne peux pas", title : "Sorry I can not", esp : "lo siento no puedo", translated : null},
      {message: "Merci, mais ça ne répond pas à mes attentes", title : "Thanks, but it doesn't meet my expectations", esp : "Gracias, pero no cumple con mis expectativas", translated : null},
      {message: "Impossible pour moi, désolé", title : "Impossible for me, sorry", esp : "Imposible para mi, lo siento", translated : null}]; 
  }

  async sendQuickAnswer(answerItem,  infoMessage) {
    //const msg = this.lang == 'fr' ? answerItem.message : answerItem.title;
    const msg = answerItem.message;
    //const lang = await this.detectMsgLanguage(msg);
    this.authService.sendQuickAnswer(
      msg,
      infoMessage.tags[0],
      infoMessage.isPrivate,
      this.project,
      infoMessage.id,
      'fr' //lang
    )
    .subscribe(res => {
      //console.log('réponse answer => '+res);
      //this.writeMode = 0;
      this.writeMode = -1;
      this.decrementNotif();
      if(this.notifiedmode){
        const index = this.dataSource.findIndex(item => item.id === res["question"].id);
        if (index >= 0) {
          this.checkDelMsg(this.dataSource[index], index);
        }
      } else this.messageService.messageRefreshConv();
      //this.messageService.messageUpdated();
      this.authService.obreceiveAsread.next(this.ID);
      //this.markAsRead(infoMessage);
      var copies = [];
      if(infoMessage.copy.length > 0){
        infoMessage.copy.forEach(element => {
          //if(element.user && element.user.id)
          copies.push(element.user.id);
        })
      }
      //this.total -= 1;
      //scroll in view
      //this.divHeaderTable.nativeElement.scrollIntoView();
      this.authService.obinstantMsgsent.next({"id": this.ID, "text":msg, "date": res['dateCreated']});
      this.socketService.sendInstant({
        id: infoMessage.id,
        action: this.ID,
        type: "RESPONSE",
        author: this.currentUser,
        recipient: infoMessage.author.id,
        text: msg,
        copy: copies,
        private: infoMessage.isPrivate,
        res: res,
        project_lib: this.projectFull.libelle,
        date: res['dateCreated']
      });

       window.scroll(0,0);

    });
  }

  getRecipient(){
    for (var i = 0; i < this.projectUsers.length; i++) {
      if(this.projectUsers[i].user.id == this.sendMessageForm.controls.recipient.value){
        return this.projectUsers[i].user.fullName;
      }
    }
    return false;
    //console.log('Your order has been submitted ---> ', this.sendMessageForm.value);
  }

  getDeadline(){
    if(this.sendMessageForm.controls.deadLine.value){
      return this.sendMessageForm.controls.deadLine.value;
    }
    return '';
    //console.log('Your order has been submitted ---> ', this.sendMessageForm.value);
  }


  transfertByMail(messageData){
    const dialogRef = this.dialog.open(transfertdialog, {
      width: '600px',
      data: {message: messageData}
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed');       
    });
  }

  
  

  open(file){

    const reader = new FileReader();
    reader.onload = (e: any) => {
       //console.log('csv content', e.target.result);
       const album = {
          src: e.target.result
       };
       let albums = [];
       albums.push(album);
       this._lightbox.open(albums, 0);

       setTimeout(() => {
        document.querySelector( 'img.lb-image' ).removeAttribute("hidden");
        if(document.querySelector( '.lb-loader' )) document.querySelector( '.lb-loader' ).setAttribute("hidden", "true");
        if(document.querySelector( '.lb-nav' )) document.querySelector( '.lb-nav' ).setAttribute("hidden", "true");
       }, 1500);

    };
    reader.readAsDataURL(file);

  }

  playVideoOrAudio(file, source){
    source.src = URL.createObjectURL(file);
  }

  createFileUrl(file, source){
    source.href = URL.createObjectURL(file);
  }

  getFiletype(file){

    if (file.type.includes("image/") == true) {
      return 1;
    }
    else if (file.type.includes("video/") == true) {
      return 2; 
    }
    else if (file.type.includes("application/") == true) {
      return 3;
    }
    else if (file.type.includes("audio/") == true) {
      return 4;
    }
    else
    {
      return -1;
    }

  }


  close(): void {
    // close lightbox programmatically
    this._lightbox.close();
  }

  deleteAttachment(index) {
    this.files.splice(index, 1);
    //console.log(this.files)
  }

  tosslePerOne(all){ 
    if (this.allSelected.selected) {  
      this.allSelected.deselect();
      return false;
    }
    if(this.sendMessageForm.controls.inCopy.value.length==this.getUserListWithNoCurrentUser().length){ 
      this.allSelected.select();
    }
  }

  
  toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];



  filter(data){
    
    if (this.arrayUserCopy.length === this.sendMessageForm.get("inCopy").value.filter(item => item != "0").length) {
    }
  }

  resetPrivate() {
    //this.sendMessageForm.controls.inCopy.patchValue([]);
    //const element: HTMLElement = document.getElementById('divtous') as HTMLElement
    //element.innerHTML = '';
    this.private = false;
    this.notifyValue = "ALL";
    //this.copiesusers = [];
    this.sendMessageForm.get('private').setValue(false);
  }
  
  fctOneToOne(){
    this.sendMessageForm.controls.inCopy.patchValue([]);
    this.allSelected.deselect();
    this.oneToOneOption.select();
    this.sendMessageForm.get('private').setValue(true);
  }

  compareObjects(o1: any, o2: any) {
    if(o1 === o2 )
    return true;
    else return false
  }

  onCloseEmoji() {
    this.showEmojiPicker = false;
  }

  toggleEmojiPicker() {
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  testClick(event: any) {
    if (event.emoji && event.emoji.native) {
    } else {
    }
  }

  addEmoji(event: any) {
    const currentValue = this.sendMessageFormInstant.get('messageToSend').value;
    this.sendMessageFormInstant.get('messageToSend').setValue(currentValue + event.emoji.native);
  }

  handleSelection(event) {
    const currentValue = this.sendMessageFormInstant.get('messageToSend').value;
    this.sendMessageFormInstant.get('messageToSend').setValue(currentValue + event.char);
  }


  truncate(value: string, limit = 25, completeWords = false, ellipsis = '...') {
    if (completeWords) {
      limit = value.substr(0, limit).lastIndexOf(' ');
    }
    let val =  value.length > limit ? value.substr(0, limit) + ellipsis : value;
    return val.replace(/(http?s:\/\/[^\s]+)/g, "<a href='$1' target='__blank'>$1</a>");
  }

  scrollToBottom(): void {
    this.isAutoScrolling = true;
    this.scrollMechat.nativeElement.scrollTop = this.scrollMechat.nativeElement.scrollHeight;
    this.reinitalizeInstantNotif();
    setTimeout(() => this.isAutoScrolling = false, 300);
    //}
    
  }

  onScroll(event: any): void {
    const container = this.scrollMechat.nativeElement;
    const atTop = container.scrollTop === 0;
    const scrollPosition = container.scrollTop;
    const maxScroll = container.scrollHeight - container.clientHeight;
    this.isAtBottom = (scrollPosition === maxScroll);
    if(this.isAtBottom && this.messagesInstant.length > 0 && !this.reinitalizeTimeout){
      this.reinitalizeInstantNotif();
      this.reinitalizeTimeout = setTimeout(() => {
        this.reinitalizeTimeout = null;
      }, 200);
    }
    if (atTop && !this.loadingMessagesTop && this.dataloaded == false && this.startedPoint == false && this.canload == true) {
      //console.log("loaaded")
      this.canload = false;
      this.dataloaded = true;
      this.scrollposition = container.scrollHeight;
      this.getMessagesInstant(true);
    }
  }

  restoreScrollPosition() {
    const container = this.scrollMechat.nativeElement;
    container.scrollTop = container.scrollHeight - this.scrollposition + 50;
    this.dataloaded = false;
  }

  getMessagesInstant(loaded = null, otherproj = false) {
    if(this.nbrloadmsg > 0) {
      this.loadingMessagesTop = true;
    }
    this.search = false;
    if(this.messagesInstant.length > 0){
      this.perPage = this.messagesInstant.length;
      this.pageIndex = 1;
    }
    if(otherproj) this.messagesInstant = [];
    //console.log("long MessagesInstant "+this.messagesInstant.length)
    //console.log("getMessagesInstant "+this.ID)
    //this.authService.getAllMessagesInstant(this.ID, null, this.pageIndex, this.perPage)
    this.authService.getMessagesInstantFromPosition(this.ID, this.offsetmsg, this.limitmsg).pipe(takeUntil(this.cancelInstantRequest$))
      .subscribe(res => {
        //this.searchresLengthInst = res['hydra:totalItems'];
        const newMessages = res['hydra:member'].reverse();
        this.nbrloadmsg++;
        if(!newMessages || newMessages.length == 0 || newMessages.length < this.limitmsg) this.startedPoint = true;
        this.addNewMessages(newMessages)
        .then(() => {
          this.offsetmsg = this.offsetmsg + this.limitmsg;
          this.canload = true;
          setTimeout(() => {
            this.restoreScrollPosition();
          }, 200);
          
        //this.messagesInstant.unshift(...newMessages);
        //this.restoreScrollPosition();
        this.loadingMessagesTop = false;
        this.messagesInstant.forEach(message => {message['showButton'] = false, message['showButtonclicked'] = false});
        this.translationenabed = (this.currentCompany === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
        if(this.translationenabed) this.updateTranslationFlagsIns();
        setTimeout(() => {
          if(loaded) return;
          if(this.notificationsCount > 0) {
            //console.log(">>>> 0")
            this.limitmsg = 20;
            this.scrollToUnread();
            //this.scrollToReadMsg();
          } else {
            //console.log("<===== 0");
            this.scrollToBottom();
          }
          //this.scrollToBottom();
          this.FocusWriteMsg();
        }, 1000);
      });

      }, (error) => {
        this.loadingMessagesTop = false;
    });
  }


  CountMessagesInstant(init = null) {
    this.authService.getAllMessagesInstant(this.ID, this.chosenFilterSearchIns, this.offsetmsg, this.limitmsg)
      .subscribe(res => {
        //const newMessages = res['hydra:member'].reverse();
        this.targetValueIns = res['hydra:totalItems'];
        if(init == 0 || this.checkSearchInitIns()) this.resultsLengthIns = 0;
        else this.animateToValueInst(this.targetValueIns);

      }, (error) => {
    });
  }

  addNewMessages(newMessages) {
    return new Promise<void>((resolve) => {
      this.messagesInstant.unshift(...newMessages);
      resolve();
    });
  }

  searchMessagesInstant() {
    //alert("date "+this.chosenFilterInstant.dateAfterinstant);
    this.authService.getAllMessagesInstant(this.ID, (this.chosenFilterInstant ? this.chosenFilterInstant : null ), null, (this.chosenFilterInstant ? 1000 : null ))
      .subscribe(res => {
        //this.messagesInstant = res['hydra:member'];
        if(res['hydra:member'].length == 0){
          alert("pas de résultats");
          return;
        }
        this.messagesResults = res['hydra:member'];
        this.fcthiddenSearchEngin();
        
        this.scrollToBottomResult();

      }, (error) => {
    });
  }

  verifyDateChanged(date, k) {
    const date1 = new Date(this.firstDate);
    const date2 = new Date(date);

    // Comparaison en ignorant l'heure, les minutes, les secondes
    const memeDate = date1.getFullYear() === date2.getFullYear() &&
                     date1.getMonth() === date2.getMonth() &&
                     date1.getDate() === date2.getDate();

    if (memeDate && k !== 0) {
      return false;
    } else {
      this.firstDate = date;
      return true
    }
  }

  pasteMessage(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    return;
    if (clipboardData && clipboardData.getData) {
      const pastedText = clipboardData.getData('text');
  
      // Récupérer le message complet depuis le stockage local
      const storedMessage = localStorage.getItem('copiedMessage');
      if (storedMessage) {
        const message = JSON.parse(storedMessage);
        if (message.files && message.files.length > 0) {
        }
      }
    }
  }

  /*
  getMediaLink2(mediaUrl, thumbnailPath=null){
    if(this.instanttype == "yes"){
      if(thumbnailPath){
        return this.authService.getMediaDataInstantThumbnail(thumbnailPath);
      } else return this.authService.getMediaDataInstant(mediaUrl);
    } else return this.authService.getMediaData(mediaUrl);
  }

  async copierText(message: any) {
      console.log("copierText : "+message.filegeneric.length+" - "+message.filegeneric[0].contentUrl)
    if(message.filegeneric.length == 1 && message.filegeneric[0].extension.startsWith('image')){
      console.log("image copied : "+message.filegeneric[0].contentUrl)
      const response = await fetch(this.authService.getMediaDataInstant(message.filegeneric[0].contentUrl));
      const blob = await response.blob();

      await navigator.clipboard.write([
        new ClipboardItem({
          [blob.type]: blob
        })
      ]);
    } else {
      let contentToCopy = message.text;
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = contentToCopy;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    } 
    if(message.filegeneric.length > 0){
      localStorage.setItem('copiedMessage', JSON.stringify(message));
    } else localStorage.removeItem('copiedMessage');
  }
  */
  

  copierText(message: any) {
    let contentToCopy = message.text;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = contentToCopy;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    /*if(message.filegeneric.length > 0){
      localStorage.setItem('copiedMessage', JSON.stringify(message));
    } else localStorage.removeItem('copiedMessage');*/
  }

  async copyImage(media: any) {
    if(media.extension.startsWith('video')) {
      this.copyVideoLink(media);
      return;
    }

    var imageUrl = this.authService.getMediaDataInstantThumbnail(media.thumbnailPath);
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = URL.createObjectURL(blob);

      await new Promise((resolve) => (img.onload = resolve));

      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      const pngBlob: Blob = await new Promise(resolve =>
        canvas.toBlob(resolve as BlobCallback, 'image/png')
      );

      await (navigator as any).clipboard.write([
        new (window as any).ClipboardItem({
          'image/png': pngBlob
        })
      ]);

      console.log('Image copiée en PNG');
    } catch (err) {
      console.error('Erreur copie image', err);
    }
  }

  async copyVideoBlob(media: any) {
  try {
    const videoUrl = this.authService.getMediaDataInstant(media.contentUrl);
    const response = await fetch(videoUrl, { mode: 'cors' });
    const blob = await response.blob();

    // Tenter le copy avec Clipboard API
    await (navigator as any).clipboard.write([
      new (window as any).ClipboardItem({
        [blob.type]: blob
      })
    ]);

    console.log('Vidéo copiée dans le presse-papier (Chrome/Edge seulement)');
  } catch (err) {
    console.error('Erreur copie vidéo', err);
    // fallback : copier le lien
    await this.copyVideoLink(media);
  }
}

  async copyVideoLink(media: any) {
    console.log("lieeen "+media.contentUrl)
    try {
      const videoUrl = this.authService.getMediaDataInstant(media.contentUrl); // ton URL complète
      await navigator.clipboard.writeText(videoUrl);
      console.log('Lien vidéo copié !');
      // ici tu peux afficher un toast “Copié”
    } catch (err) {
      console.error('Erreur copie lien vidéo', err);
    }
  }

  getColor(id){
    return this.userscolor.get(id);
  }

  loadUserTagProject(){
    this.authService.getOneProject(this.ID)
      .pipe(takeUntil(this.cancelInstantRequest$))
        .subscribe(res => {
          this.projectFull = res;
          var tmpArrayUser = res['userProject'];
          this.projectUsers = [];
          let creatorSet = new Set();
          for (var i = 0; i < tmpArrayUser.length; i++) {
            if(tmpArrayUser[i].user != null && !creatorSet.has(tmpArrayUser[i].user.id)){
              this.projectUsers.push(tmpArrayUser[i]);
              creatorSet.add(tmpArrayUser[i].user.id);
              this.userscolor.set(tmpArrayUser[i].user.id, tmpArrayUser[i].color);
            }
          }
          
          this.projectUsers.sort((a, b) => {
            if ( a.user.fullName.toLowerCase() < b.user.fullName.toLowerCase() ){
              return -1;
            }
            if ( a.user.fullName.toLowerCase() > b.user.fullName.toLowerCase() ){
              return 1;
            }
            return 0;
          });
          this.projectTags = res['tags'];


          this.projectTags.sort((a, b) => {
            if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
              return -1;
            }
            if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
              return 1;
            }
            return 0;
          })
    })
  }

  getCurrentProject() {
    this.tempMemberUser = [];
    this.msgsent = false;
    
    this.isSearch = false;
    if (!this.ID) {
      return;
    }

    this.authService.getOneProject(this.ID)
    .pipe(takeUntil(this.cancelInstantRequest$))
      .subscribe(res => {
        this.projectFull = res;
        this.firstDate = res['dateCreated'];
        if(res['company']){
          this.currentCompany = res['company'].replace('/api/companies/', '');
        }
        this.projectmembers = "";
        var tmpArrayUser = res['userProject'];
        var currentuserproject = null;
        currentuserproject = tmpArrayUser.find(userProject => {
          return userProject.user && userProject.user.id === this.currentUser;
        });
        this.notificationsCount = currentuserproject.number;
        this.currentUserProject = currentuserproject.id;
        this.projectUsers = [];
        let creatorSet = new Set();
        this.project_isparent = res['type'];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].user != null && !creatorSet.has(tmpArrayUser[i].user.id)){
            this.projectUsers.push(tmpArrayUser[i]);
            creatorSet.add(tmpArrayUser[i].user.id);
            this.userscolor.set(tmpArrayUser[i].user.id, tmpArrayUser[i].color);
            this.projectmembers+=tmpArrayUser[i].user.givenName+" "+tmpArrayUser[i].user.familyName+", ";
          }
        }
        
        this.projectUsers.sort((a, b) => {
          if ( a.user.fullName.toLowerCase() < b.user.fullName.toLowerCase() ){
            return -1;
          }
          if ( a.user.fullName.toLowerCase() > b.user.fullName.toLowerCase() ){
            return 1;
          }
          return 0;
        });
        this.project = '/api/projects/' + res['id'];
        this.projectTags = res['tags'];


        this.projectTags.sort((a, b) => {
          if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
            return -1;
          }
          if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
            return 1;
          }
          return 0;
        })

        for (var i = 0; i < this.projectUsers.length; i++) {
          if((this.projectUsers[i].isAdmin == true) && (this.projectUsers[i].user.id == this.currentUser))
          {
            this.userAdmin = true;
          }
        }

      }, (error) => {
        this.router.navigate(['/homes']);
    });
    
    merge(this.paginator.page, this.messageService.getMessageRefreshConv().pipe(
      tap(() => this.paginator.pageIndex = 0)
    ), this.refreshPageObs)
      .pipe((takeUntil(this.cancelInstantRequest$)),
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          if(this.authService.isNotified === true && !this.specMsg){
              return this.authService.getProjectNotifedMessages(this.ID, this.paginator.pageIndex, this.perPage, (this.specMsg ? this.specMsg : null ), (this.specMsgType ? this.specMsgType : null ),(this.chosenFilterProject ? this.chosenFilterProject : null ))
          } else if (this.openmsg == "tasks"){
            console.log("tasks");
            this.dateDeadline = new Date();
            this.statut = false;
            this.chosenFilter = { 
              transmitter: this.transmitter,
              recipient: this.recipient,
              copy: this.copy,
              projectId: this.projectId,
              dateBefore: this.dateBefore,
              dateAfter: this.dateAfter,
              dateDeadline: this.dateDeadline,
              dateDeadlineAfter: this.dateDeadlineAfter,
              tag: this.tag,
              statut: this.statut, 
              type: this.type,
              keyWord: (this.keyWord ? this.keyWord.trim() : null),
              smartNumber: this.smartNumber,
              isGeneral: this.isGeneral,
              isThematic: this.isThematic,
              isTask: true
            };
            return this.authService.getProjectHisMessages(this.ID, this.paginator.pageIndex, this.perPage, (this.specMsg ? this.specMsg : null ), (this.specMsgType ? this.specMsgType : null ),(this.chosenFilter), this.chrono_mode)
          } else if (this.openmsg == "sent"){
            console.log("sent");
            this.statut = false;
            this.isThematic = false;
            this.isGeneral = false;
            this.transmitter = this.currentUser;
            this.chosenFilter = { 
              transmitter: this.transmitter,
              recipient: this.recipient,
              copy: this.copy,
              projectId: this.projectId,
              dateBefore: this.dateBefore,
              dateAfter: this.dateAfter,
              dateDeadline: this.dateDeadline,
              dateDeadlineAfter: this.dateDeadlineAfter,
              tag: this.tag,
              statut: this.statut, 
              type: this.type,
              keyWord: (this.keyWord ? this.keyWord.trim() : null),
              smartNumber: this.smartNumber,
              isGeneral: this.isGeneral,
              isThematic: this.isThematic,
              isTask: false
            };
            return this.authService.getProjectHisMessages(this.ID, this.paginator.pageIndex, this.perPage, (this.specMsg ? this.specMsg : null ), (this.specMsgType ? this.specMsgType : null ),(this.chosenFilter), this.chrono_mode)
          } else if (this.openmsg == "received"){
            console.log("sent");
            this.statut = false;
            this.isThematic = false;
            this.isGeneral = false;
            this.recipient = this.currentUser;
            this.chosenFilter = { 
              transmitter: this.transmitter,
              recipient: this.recipient,
              copy: this.copy,
              projectId: this.projectId,
              dateBefore: this.dateBefore,
              dateAfter: this.dateAfter,
              dateDeadline: this.dateDeadline,
              dateDeadlineAfter: this.dateDeadlineAfter,
              tag: this.tag,
              statut: this.statut, 
              type: this.type,
              keyWord: (this.keyWord ? this.keyWord.trim() : null),
              smartNumber: this.smartNumber,
              isGeneral: this.isGeneral,
              isThematic: this.isThematic,
              isTask: false
            };
            return this.authService.getProjectHisMessages(this.ID, this.paginator.pageIndex, this.perPage, (this.specMsg ? this.specMsg : null ), (this.specMsgType ? this.specMsgType : null ),(this.chosenFilter), this.chrono_mode)
          } else if(this.authService.isAnsweredNotified === true && !this.specMsg){ 
            return this.authService.getNotansweredMessages(this.ID)
          }  else { 
              return this.authService.getProjectHisMessages(this.ID, this.paginator.pageIndex, this.perPage, (this.specMsg ? this.specMsg : null ), (this.specMsgType ? this.specMsgType : null ),(this.chosenFilterProject ? this.chosenFilterProject : null ), this.chrono_mode)
          } 
        }),
        filter(data => {
          if (this.searchface === true && data['hydra:totalItems'] === 0) {
            this.isLoadingResults = false;
            this.openNoResultPopup();

            return false;
          }

          return true;
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data['hydra:totalItems']; 
          this.searchresLength = this.resultsLength;
          if(this.searchface == true && this.searchresLength == 0) {
            alert("aucun résultats");
          } else if (this.hiddenSearchEngin == false && this.searchresLength > 0) {
            this.fcthiddenSearchEngin();
          }
          /*if (this.paginator.page !== null) {
            this.scrollToTop();
          }*/
          this.scrollToTop();
          return data['hydra:member'];  
        }),
        catchError(() => {    
          this.isLoadingResults = false;
          // Catch if the  API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => {    
          for (var i = 0; i < data.length; i++) {
            data[i].truncating = true;
            if(data[i].isMessageAnswered == true && data[i].isMessageDisabled == false) {
              data[i].answer.truncating = true;
            }
          }
          this.isReady = true;
          this.dataSource = data;
          if(this.dataSource.length == 0) {
            this.authService.obEmptyProject.next(result);
            this.emptyproject = true
          } else this.emptyproject = false;
          this.destroy$.next();
          //this.updateTranslationFlags();
          if (this.openmsg == "missions"){
            this.fctMapSuject();
          }
          if(this.dataSource.length > 0){ 
            if (this.openmsg == "thématiques" && this.dataSource.length > 0) {
                      console.log("afteer 0");
                      this.fctMapSuject();
                  }

            this.hasMessage = true;
            //this.hiddenSearchEngin = false;

            for (var i = 0; i < this.dataSource.length; i++) {
              this.translationenabed = (this.currentCompany === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
              if(this.translationenabed){;
                var result = this.detectLanguage(this.dataSource[i].text);
                this.dataSource[i].willtranslate = result;
                if(this.dataSource[i].answer) this.dataSource[i].answer.willtranslate = this.detectLanguage(this.dataSource[i].answer.text);
              }
              this.dataSource[i].comment.sort((a: any, b: any) => {// order by date
                  return b.smartNumber - a.smartNumber;
              });
            }
            if(this.specComment) {
              this.specCom = this.dataSource[0].comment[0].number;
              this.specMsg = null;
            }
            if (this.specMsg && this.specComment == false) {
              //this.specMsg = this.dataSource[0].comment[0].number;
              if (this.specMsgType && this.specMsgType == 'COMMENT') {
                for (var i = 0; i < this.dataSource.length; i++) {
                  if (this.dataSource[i].smartNumber ==  this.specMsg){
                    for (var index = 0; index < this.dataSource[index].comment.length; index++) {
                      if(this.dataSource[i].comment[index].dateCreated == this.dataSource[i].motionAt){
                        this.specMsg = this.dataSource[i].comment[index].number;
                        break;
                      }
                    }
                    break;
                  }
                }
              }
              setTimeout(() => {
                if (this.divComSpecMsg) {
                  var obj = this.dataSource[0].comment;
                  for(var i = 0; i < obj.length; i++) {
                    if(this.specMsg && (obj[i].number == this.specMsg)){
                      if(this.isNoRead(obj[i]) || this.userInCopyHasNoRead(obj[i])){
                        this.markAsRead(obj[i]);
                      }
                    }
                  }
                  this.divComSpecMsg.nativeElement.scrollIntoView({block: "center"});
                }
                else{
                  if(this.dataSource[0].smartNumber == this.specMsg){
                    if((this.userIsConcerned(this.dataSource[0]) == true) && (this.youNeedToMarkAsRead(this.dataSource[0]) == true)){
                    }
                  }
                  if(this.divHeaderTable) this.divHeaderTable.nativeElement.scrollIntoView({behavior: "smooth", block: "center"});
                  
                }
              }, 500);
            }   


          }else { 
            this.hasMessage = false;
            this.messageService.openWriteMessageFace(null);
          }

      });
      
      merge(this.refreshSearchObs)
      .pipe(
        startWith({}),
        switchMap(() => {
          if (this.instant) {
            return observableOf({ 'hydra:totalItems': 0, 'hydra:member': [] });
          } else {
            return this.authService.getProjectHisMessages(this.ID, this.paginator.pageIndex, this.perPage, (this.specMsg ? this.specMsg : null ), (this.specMsgType ? this.specMsgType : null ),(this.chosenFilterSearch ? this.chosenFilterSearch : null ), this.chrono_mode)
          }
        }),
        map(data => {
          this.targetValue = data['hydra:totalItems'];
        }),
        catchError(() => {    
          return observableOf([]);
        })
      ).subscribe(data => {   
        if(this.checkSearchInit()){
          this.animateToValue(this.resultsLength);
        } else this.animateToValue(this.targetValue);

      });
      
  } 

  reinitalizeInstantNotif(){
      this.authService.setNbrMsgProjet(this.currentUserProject).subscribe(dataAccepte => {
        this.authService.initNotifInstant.next(this.ID);
      }, (error) => {
        //alert('une erreur est survenue');
      });
  }

  // convenience getter for easy access to form fields
  get f() { return this.sendMessageForm.controls; }
  get fanswer() { return this.sendanswerForm.controls; }
  get fcomment() { return this.formComment.controls; }
  get fcommentresponse() { return this.formCommentResponse.controls; }

  convertText(text){
    return text.replace(/(http?s:\/\/[^\s]+)/g, "<a href='$1'>$1</a>");
  }

  retrySubmit(message){
    this.RetrySendQuestionInstant(message.text, message);
  }

  cancelResponse(){
    this.msgAnswered = null;
  }

  openProfilDialog() {
    this.dialog.closeAll();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'contactpanel';
    dialogConfig.id = 'balchal718';
    dialogConfig.width = '550px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = { name: this.name, profile: this.profile, commonRef: this.commonRef };
    //const dialogRef = this.dialog.open(ProfileComponent, dialogConfig);
    const dialogRef = this.dialog.open(ProfileComponent, {
      data: { name: this.name, profile: this.profile, commonRef: this.commonRef },
      panelClass: 'transferclass',
      backdropClass: 'custom-backdrop'
    });
    

    dialogRef.afterClosed().subscribe((result: any) => {
    });

  }

  answerInstant(message: any, i: number, numdoc = null){
    this.numdoc = numdoc;
    this.msgAnswered = message;
    this.sendMessageFormInstant.patchValue({ messageToSend: '' });
  }

  getIcon(media){
    let filelink = "";
    var extension = media.extension;
    var extensionfile = media.extensionfile;
    if(extensionfile){
    if(extensionfile.startsWith('xl') || (extensionfile == 'csv')){
      filelink = "../../../../assets/icons/excel.png";
    }else if(extensionfile.startsWith('ppt')){
      filelink = "../../../../assets/icons/ppt.png";
    }else if((extensionfile.startsWith('do') || extensionfile == 'odt')){
      filelink = "../../../../assets/icons/word.png";
    }else if(extensionfile.includes("zip") || extensionfile.includes("rar")){
      filelink = "../../../../assets/icons/zip.png";
    }else if(extensionfile.includes("pdf")){
      filelink = "../../../../assets/img/iconpdf.png";
    }else if(extension.includes("image")){
      //filelink = "../../../../assets/icons/image.png";
      filelink = this.getMediaLinkResponse(media.contentUrl, media.thumbnailPath);
    }else if(extension.includes("audio")){
      filelink = "../../../../assets/icons/audio.png";
    }else if(extension.includes("video")){
      filelink = "../../../../assets/icons/video.png";
    }} else if(extension.includes("image")){
      filelink = this.getMediaLinkResponse(media.contentUrl, media.thumbnailPath);
    } else if(extension.includes("video")){
      filelink = "../../../../assets/icons/video.png";
    }

    return filelink ? filelink : false;
  }

  getMediaLinkResponse(mediaUrl, thumbnailPath=null){
    if(thumbnailPath){
        return this.authService.getMediaDataInstantThumbnail(thumbnailPath);
      } else return this.authService.getMediaDataInstant(mediaUrl);
  }

  onSubmitFormInstant(customerData) {
    this.msgsent = true;
    this.showEmojiPicker = false;
    this.sendQuestionInstant(this.sendMessageFormInstant.value.messageToSend);
    this.sendMessageFormInstant.patchValue({ messageToSend: '' });
  }
 
  onSubmitForm(customerData) {
    this.submitted = true;
    this.facesent = true;
     // stop here if form is invalid
    if (this.sendMessageForm.invalid) {
      Object.keys(this.sendMessageForm.controls).forEach(key => {
        const control = this.sendMessageForm.get(key);
        if (control && control.invalid) {
        }
      });
      return;
    }
    
    if (this.private == true) {
      //this.sendMessageForm.controls.inCopy.patchValue([]);
      this.sendMessageForm.controls.private.patchValue(true)
    }

    this.sendQuestion(this.sendMessageForm.value);

    if (this.showTool == false) {
      this.messageService.setShowProjectTutoIsFalse();
    }
    //scroll in view
     window.scroll(0,0);
    //this.divHeaderTable.nativeElement.scrollIntoView();
   
  }

  resetAllmsgbloc(){
    this.messageService.setMessageIsSend();
    this.sujectPlaceholder = ""
    this.submitted = false;
    this.selectprivate = false;
    this.copiesusers = [];
    this.sendMessageForm.get('messageToSend').setValue('');
    //this.theForm.resetForm();
    this.resetQuestionFrom();
    this.resetPrivate();
    this.openWriteFace = false;
    this.divopened = false;
    this.relanceOne = null;
    this.relanceTwo = null;
    this.echeance = null;
    this.isTaskMsg = null;
    this.statusMsg = null;
    this.isMessage = false;
    this.isTache = false;
    this.isDocument = false;
    this.isAlltype = true;
    this.isTaskSearch = null;
    this.relance = null;
    this.showsubject = true;
    this.showMessages = true;
    this.editorConfig = {
          ...this.editorConfig,
          placeholder: this.translate.instant('map.placeholder')
    };
    this.messageService.getCloseWriteMessage(true);
    this.sendMessageForm.controls.inCopy.patchValue([]);
    this.senderror = false;
  }

  onSelectSubProject(sujetChosen){
    this.sendMessageForm.get('newSubProject').setValue('');
    this.sendMessageForm.get('subProject').setValidators([Validators.required]);
    this.sendMessageForm.get('subProject').updateValueAndValidity();
  }

 
  onSelectNewSubProject(newSubProjetName){
    this.sendMessageForm.get('subProject').setValue('');
    this.sendMessageForm.get('subProject').clearValidators();
    this.sendMessageForm.get('subProject').updateValueAndValidity();
  }

  onEnterKey(event: KeyboardEvent, messageTosendData): void {
    event.preventDefault(); // Empêche le saut de ligne par défaut du textarea
    this.onSubmitFormInstant(messageTosendData);
  }

  getObjectUrl(file: File): string {
    return URL.createObjectURL(file);
  }

  getExtension(filename){
    const fileName = filename.name;
    const fileExtension = fileName.split('.').pop();
    return fileExtension;
  }
  
  mapProject(messageTosendData, project, filesinstant, typefileselected){
    var files = [];
    var typefiles = "image";
    if(typefileselected == "document"){
      typefiles = 'DOCUMENT';
    }
    if(filesinstant.length > 0 ){
      files = filesinstant.map(file =>({
        id: "00000",
        contentUrl: "a81fc9305d3a613e32f57f3b29f3e5505349ac43.png",
        file: file,
        createdAt: "2024-01-16T11:13:20+00:00",
        extension: file.type,
        extensionfile: this.getExtension(file),
        mimtype: "image/png",
        type: "fake",
        libelle: typefiles,
        originalName: file.name,
        thumbnailPath: null
      }));
    }
    const newMessage = {
      id: "",
      fakeId: uuidv4(),
      type: "fake",
      author: { 
        id: this.currentUser,
        imageUrl: this.userData.imageUrl
      },
      dateCreated: new Date(),
      iddoc: null,
      isDrive: false,
      isTransfered: false,
      number: 0,
      project: {
        id: project,
        imageUrl: null,
        libelle: false,
        parentItem: null,
      },
      filegeneric: files,
      text: messageTosendData,
      transfermsg: null,
      error: true
    }
    this.msgsent = false;
    return newMessage;
    this.messagesInstant.push(newMessage);
    //this.messagesInstantSent.push(newMessage);
  }

  async sendQuestionInstant(messageTosendData) {
    //if(!this.textmode) alert("en cours de dev");
    this.msgInstantRetry = messageTosendData;
    this.notificationsCount = 0;
    //this.loadingScreenService.stopLoading();
    if(this.filesinstant.length == 0 && (messageTosendData == "" || messageTosendData.trim().length == 0)) {
      alert("veuillez ecrire un message")
      return;
    }
    const filesinst = [...this.filesinstant];
    this.filesInstantRetry = filesinst;
    const newMessage = this.mapProject(messageTosendData, this.project, filesinst, this.typefileselected );
    this.messagesInstant.push(newMessage);
    //const lang = await this.detectMsgLanguage(messageTosendData);
    setTimeout(() => {
      this.scrollToBottom();
    }, 200);
    const textarea = document.getElementById('tchat-text') as HTMLTextAreaElement;
      this.sendMessageFormInstant.get('files').setValue(null);
      this.sendMessageFormInstant.get('files').setValidators([requiredFileType(['png','jpeg','jpg','mov','mp4'])]); 
      this.sendMessageFormInstant.get('files').updateValueAndValidity();
      this.filesinstant = [];
      this.deleteAudio();
    if (textarea) {
      textarea.value = '';
    }
    var idanswered = null;
    if(this.msgAnswered){
      idanswered = this.msgAnswered.id;
    }
    var currentProject = '/api/projects/' + this.ID;
    this.authService.sendQuestionInstant(messageTosendData, currentProject, filesinst, this.typefileselected, this.numdoc, null, null, null, newMessage.fakeId, idanswered, 'fr').subscribe(res => {
      this.msgAnswered = null;
      this.numdoc = null;
      var length = this.messagesInstant.length - 1;
      this.msgInstantRetry = null;
      this.filesInstantRetry = [];
      if(this.messagesInstant[length].fakeId == res['fakeid']){
        this.messagesInstant[length] = res;
        setTimeout(() => {
          this.scrollToBottom();
        });
      }
      
      if(messageTosendData === "" || messageTosendData == undefined) {
         messageTosendData = "Documents";
      }
      this.authService.obinstantMsgsent.next({"id": this.ID, "idmsg": res['id'], "text":messageTosendData, "date": res['dateCreated']});
      this.socketService.sendInstant({
        id: res['id'],
        action: this.ID,
        type: "INSTANT",
        author: this.currentUser,
        author_name: this.currentUserInfo["fullName"],
        recipient: this.ongletId,
        text: messageTosendData,
        copy: "",
        private: false,
        res: res,
        project_lib: this.projectFull.libelle,
        date: res['dateCreated']
      });
      this.loadSelectSearch(res);
      
    },error => {
      this.msgsent = false;
      if (error.status === 403) {
        const errorDescription = JSON.parse(error.error['hydra:description']);
        this.openPackComponentDialog(1, errorDescription.subscriptionPack);
        const index = this.messagesInstant.findIndex(msg => msg.fakeId === newMessage.fakeId);
        if (index !== -1) {
            this.messagesInstant.splice(index, 1);
        }
        
      } else if (error.status === 402) {
        const errorDescription = JSON.parse(error.error['hydra:description']);
        this.openPackComponentDialog(2, errorDescription.subscriptionPack);
        const index = this.messagesInstant.findIndex(msg => msg.fakeId === newMessage.fakeId);
        if (index !== -1) {
            this.messagesInstant.splice(index, 1);
        }
      }
      for (var i = 0; i < this.messagesInstant.length; i++) {
        if(newMessage.fakeId ===  this.messagesInstant[i].fakeId){
          this.messagesInstant[i].retry = true;
        } 
      } 
      //alert("oups une erreur s'est produite!");
    });
  }

  RetrySendQuestionInstant(messageTosendData, message) {
    this.notificationsCount = 0;
    const filesinst = this.filesInstantRetry;
    this.authService.sendQuestionInstant(messageTosendData, this.project, filesinst, this.typefileselected, null, null, null, message.fakeId).subscribe(res => {
      //console.log('reponse envoi message: ',res);
      //this.messagesInstant.push(res);
      var length = this.messagesInstant.length - 1;
      this.msgInstantRetry = null;
      this.filesInstantRetry = [];
      if(this.messagesInstant[length].fakeId == res['fakeid']){
        this.messagesInstant[length] = res;
        setTimeout(() => {
          this.scrollToBottom();
        });
      }
      this.msgsent = false;
      
      if(messageTosendData === "" || messageTosendData == undefined) {
         messageTosendData = "Documents";
      }
      this.authService.obinstantMsgsent.next({"id": this.ID, "idmsg": res['id'], "text":messageTosendData, "date": res['dateCreated']});
      this.socketService.sendInstant({
        id: res['id'],
        action: this.ID,
        type: "INSTANT",
        author: this.currentUser,
        author_name: this.currentUserInfo["fullName"],
        recipient: this.ongletId,
        text: messageTosendData,
        copy: "",
        private: false,
        res: res,
        project_lib: this.projectFull.libelle,
        date: res['dateCreated']
      });
      this.loadSelectSearch(res);
    },error => {
      this.msgsent = false;
      //alert("error "+error)
      for (var i = 0; i < this.messagesInstant.length; i++) {
        if(message.fakeId ===  this.messagesInstant[i].fakeId){
          this.messagesInstant[i].retry = true;
        } 
      } 
    });
  }

  handleData(data: any) {
    // Faire quelque chose avec les données reçues du composant enfant
    //console.log("handele  "+data.contentUrl);
    this.selectedPdf = data;
  }

  closeModal(){
    this.selectedPdf=null;
  }

  getPdfLink(mediaUrl){
    if(this.instant == true){
      return this._sanitizer.bypassSecurityTrustResourceUrl(this.authService.getMediaDataInstant(mediaUrl));
    } else return this._sanitizer.bypassSecurityTrustResourceUrl(this.authService.getMediaData(mediaUrl));
    //return this._sanitizer.bypassSecurityTrustResourceUrl(this.authService.getMediaData(mediaUrl));

  }

  scrollToReadMsg() {
    const element = document.getElementById('readmsgdiv');
    if (element) {
      element.classList.add('smooth-scroll');
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      element.scrollTop -= 60;
      element.classList.remove('smooth-scroll'); // Retirez la classe après l'animation
    }
  }

  scrollToMsg(id: string) {
    setTimeout(() => {
      if (this.scrollMechat && this.scrollMechat.nativeElement) {
        const element = this.scrollMechat.nativeElement.querySelector(`#message_${id}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
      }
    }, 1000);
  }

  scrollToBottomResult(): void {
    const container = this.scrollResultchat.nativeElement;
    this.scrollResultchat.nativeElement.scrollTop = this.scrollResultchat.nativeElement.scrollHeight;
    
  }

  mapProjectFace(messageTosendData, project, filesface, typefileselected){
    var files = [];
    var typefiles = "image";
    if(typefileselected == "document"){
      typefiles = 'DOCUMENT';
    }
    var isLoading = false;
    if(filesface.length > 0 ){
      isLoading = true;
      files = filesface.map(file =>({
        id: "00000",
        contentUrl: "a81fc9305d3a613e32f57f3b29f3e5505349ac43.png",
        file: file,
        createdAt: "2024-01-16T11:13:20+00:00",
        extension: file.type,
        extensionfile: this.getExtension(file),
        mimtype: "image/png",
        type: "fake",
        libelle: typefiles,
        originalName: file.name,
        thumbnailPath: null
      }));
    }
    //const recipient = this.projectUsers.find(user => user.user.id === messageTosendData.recipient).user;
    //var recipient = null;
    let recepient;
    if(!messageTosendData.general){
      var projectuser = this.projectUsers.find(user => user.user.id === messageTosendData.recipient);
      if(projectuser) recepient = projectuser.user;
    }
    const tag = this.projectTags.find(subject => subject.id === messageTosendData.subProject.id);
    if(!tag) {
      alert("non tag ");
      return;
    }
    var smartNumber = 1 ;
    if(Number(this.dataSource.length > 0)){
      smartNumber = Number(this.dataSource[0].smartNumber) + 1;
    }
    const newMessage = {
      id: "",
      fakeId: uuidv4(),
      type: "fake",
      author: { 
        id: this.currentUser,
        givenName: this.currentUserInfo.givenName,
        familyName: this.currentUserInfo.familyName,
        imageUrl: this.userData.imageUrl
      },
      recipient: { 
        id: (messageTosendData.general) ? this.currentUser : recepient.id,
        givenName: (messageTosendData.general) ? this.currentUserInfo.givenName : recepient.givenName,
        familyName: (messageTosendData.general) ? this.currentUserInfo.familyName : recepient.familyName,
        imageUrl: (messageTosendData.general) ? this.userData.imageUrl : recepient.imageUrl
      },
      tags: [{
        id: tag.id,
        libelle: tag.libelle
      }],
      dateCreated: new Date(),
      iddoc: null,
      isDrive: false,
      isPrivate: messageTosendData.private,
      isGeneral: messageTosendData.general,
      isThematic: messageTosendData.thematic,
      isTask: this.isTaskMsg,
      isRecipientRead: false,
      isTransfered: false,
      recipientReadAt: null,
      smartNumber: smartNumber,
      copy: [],
      comment: [],
      recall: [],
      relance1: messageTosendData.relanceOne,
      deadLine: messageTosendData.deadLine,
      project: {
        id: project,
        imageUrl: null,
        libelle: false,
        parentItem: null,
      },
      filegeneric: files,
      text: messageTosendData.messageToSend,
      transfermsg: null,
      error: true,
      isLoading: isLoading
    }
    return newMessage;
  }

  getExtensionFile(element: any){
    var extension = null;
    if(element.extension.includes('video') == true){
      extension = "video";
    } else if(element.extension.includes('image') == true || element.extension.includes('heic') == true){
      extension = "image";
    } else if(element.extension.includes('pdf') == true){
      extension = "pdf";
    } else if(element.extensionfile.includes('doc') == true || element.extensionfile.includes('odt') == true || element.extensionfile.includes('word') == true){
      extension = "word";
    } else if(element.extensionfile.includes('xl') == true || element.extensionfile.includes('csv') == true){
      extension = "excel";
    } else if(element.extensionfile.includes('ppt') == true){
      extension = "presentation";
    } 
    return extension;
  }

  isLink(text: string): boolean {
    // Expression régulière pour vérifier si le texte contient une URL (http, https, www)
    const urlPattern = /(?:https?|ftp):\/\/[^\s/$.?#].[^\s]*|www\.[^\s]+/gi;
    return urlPattern.test(text);
  }

  contientLien(chaine: string): boolean {
    // Expression régulière pour vérifier la présence d'une URL
    const regex = /https?:\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+([\/\?].*)?/;
    return regex.test(chaine);
  }

  loadSelectSearch(object: any){
    const existUrl = this.contientLien(object.text);
    if(existUrl && !this.searchtypesInsApi.includes("http"))  {
      //console.log("http added : ");
      this.searchtypesInsApi = this.searchtypesInsApi.concat("http");
      this.searchtypesIns = this.searchtypesInsfilter.filter(item => this.searchtypesInsApi.includes(item.id));
    }
    var transmitter = object.author;
    var filegeneric = object.filegeneric;
    //console.log("transmitter : "+transmitter.id);
    const findSender = this.projectSendersInit.find(item => item.id = transmitter.id);
    //console.log("find sender : "+findSender);
    if(!findSender){
      //console.log("find sender : "+transmitter.fullName);
      this.projectSendersInit.push(transmitter);
      this.projectSendersInit.sort((a, b) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()));
    }
    if(filegeneric && filegeneric.length > 0){
      filegeneric.forEach(element => {
        var extension = this.getExtensionFile(element);
        if(extension != null && !this.searchtypesInsApi.includes(extension)){
          //console.log("extension added : "+extension);
          this.searchtypesInsApi = this.searchtypesInsApi.concat(extension);
          this.searchtypesIns = this.searchtypesInsfilter.filter(item => this.searchtypesInsApi.includes(item.id));
        }
      });
    }
  }

  loadSelectSearchFace(object: any){
    const existUrl = this.contientLien(object.text);
    if(existUrl && !this.searchtypesApi.includes("http"))  {
      this.searchtypesApi = this.searchtypesApi.concat("http");
      this.searchtypes = this.searchtypesfilter.filter(item => this.searchtypesApi.includes(item.id));
    }
    var transmitter = object.author;
    var recipient = object.recipient;
    var filegeneric = object.filegeneric;
    var copies = object.copy;
    var tags = object.tags;
    if(tags && tags.length > 0){
      tags.forEach(tag => {
        const findTag = this.searchTagInit.find(item => item.id == tag.id);
        if(!findTag){
          this.searchTagInit.push(tag);
          this.searchTagInit.sort((a, b) => {
            if ( a.createdAt > b.createdAt ){
              return -1;
            }
            if ( a.createdAt < b.createdAt ){
              return 1;
            }
            return 0;
          })
          //this.searchTagInit.sort((a, b) => a.libelle.toLowerCase().localeCompare(b.libelle.toLowerCase()));
        }
      });
    }
    const findSender = this.searchSenderInit.find(item => item.id == transmitter.id);
    if(!findSender){
      this.searchSenderInit.push(transmitter);
      this.searchSenderInit.sort((a, b) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()));
    }
    const findRecipient = this.searchRecipientInit.find(item => item.id == recipient.id);
    if(!findRecipient){
      this.searchRecipientInit.push(recipient);
      this.searchRecipientInit.sort((a, b) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()));
    }
    if(copies && copies.length > 0){
      copies.forEach(copy => {
        const findCopy = this.searchCopyInit.find(item => item.id == copy.user.id);
        if(!findCopy){
          this.searchCopyInit.push(copy.user);
          this.searchCopyInit.sort((a, b) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()));
        }
      });
    }
    if(filegeneric && filegeneric.length > 0){
      filegeneric.forEach(element => {
        var extension = this.getExtensionFile(element);
        if(extension != null && !this.searchtypesApi.includes(extension)){
          this.searchtypesApi = this.searchtypesApi.concat(extension);
          this.searchtypes = this.searchtypesfilter.filter(item => this.searchtypesApi.includes(item.id));
        }
      });
    }
  }

  async sendQuestion(messageTosendData) {
    
    console.log("iddd project"+this.ID)
    this.project = '/api/projects/' + this.ID;
    console.log("iddd project"+this.project)
    this.ISendMessage = true;
    //const lang = await this.detectMsgLanguage(messageTosendData.messageToSend);
    //---------------------
    const filesface = [...this.files];
    const newMessage = this.mapProjectFace(messageTosendData, this.project, filesface, this.typefileselected );
    this.dataSource.unshift(newMessage);
    //this.notifNbr++;
    //this.total += 1;
    this.divopened = false;
    //---------------------
    this.authService.sendQuestion(
      messageTosendData.messageToSend,
      messageTosendData.subProject,
      this.project,
      messageTosendData.recipient,
      messageTosendData.inCopy,
      messageTosendData.private,
      this.isCommentActivated,
      messageTosendData.deadLine,
      messageTosendData.relanceOne,
      messageTosendData.relanceTwo,
      messageTosendData.relanceTree,
      this.files,
      null,
      null,
      null,
      messageTosendData.general,
      messageTosendData.thematic,
      null,
      null,
      null,
      'fr',
      this.isTaskMsg,
      this.relance_enabled
    )
    .subscribe(event => {
      if (event.type === HttpEventType.UploadProgress) {

        const percent = Math.round(
          100 * event.loaded / (event.total || 1)
        );

        this.uploadProgress = percent;
        console.log("uploadProgress : "+this.uploadProgress)
      }
      if (event.type === HttpEventType.Response) {
        console.log("uploadProgress sent finally ")
        const res = event.body; // 👈 ICI ta vraie réponse Symfony
        window.scroll(0,0);
        //console.log('reponse envoi message: ',res);
        this.resetAllmsgbloc();
        this.tempMemberUser = [];
        this.facesent = false;
        this.newTagsArray = res['tags'];
        this.dataSource[0] = res;
        this.emptyproject = false;
        this.uploadProgress = 0;
        for (var i = 0; i < this.newTagsArray.length; i++) {
          if (this.containsTheTag(this.newTagsArray[i]) == false) {
            //console.log('ajout du nouveau tag => '+ this.newTagsArray[i]);
            var tag = this.newTagsArray[i];
            this.projectTags.push(tag);
          }
        }

        this.projectTags.sort((a, b) => {
            if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
              return -1;
            }
            if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
              return 1;
            }
            return 0;
          })
          this.socketService.sendInstant({
            id: res['id'],
            action: this.ID,
            type: "FACE",
            author: this.currentUser,
            recipient: messageTosendData.recipient,
            text: messageTosendData.messageToSend,
            copy: messageTosendData.inCopy,
            private: messageTosendData.private,
            res: res,
            project_lib: this.projectFull.libelle,
            date: res['dateCreated']
          });
          this.loadSelectSearchFace(res);
          this.tempMember = [];

          

          this.chosenFilterProject = null;
          this.specMsg = null;
          this.specComment = false;
          this.specCom = null;
          this.showRedBar = false;
          this.specMsgType = null;
          this.modeDoc = false;
          this.chosenFilter = null;
          //console.log(' launchSearch '+ JSON.stringify(this.chosenFilter) );
          this.EventLaunchSearch.emit(this.chosenFilter);
          this.ISendMessage = false;
            //console.log("socket sended");
      }
    },error => {
      this.uploadProgress = 0;
      if (error.status === 403) {
        const errorDescription = JSON.parse(error.error['hydra:description']);
        this.openPackComponentDialog(1, errorDescription.subscriptionPack);
        this.facesent = false;
        const index = this.dataSource.findIndex(msg => msg.fakeId === newMessage.fakeId);
        if (index !== -1) {
            this.dataSource.splice(index, 1);
        }
        
      } else if (error.status === 402) {
        const errorDescription = JSON.parse(error.error['hydra:description']);
        this.openPackComponentDialog(2, errorDescription.subscriptionPack);
        this.facesent = false;
        const index = this.dataSource.findIndex(msg => msg.fakeId === newMessage.fakeId);
        if (index !== -1) {
            this.dataSource.splice(index, 1);
        }
      } else {
        this.senderror = true;
        this.facesent = false;
        if(error.status !== 0){
        alert("oups une erreur s'est produite!"+JSON.stringify(error));
      }
    }
      this.ISendMessage = false;
    });
  }


  // getTags(){
  //   this.authService.getAllTags().then((res)=>{
  //     console.log({allTags:res})
  //   }).catch((err)=>{
  //     console.log(err)
  //   })
  // }
  

  getProjectInfo(){
    this.arraySubject = []

    if (!this.ID) {
      return;
    }

    this.authService.getProjectInfo(this.ID).then((res)=>{
      this.arraySubject = res['tags'];

      this.arraySubject.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })

      // this.arraySubject.reverse()
      this.isUpdate = Array(this.arraySubject.length).fill(false)
      //this.project = res
      // if(this.currentUser['id'] == this.project['creator']['id'] ){
      //   this.isAdmin = true
      // }
    }).catch(err=>console.log(err))
  }


  openDuppSubjectModal(action){
    //console.log('ID du project subject =>'+ this.ID);
    this.projectLists = this.messageService.getListProject();
    const dialogRef = this.dialog.open(SubjectDuppComponent, {
      width: '700px',
      data:{idProjet: this.project, projects: this.projectLists}
    });

    dialogRef.afterClosed().subscribe(result => {
        if(dialogRef.componentInstance.tagsadded){
          dialogRef.componentInstance.tagsadded.forEach((element)=>{
            this.projectTags.push(element);
          })
          
          this.projectTags.sort((a, b) => {
            if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
              return -1;
            }
            if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
              return 1;
            }
            return 0;
          })
          this.selectSubject.open();
        }
        
    });
  }

  

  openAddSubjectModal(action){
    //console.log('ID du project subject =>'+ this.ID);
    const dialogRef = this.dialog.open(SubjectsListComponent, {
      width: '700px',
      data:{idProjet: this.ID, action: action, type: this.project_isparent}
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed result '+result);
        //TO Do dialog ajout membre 
        //console.log(dialogRef.componentInstance.chosenSubject);
        if(dialogRef.componentInstance.chosenSubject){
          this.sujectPlaceholder = dialogRef.componentInstance.chosenSubject;
          this.sendMessageForm.get('subProject').setValue(dialogRef.componentInstance.chosenSubject)
          this.sendMessageForm.get('subProject').clearValidators();
          this.sendMessageForm.get('subProject').updateValueAndValidity();
          this.projectTags.push(dialogRef.componentInstance.chosenSubject);
          this.projectTags.sort((a, b) => {
            if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
              return -1;
            }
            if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
              return 1;
            }
            return 0;
          })
          this.selectSubject.open();
        }
        if(action == 2 && dialogRef.componentInstance.updatedSubject){
          //this.getProjectTags();
          this.getCurrentProject();
        }
        
    });
  }

  getUserListWithNoCurrentUser(){
    if(!this.projectUsers) return [];
    this.arrayUserCopy = [];
    for (var i = 0; i < this.projectUsers.length; i++) {
      if (this.sendMessageForm.controls.recipient.value) {
        if(this.projectUsers[i].user.id != this.currentUser && this.sendMessageForm.controls.recipient.value != this.projectUsers[i].user.id){
          //arrayUser.push(this.projectUsers[i]);
          this.arrayUserCopy.push(this.projectUsers[i]);
          //console.log(this.projectUsers[i].user.id);
        }
      }
      else if(this.projectUsers[i].user.id != this.currentUser){
        //arrayUser.push(this.projectUsers[i]);
        this.arrayUserCopy.push(this.projectUsers[i]);
      }
    }
    let search = this.copySearch.value;
    if (!search) {
      return this.arrayUserCopy;
    } else {
      search = search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      return this.arrayUserCopy.filter(bank => bank.user.givenName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.user.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
    //return this.arrayUserCopy;
  }

  openBottomDialogEcheance(){
    
    const dialogRef = this.dialog.open(DeadLineConvDialog, {
      width: '330px',
      data:{}
    });   
    var resultobject = {"value": "", "echeance" : "", "relanceOne": "", "relanceTwo": "", "relanceTree" : ""};
    
    
 
    dialogRef.afterClosed().subscribe(result => {
       
      
      if (result){ 
          //result.echeance = moment(result.echeance).format('DD-MM-YYYY').toLocaleString( );
          //this.echeance = result.echeance.toLocaleString( );
          if(result.deadline){
            this.echeance = moment(result.deadline).format('DD-MM-YYYY').toLocaleString( );
          }
          if(result.Relance1){
            this.relanceOneDate = moment(result.Relance1).format('DD-MM-YYYY').toLocaleString( );
          }
          this.relanceOne = result.relanceOne;
          //this.relanceOneDate = moment(result.Relance1).format('DD-MM-YYYY').toLocaleString( );
          this.relanceTwo = result.relanceTwo;
          this.relanceTwoDate = moment(result.relanceTwo).format('DD-MM-YYYY').toLocaleString( );
          this.sendMessageForm.get('deadLine').setValue(result.deadline); 
          this.sendMessageForm.get('relanceOne').setValue(result.Relance1);
          this.sendMessageForm.get('relanceTwo').setValue(result.Relance2);
          this.sendMessageForm.get('relanceTree').setValue(result.Relance3);
        
      }

    })

  }

  setPrivate() {
    if(!this.sendMessageForm.value.subProject) return;
    if(this.private == true){
      this.sendMessageForm.get('private').setValue(false);
      this.private = false;
      this.notifyValue = "ALL";
    } else {
      this.sendMessageForm.get('private').setValue(true);
      this.private = true;
      this.sendMessageForm.controls.inCopy.patchValue([]);
      this.tempMemberUser = [];
      this.notifyValue = "ALL";
      this.selectprivate = true;
      this.allcopies = false;
      this.tempMember = [];
      this.copiesusers = [];
    }
  }

  changeNotify(){
    if(this.notifyValue == "ALL"){
          this.sendMessageForm.controls.inCopy.patchValue([]);
          this.sendMessageForm.get('private').setValue(false);
          this.tempMember = [];
          this.selectprivate = false;
          this.copiesusers = [];
          this.allcopies = true;
          this.projectUsers.forEach(element => {
            if(this.currentUser != element.user.id){
              this.tempMember.push(element);
              this.copiesusers.push(element.user);
            }
          });
    } else if(this.notifyValue == "MEMBERS"){
      this.openOptionsModal();
    }
  }

  openOptionsModal(){
    //console.log('ID du project subject =>'+ this.ID);
    var copies = this.getUserListWithNoCurrentUser();
    this.nbrcopies = copies.length;
    const dialogRef = this.dialog.open(OtherOptionsComponent, {
      width: '350px',
      data:{idProjet: this.ID, type: this.project_isparent, private: this.private, copies: copies, selected: this.tempMember},
      panelClass: 'custom-modalbox'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(result.value === "private"){
          //console.log("private "+JSON.stringify(result));
          this.sendMessageForm.controls.inCopy.patchValue([]);
          this.sendMessageForm.get('private').setValue(true);
          this.private = true;
          this.selectprivate = true;
          this.allcopies = false;
        } else if(result.value === "notprivate"){
          //console.log("private "+JSON.stringify(result));
          this.sendMessageForm.controls.inCopy.patchValue([]);
          this.sendMessageForm.get('private').setValue(false);
          this.private = false;
          this.selectprivate = true;
          this.tempMember = [];
          this.copiesusers = [];
          this.toggleAllSelection();
        } else if(result.value === "all"){
          //console.log("private "+JSON.stringify(result));
          this.sendMessageForm.controls.inCopy.patchValue([]);
          this.sendMessageForm.get('private').setValue(false);
          this.private = false;
          this.tempMember = [];
          this.selectprivate = false;
          this.selectteam = true;
          this.copiesusers = [];
          this.allcopies = true;
          this.projectUsers.forEach(element => {
            if(this.currentUser != element.user.id){
              this.tempMember.push(element);
              this.copiesusers.push(element.user);
              //console.log("us "+element.user.fullName);
            }
          });
        } else if(result.value === "deadline"){
          //this.sendMessageForm.controls.inCopy.patchValue([]);
          //this.sendMessageForm.get('private').setValue(true);
          //console.log("deadline "+JSON.stringify(result));
          this.sendMessageForm.get('deadLine').setValue(result.echeance); 
          //result.echeance = moment(result.echeance).format('DD-MM-YYYY').toLocaleString( );
          //this.echeance = result.echeance.toLocaleString( );
          //this.echeance = moment(result.echeance).format('DD-MM-YYYY').toLocaleString( );
          this.relanceOne = result.relanceOne;
          this.relanceOneDate = moment(result.relanceOne).format('DD-MM-YYYY').toLocaleString( );
          this.relanceTwo = result.relanceTwo;
          this.relanceTwoDate = moment(result.relanceTwo).format('DD-MM-YYYY').toLocaleString( );
          this.sendMessageForm.get('relanceOne').setValue(result.Relance1);
          this.sendMessageForm.get('relanceTwo').setValue(result.Relance2);
          this.sendMessageForm.get('relanceTree').setValue(result.Relance3);
        } else if(result.value === "copy"){
          this.sendMessageForm.get('private').setValue(false);
          this.private = false;
          this.selectcopies = false;
          this.selectprivate = false;
          this.allcopies = false;
          this.toggleAllSelection();
          var copiesselected = result.copiesselected;
          this.tempMember = [];
          this.copiesusers = [];
          copiesselected.forEach(item => {
            this.projectUsers.forEach(element => {
              if(item == element.user.id){
                this.tempMember.push(item);
                this.copiesusers.push(element.user);
                //console.log("us "+element.user.fullName);
              }
            });
          });
          this.sendMessageForm.controls.inCopy.patchValue(this.tempMember);
        }
      }
    });
  }


  containsTheTag(newTag){
    for(var i = 0; i < this.projectTags.length; i++) {
      if(this.projectTags[i].id == newTag.id){
        return true;
      }
    }
    return false;
  }

  quitReply(messageData){
    this.writeMode = -1;
  }

  openAnswerMode(messageData) {
    //console.log(' messageData => '+ JSON.stringify(messageData));
    this.resetAnswerFrom();
    this.resetQuestionFrom();
    this.openWriteFace = false;
    this.showMessages = true;
    this.messageInfo = messageData;
    this.isExpanded = false;
    this.writeMode = 1;     
  }

  quitComment(messageData){
    this.writeMode = -1;
  }

  openCommentResponseMode(messageData){
    if(messageData && messageData.isCommentActivated == true){
      //if (this.writeMode !== 2) {
        this.resetCommentForm();
        this.resetQuestionFrom();
        this.openWriteFace = false;
        this.showMessages = true;
        this.messageInfo = messageData;
        this.isExpanded = false;
        this.writeMode = 3;
        setTimeout(() => this.commentresponsetext.nativeElement.focus(), 1000);
    }
    else
    {
      if(!messageData) 
      {
        alert('Aucun message à commenter');
      }
      else if (messageData.isCommentActivated == false)
      {
        alert('Commentaire déactivé');
      }
      else
      {
        alert('oups Error !!!');
      }
    }
  }

  openCommentMode(messageData){
    if(messageData.isMessageDisabled) {
      alert("vous pouvez pas commenter car le message est déjà archivé!");
      return;
    }
    if(this.divopened) this.closeMsgBloc();
    this.hiddenSearchEngin = true;
    if(messageData && messageData.isCommentActivated == true){
      //if (this.writeMode !== 2) {
        this.resetCommentForm();
        this.resetQuestionFrom();
        this.openWriteFace = false;
        this.showMessages = true;
        this.messageInfo = messageData;
        this.isExpanded = false;
        this.writeMode = 2;
        setTimeout(() => this.commenttext.nativeElement.focus(), 1000);
    }
    else
    {
      if(!messageData) 
      {
        alert('Aucun message à commenter');
      }
      else if (messageData.isCommentActivated == false)
      {
        alert('Commentaire déactivé');
      }
      else
      {
        alert('oups Error !!!');
      }
    }
  }


  onSubmitAnswerForm(answerFormData, element) {

     // Process checkout data here
    //console.log('Your order has been submitted onSubmitAnswerForm ', answerFormData);

    this.submitted = true;

     // stop here if form is invalid
    if (this.sendanswerForm.invalid) {
      return;
    }
    this.markAsRead(element);
    
    this.sendAnswer(answerFormData, element);
    
    this.submitted = false;
    this.resetAnswerFrom();

    //scroll in view
     window.scroll(0,0);
    //this.divHeaderTable.nativeElement.scrollIntoView();

  }

  async sendAnswer(answerData, element) {
    this.ISendMessage = true;
    //const lang = await this.detectMsgLanguage(answerData.answerMessage);
    this.authService.sendAnswer(
      answerData.answerMessage,
      this.messageInfo.tags[0],
      this.messageInfo.isPrivate,
      this.project,
      this.messageInfo.id,
      this.files,
      null,
      null,
      null,
      'fr' //lang
    )
    .subscribe(res => {
      //console.log('réponse answer => '+res);
      //this.writeMode = 0;
      this.writeMode = -1;
      this.files = [];
      this.decrementNotif();
      if(this.notifiedmode){
        const index = this.dataSource.findIndex(item => item.id === res["question"].id);
        if (index >= 0) {
          this.checkDelMsg(this.dataSource[index], index);
        }
      } else this.messageService.messageRefreshConv();
      //this.setStatusAnswered();
      //this.envoyerObs.next();
      //this.messageService.messageRefreshConv();
      this.authService.obreceiveAsread.next(this.ID)
      //this.messageService.messageUpdated();
      this.ISendMessage = false;
      //this.total -=1;
      var copies = [];
      if(element.copy.length > 0){
        element.copy.forEach(element => {
          //if(element.user && element.user.id)
          copies.push(element.user.id);
        })
      }
      this.authService.obinstantMsgsent.next({"id": this.ID, "text":answerData.answerMessage, "date": res['dateCreated']});
      this.socketService.sendInstant({
        id: this.messageInfo.id,
        action: this.ID,
        type: "RESPONSE",
        author: this.currentUser,
        recipient: element.author.id,
        text: answerData.answerMessage,
        private: element.isPrivate,
        res: res,
        project_lib: this.projectFull.libelle,
        copy: copies,
        date: res['dateCreated'],
        ongletid : this.ongletId
      });

    },error => {
      alert("oups une erreur s'est produite!");
      this.ISendMessage = false;
    });
  }

  onSubmitFormComment(commentFormData){

    // Process checkout data here
    //console.log('Your order has been submitted onSubmitFormComment ', commentFormData);

    this.submitted = true;

     // stop here if form is invalid
    if (this.formComment.invalid) {
      return;
    }
    
    this.sendComment(commentFormData);

    this.submitted = false;
    this.resetCommentForm();  

     //scroll in view
      window.scroll(0,0);
    //this.divHeaderTable.nativeElement.scrollIntoView();

  }

  onSubmitFormCommentResponse(commentFormData, element){

    // Process checkout data here
    //console.log('Your order has been submitted onSubmitFormComment ', commentFormData);

    this.submitted = true;

     // stop here if form is invalid
    if (this.formCommentResponse.invalid) {
      return;
    }
    
    this.sendCommentResponse(commentFormData, element);
    

    this.submitted = false;
    this.resetCommentResponseForm();  

     //scroll in view
      window.scroll(0,0);
    //this.divHeaderTable.nativeElement.scrollIntoView();

  }

  async sendComment(commentFormData) {
    this.ISendMessage = true;
    //const lang = await this.detectMsgLanguage(commentFormData.commentMessage);
    this.authService.sendComment(
      commentFormData.commentMessage,
      this.messageInfo.tags[0],
      this.messageInfo.isPrivate,
      this.project,
      this.messageInfo.id,
      this.files,
      null,
      null,
      null,
      'fr' //lang
    )
    .subscribe(res => {
      this.files = [];
      //console.log('réponse comment => '+res);
      //this.writeMode = 0;
      this.writeMode = -1;
      //this.envoyerObs.next();
      const messageIndex = this.dataSource.findIndex(message => message.id === this.messageInfo.id);

      if (messageIndex !== -1) {
        // 2. Ajouter le nouveau commentaire dans le tableau des commentaires du message
        this.dataSource[messageIndex].comment.unshift(res);
      }
      //this.messageService.messageRefreshConv();
      //this.messageService.messageUpdated();
      this.ISendMessage = false;
      this.specComment = true;
      //this.messageInfo.id
      this.authService.obinstantMsgsent.next({"id": this.ID, "text":commentFormData.commentMessage, "date": res['dateCreated']});
      this.isExpanded = false;
      this.socketService.sendInstant({
        id: this.messageInfo.id,
        action: this.ID,
        type: "COMMENT",
        author: this.currentUser,
        recipient: "",
        text: commentFormData.commentMessage,
        copy: "",
        private: false,
        res: res,
        project_lib: this.projectFull.libelle,
        smartNumber: res['smartNumber'],
        date: res['dateCreated']
      });

    },error => {
      alert("oups une erreur s'est produite!");
      this.ISendMessage = false;
      this.writeMode = 2;
    });
  }

  sendCommentResponse(commentFormData, element) {
    this.ISendMessage = true;
    this.authService.sendCommentResponse(
      commentFormData.commentMessage,
      element.tags[0],
      element.isPrivate,
      this.project,
      this.messageInfo.id,
      this.files,
      null,
      null,
      null
    )
    .subscribe(res => {
      //console.log('réponse comment => '+res);
      //this.writeMode = 0;
      this.writeMode = -1;
      this.files = [];
      //this.envoyerObs.next();
      this.messageService.messageRefreshConv();
      //this.messageService.messageUpdated();
      this.ISendMessage = false;
      this.isExpanded = false;
      this.authService.obinstantMsgsent.next({"id": this.ID, "text":commentFormData.commentMessage, "date": res['dateCreated']});
      this.socketService.sendInstant({
        id: this.messageInfo.id,
        action: this.ID,
        type: "COMMENT",
        author: this.currentUser,
        recipient: "",
        text: commentFormData.commentMessage,
        copy: "",
        private: false,
        res: res,
        project_lib: this.projectFull.libelle,
        smartNumber: res['smartNumber'],
        date: res['dateCreated']
      });

    },error => {
      alert("oups une erreur s'est produite!");
      this.ISendMessage = false;
    });
  }

  resetQuestionFrom(){
    this.files = [];
    this.selctedRecipient = null;
    this.selctedRecipientImg = null;
    this.selctedRecipientColor = null;
    this.sendMessageForm.get('subProject').setValue('');
    this.sendMessageForm.get('subProject').setValidators([Validators.required]);
    this.sendMessageForm.get('subProject').updateValueAndValidity();
    this.sendMessageForm.get('newSubProject').setValue('');
    this.sendMessageForm.get('recipient').setValue('');
    //this.sendMessageForm.get('recipient').setValidators([Validators.required]);
    this.sendMessageForm.get('recipient').updateValueAndValidity();
    this.sendMessageForm.get('inCopy').setValue([]);
    this.sendMessageForm.get('private').setValue(false);
    this.sendMessageForm.get('deadLine').setValue(null);
    this.echeance = null;
    this.isTaskMsg = null;
    this.statusMsg = null;
    this.isMessage = false;
    this.isTache = false;
    this.isDocument = false;
    this.isAlltype = true;
    this.isTaskSearch = null;
    this.private = false;
    this.relanceOneDate = null;
    this.relance_enabled = false;
    this.sendMessageForm.get('relanceOne').setValue(null);
    this.sendMessageForm.get('relanceTwo').setValue(null);
    this.sendMessageForm.get('relanceTree').setValue(null);
    this.sendMessageForm.get('messageToSend').setValue('');
    //this.sendMessageForm.get('messageToSend').setValidators([Validators.required, Validators.minLength(1)]);
    this.sendMessageForm.get('messageToSend').updateValueAndValidity();
    this.sendMessageForm.get('files').setValue(null);
    this.sendMessageForm.get('files').setValidators([requiredFileType(['png','jpeg','jpg','mov','mp4'])]); 
    this.sendMessageForm.get('files').updateValueAndValidity();
    this.tempMemberUser = [];
    this.sendMessageForm.controls.general.patchValue(false);
    this.sendMessageForm.controls.thematic.patchValue(false);
    this.selectedProjectType = "face";
    this.tempRecipientSelected = [];
    this.tempCopyUsers = [];
    this.multipleRecipient = false;
    this.editorConfig = {
          ...this.editorConfig,
          placeholder: this.translate.instant('map.placeholder')
    };
    
    // Object.keys(this.sendMessageForm.controls).forEach(key => {
    //   this.sendMessageForm.controls[key].setErrors(null)
    // });
  }


  redirectTache(){
   //this.router.navigateByUrl('/reunion/'+this.ID)
   //alert("En cours de développement");
   this.router.navigateByUrl('/faceTofacesProposal/'+this.ID+'/openprop');
  }

  redirectReunions(){
   //this.router.navigateByUrl('/reunion/'+this.ID)
   this.router.navigateByUrl('/faceTofacesReunion/'+this.ID+'/openmeet');
  }

  redirectPlan(){
    this.router.navigateByUrl('/plan/'+this.ID)
  }

  redirectCompteRenduReunions(){
    this.router.navigateByUrl('/compteRenduRenunion/'+this.ID)
  }

  changePrivacy(val){
    this.sendMessageForm.get('private').setValue(!val);
  }

  resetAnswerFrom(){
    
    // reset form
    this.sendanswerForm.get('answerMessage').clearValidators();
    this.sendanswerForm.get('answerMessage').updateValueAndValidity();
    this.sendanswerForm.get('files').clearValidators();
    this.sendanswerForm.get('files').updateValueAndValidity();
    this.sendanswerForm.reset();

    //set defaut form values
    this.sendanswerForm.get('answerMessage').setValue('');
    this.sendanswerForm.get('answerMessage').setValidators([Validators.required, Validators.minLength(1)]);
    this.sendanswerForm.get('answerMessage').updateValueAndValidity();
    this.sendanswerForm.get('files').setValue(null);
    this.sendanswerForm.get('files').setValidators([requiredFileType(['png','jpeg','jpg','mov','mp4'])]);
    this.sendanswerForm.get('files').updateValueAndValidity();

  }

  resetCommentForm(){

    // reset form
    this.formComment.get('commentMessage').clearValidators();
    this.formComment.get('commentMessage').updateValueAndValidity();
    this.formComment.get('files').clearValidators();
    this.formComment.get('files').updateValueAndValidity();
    this.formComment.reset();

    //set defaut form values
    this.formComment.get('commentMessage').setValue('');
    this.formComment.get('commentMessage').setValidators([Validators.required, Validators.minLength(1)]);
    this.formComment.get('commentMessage').updateValueAndValidity();
    this.formComment.get('files').setValue(null);
    this.formComment.get('files').setValidators([requiredFileType(['png','jpeg','jpg','mov','mp4'])]);
    this.formComment.get('files').updateValueAndValidity();

  }

  resetCommentResponseForm(){

    // reset form
    this.formCommentResponse.get('commentMessage').clearValidators();
    this.formCommentResponse.get('commentMessage').updateValueAndValidity();
    this.formCommentResponse.get('files').clearValidators();
    this.formCommentResponse.get('files').updateValueAndValidity();
    this.formCommentResponse.reset();

    //set defaut form values
    this.formCommentResponse.get('commentMessage').setValue('');
    this.formCommentResponse.get('commentMessage').setValidators([Validators.required, Validators.minLength(1)]);
    this.formCommentResponse.get('commentMessage').updateValueAndValidity();
    this.formCommentResponse.get('files').setValue(null);
    this.formCommentResponse.get('files').setValidators([requiredFileType(['png','jpeg','jpg','mov','mp4'])]);
    this.formCommentResponse.get('files').updateValueAndValidity();

  }

  getMediaLink(mediaUrl){
    return this.authService.getMediaData(mediaUrl);
  }

  getMediaThumbail(mediaUrl){
    return this.authService.getMediaThumbail(mediaUrl);
  }

  fctListeMembre(){
    const dialogRef = this.dialog.open(DialogMemberListe, {
      //panelClass: 'dialogmember-container',
      panelClass: 'transferclass',
      backdropClass: 'custom-backdrop',
      height: "height: calc(-80px + 100vh);",
      data:{idProjet: this.ID, dateCreated : this.projectFull.dateCreated}
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed result '+result);
       if (Array.isArray(result) && result.length > 0) {
        this.projectUsers.push(...result.filter(r => r)); // on filtre les null au passage
        this.fctMapSuject();
      }
    });
  }

  getFormattedName(member: { givenName: string; familyName: string }): string {
    var firstInitial = "";
    if(member.familyName) firstInitial = member.familyName.charAt(0).toUpperCase();
    return `${member.givenName} .${firstInitial}`;
  }

  setPrivateVaue(value) {
    if(value == false){
      this.sendMessageForm.get('private').setValue(false);
      this.private = false;
      this.notifyValue = "ALL";
    } else {
      this.sendMessageForm.get('private').setValue(true);
      this.private = true;
      this.sendMessageForm.controls.inCopy.patchValue([]);
      this.notifyValue = "ALL";
      this.selectprivate = true;
      this.allcopies = false;
      this.tempMember = [];
      this.copiesusers = [];
    }
  }

  onProjectTypeChange(event: any){
    this.selectedProjectType = event.value;
    this.tempMemberUser = [];
    this.selctedRecipient = null;
    this.selctedRecipientImg = null;
    this.selctedRecipientColor = null;
    if(this.selectedProjectType == "face"){
      this.setPrivateVaue(false);
      this.sendMessageForm.patchValue({subProject: ''});
      this.sendMessageForm.controls.general.patchValue(false);
      this.sendMessageForm.controls.thematic.patchValue(false);
      this.sendMessageForm.get('recipient').setValue('');
      this.sendMessageForm.controls.inCopy.patchValue([]);
      setTimeout(() => {
        const librecipientvalue: HTMLElement = document.getElementById('librecipientvalue') as HTMLElement
        librecipientvalue.innerHTML = '';
      }, 0.5);
    } else if(this.selectedProjectType == "thematic"){
      this.setPrivateVaue(false);
      this.sendMessageForm.patchValue({subProject: ''});
      this.sendMessageForm.controls.general.patchValue(true);
      this.sendMessageForm.controls.thematic.patchValue(true);
      this.sendMessageForm.patchValue({recipient: this.currentUser});
      this.sendMessageForm.controls.inCopy.patchValue([]);
    } else if(this.selectedProjectType == "general"){
      this.setPrivateVaue(false);
      this.sendMessageForm.patchValue({subProject: ''});
      this.sendMessageForm.controls.general.patchValue(true);
      this.sendMessageForm.controls.thematic.patchValue(false);
      this.sendMessageForm.patchValue({recipient: this.currentUser});
      var tempMember = [];
      this.tempMemberUser = [];
      this.getUserListWithNoCurrentUser().map(item=> {
        if (item.user.id !== this.currentUser) {
          tempMember.push(item.user.id);
          this.tempMemberUser.push(item.user);
        }
      })
      this.sendMessageForm.controls.inCopy.patchValue([tempMember]);
    } else if(this.selectedProjectType == "private"){
      this.setPrivateVaue(true);
      this.sendMessageForm.patchValue({subProject: ''});
      this.sendMessageForm.controls.general.patchValue(false);
      this.sendMessageForm.controls.thematic.patchValue(false);
      this.sendMessageForm.get('recipient').setValue('');
      this.sendMessageForm.controls.inCopy.patchValue([]);
      setTimeout(() => {
        const librecipientvalue: HTMLElement = document.getElementById('librecipientvalue') as HTMLElement
        librecipientvalue.innerHTML = '';
      }, 0.5);
    }
    setTimeout(() => {
      const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
      libsubjectvalue.innerHTML = '';
    }, 0.5);
  }

  selectTypeMessage(result){
    var typemessage = "Face à face";
      if (result) {
        this.selectedProjectType = result;
        this.tempMemberUser = [];
        if(this.selectedProjectType == "face"){
          this.setPrivateVaue(false);
          typemessage = "Face à face";
          this.sendMessageForm.patchValue({subProject: ''});
          this.sendMessageForm.controls.general.patchValue(false);
          this.sendMessageForm.controls.thematic.patchValue(false);
          this.sendMessageForm.get('recipient').setValue('');
          this.sendMessageForm.controls.inCopy.patchValue([]);
          this.tempMemberUser = [];
          this.selctedRecipient = null;
          this.selctedRecipientImg = null;
          this.selctedRecipientColor = null;
          setTimeout(() => {
            const librecipientvalue: HTMLElement = document.getElementById('librecipientvalue') as HTMLElement
            librecipientvalue.innerHTML = '';
          }, 0.5);
          setTimeout(() => {
            const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
            libsubjectvalue.innerHTML = '';
          }, 0.5);
        } else if(this.selectedProjectType == "thematic"){
          typemessage = "Bloc d'équipe";
          this.setPrivateVaue(false);
          this.sendMessageForm.patchValue({subProject: ''});
          this.sendMessageForm.controls.general.patchValue(true);
          this.sendMessageForm.controls.thematic.patchValue(true);
          this.sendMessageForm.patchValue({recipient: this.currentUser});
          this.sendMessageForm.controls.inCopy.patchValue([]);
          this.tempMemberUser = [];
          setTimeout(() => {
            const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
            libsubjectvalue.innerHTML = '';
          }, 0.5);
        } else if(this.selectedProjectType == "general"){
          typemessage = "Note Générale";
          this.setPrivateVaue(false);
          this.sendMessageForm.patchValue({subProject: ''});
          this.sendMessageForm.controls.general.patchValue(true);
          this.sendMessageForm.controls.thematic.patchValue(false);
          this.sendMessageForm.patchValue({recipient: this.currentUser});
          var tempMember = [];
          this.tempMemberUser = [];
          this.getUserListWithNoCurrentUser().map(item=> {
            if (item.user.id !== this.currentUser) {
              tempMember.push(item.user.id);
              this.tempMemberUser.push(item.user);
            }
          })
          this.sendMessageForm.controls.inCopy.patchValue([...this.getUserListWithNoCurrentUser().map(item => item.user.id)]);
          setTimeout(() => {
            const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
            libsubjectvalue.innerHTML = '';
          }, 0.5);
        } else if(this.selectedProjectType == "private"){
          this.setPrivateVaue(true);
          this.sendMessageForm.patchValue({subProject: ''});
          this.sendMessageForm.controls.general.patchValue(false);
          this.sendMessageForm.controls.thematic.patchValue(false);
          this.sendMessageForm.get('recipient').setValue('');
          this.sendMessageForm.controls.inCopy.patchValue([]);
          this.selctedRecipient = null;
          this.selctedRecipientImg = null;
          this.selctedRecipientColor = null;
          setTimeout(() => {
            const librecipientvalue: HTMLElement = document.getElementById('librecipientvalue') as HTMLElement
            librecipientvalue.innerHTML = '';
          }, 0.5);
        }
       } 
  }

  fctListeMessageType(event: MouseEvent){
    var isAdmin = (this.userIsAdmin() === 'admin' || this.userIsAdmin() === 'co-admin');
    const dialogRef = this.dialog.open(MessageTypeListeDialog, {
      panelClass: 'dialogsubject-container',
      data: { isAdmin: isAdmin},
      position: {
        top: '50vh',
        left: '50%'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed result '+result);
      var typemessage = "Face à face";
      if (result) {
        this.selectedProjectType = result;
        this.tempMemberUser = [];
        if(this.selectedProjectType == "face"){
          this.setPrivateVaue(false);
          typemessage = "Face à face";
          this.sendMessageForm.patchValue({subProject: ''});
          this.sendMessageForm.controls.general.patchValue(false);
          this.sendMessageForm.controls.thematic.patchValue(false);
          this.sendMessageForm.get('recipient').setValue('');
          this.sendMessageForm.controls.inCopy.patchValue([]);
          this.tempMemberUser = [];
          this.selctedRecipient = null;
          this.selctedRecipientImg = null;
          this.selctedRecipientColor = null;
          setTimeout(() => {
            const librecipientvalue: HTMLElement = document.getElementById('librecipientvalue') as HTMLElement
            librecipientvalue.innerHTML = '';
          }, 0.5);
          setTimeout(() => {
            const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
            libsubjectvalue.innerHTML = '';
          }, 0.5);
        } else if(this.selectedProjectType == "thematic"){
          typemessage = "Bloc d'équipe";
          this.setPrivateVaue(false);
          this.sendMessageForm.patchValue({subProject: ''});
          this.sendMessageForm.controls.general.patchValue(true);
          this.sendMessageForm.controls.thematic.patchValue(true);
          this.sendMessageForm.patchValue({recipient: this.currentUser});
          this.sendMessageForm.controls.inCopy.patchValue([]);
          this.tempMemberUser = [];
          setTimeout(() => {
            const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
            libsubjectvalue.innerHTML = '';
          }, 0.5);
        } else if(this.selectedProjectType == "general"){
          typemessage = "Note Générale";
          this.setPrivateVaue(false);
          this.sendMessageForm.patchValue({subProject: ''});
          this.sendMessageForm.controls.general.patchValue(true);
          this.sendMessageForm.controls.thematic.patchValue(false);
          this.sendMessageForm.patchValue({recipient: this.currentUser});
          var tempMember = [];
          this.tempMemberUser = [];
          this.getUserListWithNoCurrentUser().map(item=> {
            if (item.user.id !== this.currentUser) {
              tempMember.push(item.user.id);
              this.tempMemberUser.push(item.user);
            }
          })
          this.sendMessageForm.controls.inCopy.patchValue([tempMember]);
          setTimeout(() => {
            const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
            libsubjectvalue.innerHTML = '';
          }, 0.5);
        } else if(this.selectedProjectType == "private"){
          this.setPrivateVaue(true);
          this.sendMessageForm.patchValue({subProject: ''});
          this.sendMessageForm.controls.general.patchValue(false);
          this.sendMessageForm.controls.thematic.patchValue(false);
          this.sendMessageForm.get('recipient').setValue('');
          this.sendMessageForm.controls.inCopy.patchValue([]);
          this.selctedRecipient = null;
          this.selctedRecipientImg = null;
          this.selctedRecipientColor = null;
          setTimeout(() => {
            const librecipientvalue: HTMLElement = document.getElementById('librecipientvalue') as HTMLElement
            librecipientvalue.innerHTML = '';
          }, 0.5);
        }
        setTimeout(() => {
            const typemessagevalue: HTMLElement = document.getElementById('typemessagevalue') as HTMLElement
            typemessagevalue.innerHTML = typemessage;
        }, 0.5);
       } 
    });
  }

  fctListeSuject(event: MouseEvent, addsub = null){
    var general = (this.selectedProjectType == "general");
    var isAdmin = (this.userIsAdmin() === 'admin' || this.userIsAdmin() === 'co-admin');
    var isPrivate = this.projectFull.isPrivate;
    if(isAdmin) {
      this.onlyUserTags = [];
      this.onlyUserTags = this.projectTags;
    }
    const dialogRef = this.dialog.open(SubjectListeDialog, {
      panelClass: 'dialogsubject-container',
      data: { idProjet: this.ID, projectTags: this.onlyUserTags, projectUsers: this.getUserListWithNoCurrentUser(), general : general, isAdmin : isAdmin, isPrivate: isPrivate, projectlib: this.projectFull.libelle, addsub: addsub},
      height: "height: calc(-80px + 100vh);",
      position: {
        top: '50vh',
        left: '50%'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.setPrivateVaue(false);
        console.log("result "+JSON.stringify(result))
        this.multipleRecipient = false;
        this.tempMemberUser = [];
        this.tempRecipientSelected = [];
        if(result.libelle.toLowerCase() == "general"){
          console.log("general selected")
          this.selectedProjectType = "general";
          this.sendMessageForm.patchValue({
                subProject: result
          });
          //this.tempRecipientSelected = [];
            this.getUserListWithNoCurrentUser().map(item=> {
              if (item.user.id !== this.currentUser) {
                this.tempMemberUser.push(item.user);
              }
            })
          this.sendMessageForm.patchValue({recipient: this.currentUser});
          this.sendMessageForm.controls.inCopy.patchValue([...this.getUserListWithNoCurrentUser().map(item => item.user.id)]);
          this.sendMessageForm.controls.general.patchValue(true);
          this.sendMessageForm.controls.thematic.patchValue(false);
          setTimeout(() => {
                const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
                libsubjectvalue.innerHTML = "Note générale";
                //if(this.descp) this.descp.focus();
              }, 0.5);
        } else {
              this.selectedProjectType = "face";
              const index = this.projectTags.findIndex(item => item.id === result.id);
              if (index == -1) {
                this.projectTags.push(result);
                this.projectTags.sort((a, b) => {
                  if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
                    return -1;
                  }
                  if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
                    return 1;
                  }
                  return 0;
                })
              }
              this.sendMessageForm.patchValue({
                subProject: result
              });
              this.sendMessageForm.controls.inCopy.patchValue([]);
              if(!this.projectFull.isPrivate) {
                this.sendMessageForm.get('recipient').setValue('');
                this.selctedRecipient = null;
                this.selctedRecipientImg = null;
                this.selctedRecipientColor = null;
                /*setTimeout(() => {
                    const librecipientvalue: HTMLElement = document.getElementById('librecipientvalue') as HTMLElement
                    librecipientvalue.innerHTML = '';
                }, 0.5);*/
              }
              //var tempMember = [];
              this.tempMemberUser = [];
              this.tempCopyUsers = [];
              this.tempRecipientUser = [];
              const createdAt = new Date(result.createdAt);
              const comparisonDate = new Date('2025-05-12');
              const isBefore = (createdAt < comparisonDate); 
              //if(!isBefore){
              result.userTag.map(item=> {
                  if (item.user && item.user.id !== this.currentUser) {
                    //tempMember.push(item.user.id);
                    this.tempCopyUsers.push(item.user);
                    this.tempRecipientUser.push(item.user);
                    console.log("naaame : "+item.user.givenName)
                  }
                })
              /*} else {
                this.getUserListWithNoCurrentUser().map(item=> {
                  if (item.user.id !== this.currentUser) {
                    this.tempCopyUsers.push(item.user);
                    this.tempRecipientUser.push(item.user);
                    console.log("naaame2 : "+item.user.givenName)
                  }
                })
              }*/
              
              setTimeout(() => {
                const libsubjectvalue: HTMLElement = document.getElementById('libsubjectvalue') as HTMLElement
                libsubjectvalue.innerHTML = this.sendMessageForm.value.subProject.libelle;
                //if(this.descp) this.descp.focus();
              }, 0.5);
              if(!this.projectFull.isPrivate){
                //this.fctListeRecipient(new MouseEvent('click', {bubbles: true, cancelable: true}));
              }
            }
       } 
    });
  }

  fctMapSuject(){
  console.log('mappped')
    var isAdmin = (this.userIsAdmin() === 'admin' || this.userIsAdmin() === 'co-admin');
    var isPrivate = this.projectFull.isPrivate;
    if(isAdmin) {
      this.onlyUserTags = [];
      this.onlyUserTags = this.projectTags.filter(item => item.libelle !== 'general');
    }
    const dialogRef = this.dialog.open(SubjectMapComponent, {
      panelClass: 'dialogmapping-container',
      data: { idProjet: this.ID, subjects: this.onlyUserTags, projectUsers: this.getUserListWithNoCurrentUser(), isAdmin : isAdmin, isPrivate: isPrivate, project: this.projectFull},
      height: "height: calc(-80px + 100vh);",
      position: {
        top: '50vh',
        left: '50%'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadUserTagProject();
    });
  }

  getSubjectUserList(){
    if(!this.tempRecipientUser) return [];
    var arrayUserCopy = [];
    for (var i = 0; i < this.tempRecipientUser.length; i++) {
      if(this.tempRecipientUser[i].id != this.currentUser && this.sendMessageForm.controls.recipient.value != this.tempRecipientUser[i].id){
        //arrayUser.push(this.projectUsers[i]);
        //arrayUserCopy.push(this.tempRecipientUser[i]);
        const matchedProjectUser = this.projectUsers.find(pu => pu.user.id === this.tempRecipientUser[i].id);
        
        if (matchedProjectUser) {
          arrayUserCopy.push(matchedProjectUser);
        }
      }
    }
    return arrayUserCopy;
  }

  getOtherUserProjectList(){
    if (!this.tempRecipientUser) return [];

    const recipientIds = this.tempRecipientUser.map(user => user.id);
    const availableUsers = [];

    for (let i = 0; i < this.projectUsers.length; i++) {
      const userId = this.projectUsers[i].user.id;

      if (/*!recipientIds.includes(userId)*/userId != this.sendMessageForm.value.recipient && userId != this.currentUser) {
        availableUsers.push(this.projectUsers[i]);
      }
    }

    return availableUsers;
  }

  fctListeCopies(event: MouseEvent){
    if(!this.sendMessageForm.value.subProject || this.private) return;
    const dialogRef = this.dialog.open(CopyListeDialog, {
      panelClass: 'dialogsubject-container',
      data: { idProjet: this.ID, projectCopies: this.getSubjectUserList(), userSelected : this.tempMemberUser},
      height: "calc(-80px + 100vh)",
      position: {
        top: '50vh', 
        left: '50%'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var tempMember = [];
        this.tempMemberUser = [];
        result.map(item=> {
          tempMember.push(item.id);
          this.tempMemberUser.push(item);
        })
        this.sendMessageForm.controls.inCopy.patchValue(tempMember);
        //this.fctListeSuject(new MouseEvent('click', {bubbles: true, cancelable: true}));
       } else {
       }
    });
  }

  fctListeCopiesFromPlus(event: MouseEvent){
    if(!this.sendMessageForm.value.subProject || this.private) return;
    console.log("count : "+this.getOtherUserProjectList().length)
    const dialogRef = this.dialog.open(CopyListeDialog, {
      panelClass: 'dialogsubject-container',
      data: { idProjet: this.ID, projectCopies: this.getOtherUserProjectList(), userSelected : this.tempMemberUser},
      height: "calc(-80px + 100vh)",
      position: {
        top: '50vh', 
        left: '50%'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var tempMember = [];
        this.tempMemberUser = [];
        result.map(item=> {
          tempMember.push(item.id);
          this.tempMemberUser.push(item);
        })
        this.sendMessageForm.controls.inCopy.patchValue(tempMember);
        //this.fctListeSuject(new MouseEvent('click', {bubbles: true, cancelable: true}));
       } else {
       }
    });
  }

  fctCheckTeam(){
    if(!this.sendMessageForm.value.subProject) return;
    this.setPrivateVaue(false);
    this.selectedProjectType = "team";
        this.multipleRecipient = false;
        this.tempMemberUser = [];
        this.tempRecipientSelected = [];
        this.tempMemberUser = [...this.tempCopyUsers];
        this.sendMessageForm.patchValue({recipient: this.currentUser});
        this.sendMessageForm.controls.inCopy.patchValue([...this.tempMemberUser.map(item => item.id)]);
        this.sendMessageForm.controls.general.patchValue(true);
        this.sendMessageForm.controls.thematic.patchValue(true);
        setTimeout(() => {
          const libcopiesvalue: HTMLElement = document.getElementById('libcopiesvalue') as HTMLElement
          libcopiesvalue.innerHTML = "Toute l'équipe";
        }, 0.5);
  }

  selectTeam(){
        if(!this.sendMessageForm.value.subProject) {
          alert(this.translate.instant('form.alertcanal'));
          return;
        }
        this.setPrivateVaue(false);
        this.selectedProjectType = "team";
        this.multipleRecipient = false;
        this.tempMemberUser = [];
        this.tempRecipientSelected = [];
        this.tempMemberUser = [...this.tempCopyUsers];
        this.sendMessageForm.patchValue({recipient: this.currentUser});
        this.sendMessageForm.controls.inCopy.patchValue([...this.tempMemberUser.map(item => item.id)]);
        this.sendMessageForm.controls.general.patchValue(true);
        this.sendMessageForm.controls.thematic.patchValue(true);
        setTimeout(() => {
          const libcopiesvalue: HTMLElement = document.getElementById('libcopiesvalue') as HTMLElement
          libcopiesvalue.innerHTML = "Toute l'équipe";
        }, 0.5);
        this.descp.focus();
  }

  fctListeRecipient(event: MouseEvent, isPrivate = null){
    if(!this.sendMessageForm.value.subProject) {
      alert(this.translate.instant('form.alertcanal'));
      return;
    }
    var projectUsers = this.projectUsers;
    //if(this.selectedProjectType == "face") projectUsers = this.tempRecipientUser;
    if(this.projectFull.isPrivate) return;
    const dialogRef = this.dialog.open(RecipientListeDialog, {
      panelClass: 'dialogsubject-container',
      data: { idProjet: this.ID, projectUsers: this.tempRecipientUser, usersSelected : this.tempRecipientSelected, subject: this.sendMessageForm.value.subProject.libelle, projectlib: this.projectFull.libelle},
      position: {
        top: '50vh',
        left: '50%'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      //----------------------------------------------------------------
      if (result === "team") {
        this.setPrivateVaue(false);
        this.selectedProjectType = "team";
        this.multipleRecipient = false;
        this.tempMemberUser = [];
        this.tempRecipientSelected = [];
        this.tempMemberUser = [...this.tempCopyUsers];
        this.sendMessageForm.patchValue({recipient: this.currentUser});
        this.sendMessageForm.controls.inCopy.patchValue([...this.tempMemberUser.map(item => item.id)]);
        this.sendMessageForm.controls.general.patchValue(true);
        this.sendMessageForm.controls.thematic.patchValue(true);
        setTimeout(() => {
          const libcopiesvalue: HTMLElement = document.getElementById('libcopiesvalue') as HTMLElement
          libcopiesvalue.innerHTML = "Toute l'équipe";
        }, 0.5);
        this.descp.focus();
      } else if (Array.isArray(result)) {
        this.tempRecipientSelected = [...result];
        this.sendMessageForm.controls.general.patchValue(false);
        if (result.length === 1) {
          this.selectedProjectType = "face";
          this.multipleRecipient = false;
          //console.log("Un seul utilisateur sélectionné :", result[0]);
          this.sendMessageForm.patchValue({
              recipient: result[0].id
          });
          this.sendMessageForm.controls.general.patchValue(false);
          this.sendMessageForm.controls.thematic.patchValue(false);
          this.sendMessageForm.controls.inCopy.patchValue([]);
          if(isPrivate) this.setPrivateVaue(true);
          else this.setPrivateVaue(false);
          const filteredUsers = this.tempCopyUsers.filter(item => item.id !== result[0].id).map(item => item.id);
          this.sendMessageForm.controls.inCopy.patchValue([...filteredUsers]);
          this.tempMemberUser = [];
          this.tempCopyUsers.map(item=> {
            if (item.id !== result[0].id) {
              this.tempMemberUser.push(item);
            }
          })
          setTimeout(() => {
                //const librecipientvalue: HTMLElement = document.getElementById('librecipientvalue') as HTMLElement
                //librecipientvalue.innerHTML = result[0].givenName +" "+result[0].familyName;
                console.log("before "+this.selctedRecipient)
                if(result[0].familyName) var name = result[0].givenName +" "+result[0].familyName;
                //librecipientvalue.innerHTML = result[0].givenName;
                this.selctedRecipient = name;
                console.log("after "+this.selctedRecipient)
                this.selctedRecipientImg = result[0].imageUrl;
                this.selctedRecipientColor = result[0].color;
          }, 0.5);
        this.descp.focus();
        } else if (result.length > 1) {
          this.multipleRecipient = true;
          this.selectedProjectType = "team";
          //console.log("Plusieurs utilisateurs sélectionnés :", result);
          this.sendMessageForm.patchValue({
              recipient: this.currentUser
          });
          this.sendMessageForm.controls.general.patchValue(true);
          this.sendMessageForm.controls.thematic.patchValue(true);
          this.sendMessageForm.controls.inCopy.patchValue([...result.map(item => item.id)]);
          this.tempMemberUser = [];
          result.map(item=> {
            if (item.id !== this.currentUser) {
              this.tempMemberUser.push(item);
            }
          })
          setTimeout(() => {
                const librecipientvalue: HTMLElement = document.getElementById('librecipientvalue') as HTMLElement
                librecipientvalue.innerHTML = result.length + " Membres";
          }, 0.5);
          this.descp.focus();
        } else {
        }
      }
    });
  }

  fctAddMember() {
    const dialogRef = this.dialog.open(DialogAddMember, {
      panelClass: 'dialogmember-container',
      data: {project: this.project, projectUsers: this.projectUsers, project_lib: this.projectFull.libelle}
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed result add membre '+result);    
    });
  }

  showHideAllMessage(){
    if (this.showMessages == true) {
        this.showMessages = false;
    }
    else{
       this.showMessages = true;
    }
  }


  loadAllMessage(){
    this.ged = false;
    this.notifiedmode = false;
    this.keyWord = null;
    localStorage.setItem('notified', "all");
    this.chosenFilterProject = null;
    this.specMsg = null;
    this.specComment = false;
    this.specCom = null;
    this.showRedBar = false;
    this.specMsgType = null;
    this.chosenFilter = null;
    //this.envoyerObs.next();
    this.messageService.messageRefreshConv();
  }

  public filterMessage(wantedFilter){
    //console.log(' wantedFilter --> '+ JSON.stringify(wantedFilter));
    if (this.isEmpty(wantedFilter) == true) 
    {
      this.chosenFilterProject = null;
    }
    else 
    {
      this.chosenFilterProject = wantedFilter;    
    }
    
    //console.log("beeef : "+JSON.stringify(this.chosenFilterProject))
    this.ged = false;
    this.expanded = true;
    this.specMsg = null;
    this.specComment = false;
    this.specCom = null;
    this.showRedBar = false;
    this.specMsgType = null;
    //this.envoyerObs.next();
    this.messageService.messageRefreshConv();
  }

  animateToValue(newValue: number) {
    if (newValue == this.searchresLength) return;
  
    const step = newValue > this.searchresLength ? 1 : -1;
  
    // Durée totale de l'animation (ici 1 seconde, à ajuster si nécessaire)
    const animationDuration = 1000; // 1000 ms = 1 seconde
    const totalSteps = Math.abs(newValue - this.searchresLength); // nombre d'incréments nécessaires
    const stepDuration = animationDuration / totalSteps; // durée de chaque incrément
  
    let startTime = performance.now(); // Horodatage au début de l'animation
    let lastStepTime = startTime; // Temps du dernier "step" effectué
    let currentStep = 0; // Compteur des étapes réalisées
  
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime; // Temps écoulé depuis le début de l'animation
      const progress = Math.min(elapsed / animationDuration, 1); // Calcul du progrès de l'animation
  
      // Nombre d'étapes réalisées jusqu'à maintenant, basé sur le temps écoulé
      currentStep = Math.floor(progress * totalSteps);
  
      // Si une nouvelle étape doit être effectuée
      if (currentTime - lastStepTime >= stepDuration) {
        this.searchresLength = this.searchresLength + step;
        lastStepTime = currentTime; // Mettre à jour le temps du dernier step
  
        // Si la cible est atteinte, on s'assure que la valeur finale est atteinte
        if ((step === 1 && this.searchresLength >= newValue) || (step === -1 && this.searchresLength <= newValue)) {
          this.searchresLength = newValue;
        }
      }
  
      // Si l'animation n'est pas encore terminée, on continue l'animation
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // À la fin de l'animation, on s'assure que la valeur finale est bien celle attendue
        this.searchresLength = newValue;
      }
    };
  
    // Démarre l'animation
    requestAnimationFrame(animate);
  }
  

  animateToValueInst(newValue: number) {
    if (newValue == this.searchresLengthInst) return;
  
    const step = newValue > this.searchresLengthInst ? 1 : -1;
  
    // Durée totale de l'animation (ici 1 seconde, à ajuster si nécessaire)
    const animationDuration = 1000; // 1000 ms = 1 seconde
    const totalSteps = Math.abs(newValue - this.searchresLengthInst); // nombre d'incréments nécessaires
    const stepDuration = animationDuration / totalSteps; // durée de chaque incrément
  
    let startTime = performance.now(); // Horodatage au début de l'animation
    let lastStepTime = startTime; // Temps du dernier "step" effectué
    let currentStep = 0; // Compteur des étapes réalisées
  
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime; // Temps écoulé depuis le début de l'animation
      const progress = Math.min(elapsed / animationDuration, 1); // Calcul du progrès de l'animation
  
      // Nombre d'étapes réalisées jusqu'à maintenant, basé sur le temps écoulé
      currentStep = Math.floor(progress * totalSteps);
  
      // Si une nouvelle étape doit être effectuée
      if (currentTime - lastStepTime >= stepDuration) {
        this.searchresLengthInst = this.searchresLengthInst + step;
        lastStepTime = currentTime; // Mettre à jour le temps du dernier step
  
        // Si la cible est atteinte, on s'assure que la valeur finale est atteinte
        if ((step === 1 && this.searchresLengthInst >= newValue) || (step === -1 && this.searchresLengthInst <= newValue)) {
          this.searchresLengthInst = newValue;
        }
      }
  
      // Si l'animation n'est pas encore terminée, on continue l'animation
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // À la fin de l'animation, on s'assure que la valeur finale est bien celle attendue
        this.searchresLengthInst = newValue;
      }
    };
  
    // Démarre l'animation
    requestAnimationFrame(animate);
  }

  filterMessageCountInst(){

    this.chosenFilterSearchIns = { 
      transmitterinstant: this.transmitterinstant,
      dateBeforeinstant: this.dateBeforeinstant,
      dateAfterinstant: this.dateAfterinstant,
      typeinstant: this.typeinstant,
      keyWordinstant: this.keyWordinstant,
      smartNumber: null
    };
    this.CountMessagesInstant();
  }

  checkSearchInit(){
    if(this.transmitter == null && this.recipient == null && this.copy == null && this.dateBefore  == null && this.dateAfter  == null && this.dateDeadline == null && this.dateDeadlineAfter == null && this.tag == null && this.statut == null && this.type == null && this.keyWord == null && this.smartNumber == null && this.isGeneral == null && this.isThematic == null && this.isTaskSearch == null){
      return true;
    } else {
      return false;
    }
  }

  checkSearchInitIns(){
    if(this.transmitterinstant == null  && this.dateBeforeinstant == null && this.dateAfterinstant == null && this.typeinstant == null && this.keyWord == null){
      return true;
    } else {
      return false;
    }
  }
  

  public filterMessageCount(){
    //console.log(' wantedFilter --> '+ JSON.stringify(wantedFilter));
    this.chosenFilterSearch = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      copy: this.copy,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateAfter: this.dateAfter,
      dateDeadline: this.dateDeadline,
      dateDeadlineAfter: this.dateDeadlineAfter,
      tag: this.tag,
      statut: this.statut, 
      type: this.type,
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber,
      isGeneral: this.isGeneral,
      isThematic: this.isThematic,
      isTask: this.isTaskSearch
    };
    this.refreshSearchObs.next();
  }

  isEmpty(obj) {
    if (obj) {
      for(var key in obj) {
        if ((key != 'projectId') && obj[key] || ((key != 'isThematic') && obj[key] != null) || ((key != 'isGeneral') && obj[key] != null)) {
          return false;
        }
      }
    }
    return true;
  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }



  userInCopyHasNoRead(element){
    if(!element) return false;
    for (var i = 0; i < element.copy.length; i++) {
      if((element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.copy[i].isRead == false)){
        return true;
      }
    }
    return false;
  }

  userInCopyHasRead(element){
    if(!element) return false;
    for (var i = 0; i < element.copy.length; i++) {
      if((element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.copy[i].isRead == true)){
        return true;
      }
    }
    return false;
  }

  isNoRead(element){
    if((element.recipient && element.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.isRecipientRead == false))
    {
      return true;
    }
    return false;
  }

  isRead(element){
    if((element.recipient && element.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.isRecipientRead == true))
    {
      return true;
    }
    return false;
  }


  userIsNotConcerned(element){
    if(!element) return true;
    if(element.recipient && (element.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id']))
    {
      return false;
    }
    for (var i = 0; i < element.copy.length; i++) {
      if(element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']){
        return false;
      }
    } 
    return true;
  }


  userHasRead(element){
    if(!element) return false;
    if((element.recipient && (element.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id'])) && (element.isRecipientRead == true))
    {
      return true;
    }
    else if ((element.recipient && (element.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id'])) && (element.isRecipientRead == false)) {
      return false;
    }
    return false;
  }

  inCopyHasRead(element){
    if(!element) return false;
    for (var i = 0; i < element.copy.length; i++) {
      if((element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.copy[i].isRead == true)){
        return true;
      }
      else if ((element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.copy[i].isRead == false)) {
        return false;
      }
    }
    return false;
  }

  userIsInCopy(element){
    if(!element) return false;
    for (var i = 0; i < element.copy.length; i++) {
      if(element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']){
        return true;
      }
    } 
    return false;
  }

  userIsConcerned(element){
    if(!element) return false;
    if(element.recipient && (element.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id']))
    {
      return true;
    }
    if(element.author && (element.author.id == JSON.parse(localStorage.getItem('currentUser'))['id']))
    {
      return true;
    }
    for (var i = 0; i < element.copy.length; i++) {
      if(element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']){
        return true;
      }
    }
    if (element.answer) {
      for (var i = 0; i < element.answer.copy.length; i++) {
        if(element.answer.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']){
          return true;
        }
      }
    }
    return false;
  }

  userIsConcernedQuestion(element){
    if(!element) return false;
    if(element.recipient && (element.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id']))
    {
      return false;
    }
    for (var i = 0; i < element.copy.length; i++) {
      if(element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']){
        return true;
      }
    }
    return false;
  }


  userIsConcernedResponse(element){
    if(!element) return false;
    if(element.recipient && (element.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id']))
    {
      return true;
    }
    for (var i = 0; i < element.copy.length; i++) {
      if(element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']){
        return true;
      }
    }
    return false;
  }

  youNeedToMarkReadQuestion(element){
    
    if(!element) return false;

    if(element.isMessageDisabled) return false;

    if((element.isRecipientRead == false) && (element.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id'])){
      return true
    }

    for (var i = 0; i < element.copy.length; i++) {
      if((element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.copy[i].isRead == false)){
         return true
      }
    }

    
    return false;

  }

  youNeedToMarkReadResponse(element){
    
    if(!element) return false;

    if(element.isMessageDisabled) return false;

    if (element.answer) {
      
      if((element.answer.isRecipientRead == false) &&  (element.answer.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id'])){
        return true
      }

      for (var i = 0; i < element.answer.copy.length; i++) {
        if((element.answer.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.answer.copy[i].isRead == false)){
           return true
        }
      }

    }

    return false;

  }


  youNeedToMarkAsRead(element, type =""){
    if(!element) return false;

    if(element.isMessageDisabled) return false;
    if(type != 'answer'){
      if((element.isRecipientRead == false) && (element.type != "COMMENT") && (element.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id'])){
        return true
      }

      for (var i = 0; i < element.copy.length; i++) {
        if((element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.copy[i].isRead == false)){
          return true
        }
      }
    }
    if (element.answer) {
      if((element.answer.isRecipientRead == false) && (element.answer.type != "COMMENT") && (element.answer.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id'])){
        return true
      }

      for (var i = 0; i < element.answer.copy.length; i++) {
        if((element.answer.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.answer.copy[i].isRead == false)){
           return true
        }
      }

    }

    return false;

  }

  markAsReadForCopy(element, index, type){
    if (!element) {
      return null;
    }
    const iduser = JSON.parse(localStorage.getItem('currentUser'))['id'];
    if(element.author.id !== iduser && element.recipient.id !== iduser){
      this.markAsReadCopy(element, index, type);
    } else if (element.answer) {
      this.dataSource[index].answer.isRecipientRead = true;
      this.decrementNotif();
      //if(this.notifiedmode === true) this.deleteMsgNotified(this.dataSource[index], index);
      this.authService.markAsRead(element.answer).subscribe(res => {
        this.authService.obreceiveAsread.next(this.ID);
        //this.updateNewProjectNotifications(this.ID);
        if(this.notifiedmode === true) this.deleteMsgNotified(this.dataSource[index], index);
        this.socketService.sendInstant({
          id: element.answer.id,
          action: this.ID,
          type: "MARKREADRESPONSE",
          author: this.currentUser,
          recipient: this.ongletId,
          text: "",
          copy: "",
          private: false,
          res: "",
          date: ""
        });
      },
      error => {
        this.dataSource[index].answer.isRecipientRead = false;
      });
    }
    
  }

  markAsReadAll(element){
    
     this.authService.markAsRead(element).subscribe(res => {
        let idCopy = this.readMarkCopyFct(element);
        if (idCopy) {
          this.authService.markAsReadCopy(idCopy).subscribe(res => {
            if (element.answer) {
              this.markAsReadAll(element.answer);
            }
            else
            {
              this.authService.obreceiveAsread.next(this.ID);
              this.refreshPageObs.next();
              //this.messageService.messageUpdated();
              return;
            }
          },
          error => {
            //alert("oups une erreur s'est produite!");
            if (element.answer) {
              this.markAsReadAll(element.answer);
            }
            else
            {
              this.authService.obreceiveAsread.next(this.ID);
              this.refreshPageObs.next();
              //this.messageService.messageUpdated();
              return;
            }
          });
        }
        else
        {
          if (element.answer) {
            this.markAsReadAll(element.answer);
          }
          else
          {
            this.refreshPageObs.next();
            this.authService.obreceiveAsread.next(this.ID);
            //this.authService.obreceiveAsread.next(this.ID);
            //this.messageService.messageUpdated();
            return;
          }
        }
      },
      error => {
        //alert("oups une erreur s'est produite!");
        let idCopy = this.readMarkCopyFct(element);
        if (idCopy) {
          this.authService.markAsReadCopy(idCopy).subscribe(res => {
            this.authService.obreceiveAsread.next(this.ID);
            if (element.answer) {
              this.markAsReadAll(element.answer);
            }
            else
            {
              this.refreshPageObs.next();
              //this.messageService.messageUpdated();
              return;
            }
          },
          error => {
            //alert("oups une erreur s'est produite!");
            if (element.answer) {
              this.markAsReadAll(element.answer);
            }
            else
            {
              this.refreshPageObs.next();
              //this.messageService.messageUpdated();
              return;
            }
          });
        }
        else
        {
          if (element.answer) {
            this.markAsReadAll(element.answer);
          }
          else
          {
            this.refreshPageObs.next();
            //this.messageService.messageUpdated();
            return;
          }
        }
      });
  }

  checkAllReadMsg(element){
    if((this.userIsConcerned(element) == true) && (this.youNeedToMarkAsRead(element) == true)){
        return true;
    } else if(element.comment){
        var comments = element.comment;
        comments.forEach(element => {
        if(this.isNoRead(element) || this.userInCopyHasNoRead(element)) return true;
        });
        
    }
    return false;
  }

  trackByIndex(index: number, item: any): number {
    return index; // ou `item.id` si vous avez un identifiant unique
  }
  

  deleteFace(index: number) {
    // Lancer la suppression après un délai pour respecter l'animation
    //alert("deleted : "+index)
    this.dataSource[index].isDeleting = true;
    setTimeout(() => {
      this.dataSource.splice(index, 1);  // Supprimer l'élément du tableau
    }, 1000);  // Correspond à la durée de l'animation
  }

  delMsgDisabled(i){
    if(this.dataSource.length > 1) {
      //this.dataSource.splice(i, 1);
      this.deleteFace(i);
    } else if(this.dataSource.length == 1) {
      this.deleteFace(i);
      this.isVisible = true;
      setTimeout(() => {
        this.isVisible = false;
        this.loadAllMessage();
      }, 2000);
      //alert("tous vos messages sont traités");
      //this.loadAllMessage();
    }
  }

  checkDelMsg(element, i){
    var deleted = true;
    var iduser = JSON.parse(localStorage.getItem('currentUser'))['id'];
    element.comment.forEach(comment => {
      comment.copy.forEach(cp => {
        if(cp.user.id === iduser && cp.isRead == false) deleted = false;
      })
    })
    if(!deleted) return;
    if(this.dataSource.length > 1) {
      //this.dataSource.splice(i, 1);
      this.deleteFace(i);
    } else if(this.dataSource.length == 1) {
      this.isVisible = true;
      setTimeout(() => {
        this.isVisible = false;
        this.loadAllMessage();
      }, 2000);
      //alert("tous vos messages sont traités");
      //this.loadAllMessage();
    }
  }

  deleteMsgNotified(element, i){
    var deleted = true;
    var iduser = JSON.parse(localStorage.getItem('currentUser'))['id'];
    if(element.author.id == iduser) {
      if(!element.answer && !element.isThematic && !element.isGeneral){
        deleted = false;
      } else if(element.answer.isRecipientRead == false) deleted = false;
    } else if(element.recipient.id == iduser) {
      if(!element.answer) deleted = false;
    } else {
        element.copy.forEach(copy => {
          if(copy.user.id == iduser && copy.isRead == false) {
            deleted = false;
            return;
          }
        })
        if(element.answer){
          element.answer.copy.forEach(copy => {
            if(copy.user.id == iduser && copy.isRead == false) {
              deleted = false;
              return;
            }
          })
        }
    }
    if(element.comment){
      element.comment.forEach(comment => {
        comment.copy.forEach(cp => {
          if(cp.user.id === iduser && cp.isRead == false) {
            deleted = false;
            return;
          }
        })
      })
    }
    if(this.dataSource.length > 1 && deleted) {
      this.deleteFace(i);
    } else if(this.dataSource.length == 1) {
      this.isVisible = true;
      setTimeout(() => {
        this.isVisible = false;
      }, 2000);
      //alert("tous vos messages sont traités");
      this.loadAllMessage();
    }
  }


  readMarkCopyFct(element){
      if (!element) {
        return null;
      }
      for (var i = 0; i < element.copy.length; i++) {
        if((element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.copy[i].isRead == false)){
          return element.copy[i].id;
        }
      }
      return null;
  }

  markAsReadComment(element, indexmsg, indexcmt){
    for (var i = 0; i < element.copy.length; i++) {
      if((element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.copy[i].isRead == false)){
        this.dataSource[indexmsg].comment[indexcmt].copy[i].isRead = true;
        if(this.notifiedmode === true && !this.youNeedToMarkReadQuestion(this.dataSource[indexmsg]) && !this.youNeedToMarkReadResponse(this.dataSource[indexmsg])) this.checkDelMsg(this.dataSource[indexmsg], indexmsg);
        this.decrementNotif();
        this.authService.markAsReadCopy(element.copy[i].id).subscribe(res => {
          //this.refreshPageObs.next();
          //this.messageService.messageUpdated();
          this.authService.obreceiveAsread.next(this.ID);
          this.socketService.sendInstant({
            id: this.dataSource[indexmsg].id,
            action: this.ID,
            type: "MARKREADCOMMENT",
            author: this.currentUser,
            recipient: this.ongletId,
            text: "",
            copy: "",
            private: false,
            res: this.dataSource[indexmsg].comment[indexcmt].id,
            date: ""
          });
        },
        error => {
          this.dataSource[indexmsg].comment[indexcmt].copy[i].isRead = false;
          alert("oups une erreur s'est produite!");
        });
        return;
      }
    }
  }

  markAsRead(element){
    if((element.isRecipientRead == false) && (element.type != "COMMENT") && (element.recipient.id == JSON.parse(localStorage.getItem('currentUser'))['id'])){
      this.authService.markAsRead(element).subscribe(res => {
        this.refreshPageObs.next();
      },
      error => {
        alert("oups une erreur s'est produite!");
      });
    }
    else
    {
       for (var i = 0; i < element.copy.length; i++) {
        if((element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.copy[i].isRead == false)){
          this.authService.markAsReadCopy(element.copy[i].id).subscribe(res => {
            this.refreshPageObs.next();
            //this.messageService.messageUpdated();
            this.authService.obreceiveAsread.next(this.ID);
          },
          error => {
            alert("oups une erreur s'est produite!");
          });
          return;
        }
      }
    }
  }

  markAsReadbis(element){

     this.authService.markAsRead(element).subscribe(res => {
        if (element.answer) {
          this.authService.markAsRead(element.answer).subscribe(res => {
            this.refreshPageObs.next();
            //this.messageService.messageUpdated();
          },
          error => {
            alert("oups une erreur s'est produite!");
          });
        }
        else
        {
          this.refreshPageObs.next();
          //this.messageService.messageUpdated();
        }
      },
      error => {
        alert("oups une erreur s'est produite!");
      });

  }

  markAsReadCopy(element, indexmsg = null, type){
    var countData = this.dataSource.length;
    if(type=="question"){
      for (var i = 0; i < element.copy.length; i++) {
        if((element.copy[i].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.copy[i].isRead == false)){
          this.dataSource[indexmsg].copy[i].isRead = true;
          this.decrementNotif();
          if(this.notifiedmode === true) {
            //alert("ok del")
            this.deleteMsgNotified(this.dataSource[indexmsg], indexmsg);
          }
          this.authService.markAsReadCopy(element.copy[i].id).subscribe(res => {
            this.socketService.sendInstant({
              id: element.id,
              action: this.ID,
              type: "MARKREADCPYQUESTION",
              author: this.currentUser,
              recipient: this.ongletId,
              text: "",
              copy: "",
              private: false,
              res: "",
              date: ""
            });
            // socket MARKREADQUESTION
            //this.refreshPageObs.next();
            if(!element.isMessageDisabled) this.authService.obreceiveAsread.next(this.ID);
            //this.messageService.messageUpdated()
          },
          error => {
            alert("oups une erreur s'est produite!");
            this.dataSource[indexmsg].copy[i].isRead = false;
          });
        }
      }
    } else if(type=="answer"){

      for (var index = 0; index < element.answer.copy.length; index++) {
        if((element.answer.copy[index].user.id == JSON.parse(localStorage.getItem('currentUser'))['id']) && (element.answer.copy[index].isRead == false)){
          this.dataSource[indexmsg].answer.copy[index].isRead = true;
          this.decrementNotif();
          this.authService.markAsReadCopy(element.answer.copy[index].id).subscribe(res => {
            if(this.notifiedmode === true) {
              this.deleteMsgNotified(this.dataSource[indexmsg], indexmsg);
            }
            this.socketService.sendInstant({
              id: element.id,
              action: this.ID,
              type: "MARKREADCPYRESPONSE",
              author: this.currentUser,
              recipient: this.ongletId,
              text: "",
              copy: "",
              private: false,
              res: "",
              date: ""
            });
            this.authService.obreceiveAsread.next(this.ID);
          },
          error => {
            alert("oups une erreur s'est produite!");
            this.dataSource[indexmsg].answer.copy[index].isRead = false;
          });
        }
      }
    }
  }

  decrementNotif(){
    if(this.notifNbr > 0){
      this.notifNbr--;
    }
  }


  fctinfoProjet(): void{
    const dialogRef = this.dialog.open(projectInfoDialog, {
      width: '500px',
      data: this.projectFull
    });
    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed fctinfoProjet '+result); 
        if (result && result.deleteReturn) {
          this.authService.obRefreshProjet.next();
          this.router.navigate(['/']);
        }else if (result) {
          this.projectFull = result;
          //this.authService.obRefreshProjet.next();
       }  

    });
  }

  changeSubject(){
    
    if (this.showTool == true) {
      this.showTool = false;
      this.messageService.setShowProjectTutobis(false);
    }

    const dialogRef = this.dialog.open(subjectInfodialog, {
      width: '500px',
      data: {
        projectData : this.projectFull,
        sendMessageForm : this.sendMessageForm
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed fctinfoProjet '+result); 
      if (result) {
       this.sendMessageForm.patchValue({
          subProject: result
        });
      } 
    });

  }

  disabledMessage(messageData): void{
    var copies = [];
    if(messageData.copy.length){
      messageData.copy.forEach(element => {
        //if(element.user && element.user.id)
        copies.push(element.user.id);
      })
    }
    this.authService.disableMessage(messageData)
    .subscribe(res => {
      this.updateCurrentNotifications(this.ID).subscribe((total) => {
        this.notifNbr=total;
      });
      //this.refreshPageObs.next();
      const messageIndex = this.dataSource.findIndex(message => message.id === messageData.id);
      if (messageIndex !== -1) {
        // 2. Ajouter le nouveau commentaire dans le tableau des commentaires du message
        this.dataSource[messageIndex].isMessageDisabled = true;
        this.dataSource[messageIndex].comment.forEach(element => {
          if(this.userInCopyHasNoRead(element)) {
            this.markAsRead(element);
            //element.isRead = true;
          } else {
          }
        });
      }
      //TO DO ENLEVER RAFRAISCHISSEMENT
      //this.messageService.messageUpdated();
      this.messageService.obdisableMessage.next(this.ID);
      this.socketService.sendInstant({
        id: messageData.id,
        action: this.ID,
        type: "DISABLE",
        author: this.currentUser,
        recipient: messageData.recipient.id,
        text: "",
        copy: copies,
        private: messageData.private,
        res: res,
        date: res['dateCreated']
      });
    },
    error => {
      alert("oups une erreur s'est produite!");
    }); 
  }

  disabledMessageNotified(messageData, index): void{
    var copies = [];
    if(messageData.copy.length){
      messageData.copy.forEach(element => {
        //if(element.user && element.user.id)
        copies.push(element.user.id);
      })
    }
    this.authService.disableMessage(messageData)
    .subscribe(res => {
      //this.dataSource.splice(index, 1);
      this.updateCurrentNotifications(this.ID).subscribe((total) => {
        this.notifNbr=total;
      });
      //const messageIndex = this.dataSource.findIndex(message => message.id === messageData.id);
      if (index !== -1) {
        // 2. Ajouter le nouveau commentaire dans le tableau des commentaires du message
        this.dataSource[index].isMessageDisabled = true;
        this.dataSource[index].comment.forEach(element => {
          if(this.userInCopyHasNoRead(element)) {
            this.markAsRead(element);
            //element.isRead = true;
          } else {
          }
        });
        if(this.notifiedmode){
            this.delMsgDisabled(index);
        }
      }
      //this.messageService.messageUpdated();
      this.messageService.obdisableMessage.next(this.ID);
      this.socketService.sendInstant({
        id: messageData.id,
        action: this.ID,
        type: "DISABLE",
        author: this.currentUser,
        recipient: messageData.recipient.id,
        text: "",
        copy: copies,
        private: messageData.private,
        res: res,
        date: res['dateCreated']
      });
    },
    error => {
      alert("oups une erreur s'est produite!");
    }); 
  } //to do here 

  recalls(messageData): void{
    this.authService.recalls(messageData).subscribe(res => {
      this.refreshPageObs.next();
      //this.messageService.messageUpdated();
      alert("Rappel envoyé");
    },
    error => {
      //console.log('error '+JSON.stringify(error));   
      alert(error['error']['hydra:description']);
    }); 
  }
 
  compare( a, b ) {
    if ( a.fullName.toLowerCase() < b.fullName.toLowerCase() ){
      return -1;
    }
    if ( a.fullName.toLowerCase() > b.fullName.toLowerCase() ){
      return 1;
    }
    return 0;
  }

  getUserSubjects(){
    this.onlyUserTags = [];
    this.authService.getUserSubjects(this.iDProjet).subscribe(res => {
      this.onlyUserTags = res['hydra:member'];
      this.onlyUserTags.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }, (error) => {
    });
  }

  getInfoProject(){

    if (!this.iDProjet) {
      return;
    }
    this.saveTheme = null
    this.projectId = this.iDProjet;
    //console.log("iddproject "+this.projectId)
    this.authService.getOneProject(this.iDProjet).subscribe(res => {
      this.projectTags = res['tags'];
      this.projectTags.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }, (error) => {
    });
    
  }

  getProjectExp(){
    this.authService.getContactsExpID(this.ID, this.tag, this.isThematic, this.isGeneral).subscribe(res => {
      //var tmpArrayUser = res['hydra:member'];
      this.contactsExp = [];
      this.contactsExp = res['hydra:member'];
      this.contactsExp.sort(this.compare);
      this.contactsExp.forEach(element => {
        const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
        element.color = this.vibrantColors[randomIndex];
      });
      this.searchSenderInit = this.contactsExp;
      this.transmittersLoaded.emit(this.searchSenderInit);
    }, (error) => {
    });
  }

  getProjectDest(){
    this.authService.getContactsRecipID(this.ID).subscribe(res => {
      var tmpArrayUser = res['hydra:member'];
      this.contactsDest = [];
      for (var i = 0; i < tmpArrayUser.length; i++) {
        if(tmpArrayUser[i].id){
          this.contactsDest.push(tmpArrayUser[i]);
        }
      }
      this.contactsDest.sort(this.compare);
      this.contactsDest.forEach(element => {
        const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
        element.color = this.vibrantColors[randomIndex];
      });
      this.searchRecipientInit = this.contactsDest;
      this.recipientsLoaded.emit(this.searchRecipientInit);
    }, (error) => {
    });
  }


  getReceiver(recipientid = null){
    this.authService.getRecipientsBySender(this.ID, recipientid, this.tag, this.isThematic, this.isGeneral).subscribe(res => {
      var tmpArrayUser = res['hydra:member'];
      this.contactsDest = [];
      for (var i = 0; i < tmpArrayUser.length; i++) {
        if(tmpArrayUser[i].id){
          this.contactsDest.push(tmpArrayUser[i]);
        }
      }
      this.contactsDest.sort(this.compare);
      this.contactsDest.forEach(element => {
        const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
        element.color = this.vibrantColors[randomIndex];
      });
      this.searchRecipientInit = this.contactsDest;
    }, (error) => {
    });
  }

  getTags(){
    this.searchTags = [];
    this.authService.getTagsByProject(this.ID, this.isThematic, this.isGeneral).subscribe(res => {
      this.searchTags = this.searchTags.concat(res['hydra:member']);
      this.searchTagInit = this.searchTags;
      this.searchTagInit.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
      this.tagsLoaded.emit(this.searchTagInit);
    }, (error) => {
    });
  }


  getCopy(){
    this.authService.getCopy(this.ID, this.transmitter, this.recipient, this.tag).subscribe(res => {
      var tmpArrayUser = res['hydra:member'];
      this.contactsCopy = [];
      for (var i = 0; i < tmpArrayUser.length; i++) {
        if(tmpArrayUser[i].id){
          this.contactsCopy.push(tmpArrayUser[i]);
        }
      }
      this.contactsCopy.sort(this.compare);
      this.contactsCopy.forEach(element => {
        const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
        element.color = this.vibrantColors[randomIndex];
      });
      this.searchCopyInit = this.contactsCopy;
      this.copiesLoaded.emit(this.searchCopyInit);
    }, (error) => {
    });
  }


  loadSendersIns(){
    this.authService.getContactsExpInstant(this.ID).subscribe(res => {
      this.projectSenders = res['hydra:member'];
      this.projectSenders.sort((a, b) => {
          if ( a.fullName.toLowerCase() < b.fullName.toLowerCase() ){
              return -1;
            }
            if ( a.fullName.toLowerCase() > b.fullName.toLowerCase() ){
              return 1;
            }
            return 0;
        })
      this.projectSenders.forEach(element => {
        const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
        element.color = this.vibrantColors[randomIndex];
      });
      this.projectSendersInit = this.projectSenders;
      console.log("lennn : "+this.projectSendersInit.length)
      //this.sendersLoadedInstant.emit(this.projectSendersInit);
    }, (error) => {
    });
  }

  loadDocsSendersIns(){
    this.authService.getDocsExpInstant(this.ID).subscribe(res => {
      this.projectDocSenders = res['hydra:member'];
      this.projectDocSendersInit = this.projectDocSenders;
      console.log("senders doc project "+this.projectDocSendersInit.length)
      this.sendersLoadedInstant.emit(this.projectDocSendersInit);
    }, (error) => {
    });
  }

  loadTypes(url?: string){
    this.searchtypesApi = [];
    this.authService.getMessageTypes(this.ID, this.transmitter, this.recipient, this.copy, this.tag).subscribe(res => {
      this.searchtypesApi = this.searchtypesApi.concat(res['hydra:member']);
      this.searchtypes = this.searchtypesfilter.filter(item => this.searchtypesApi.includes(item.id));
      this.typesLoaded.emit(this.searchtypes);
    }); 
  }

  loadTypesBlocs(url?: string){
    this.searchtypesblocs = [];
    this.authService.getMessageBlocTypes(this.ID, this.transmitter, this.recipient, null, this.tag).subscribe(res => {
      this.searchtypesblocs = this.searchtypesblocs.concat(res['hydra:member']);
    }); 
  }

  loadTypesIns(url?: string){
    this.searchtypesInsApi = [];
    this.authService.getMessageTypesIns(this.ID, this.transmitterinstant).subscribe(res => {
      this.searchtypesInsApi = this.searchtypesInsApi.concat(res['hydra:member']);
      this.searchtypesIns = this.searchtypesInsfilter.filter(item => this.searchtypesInsApi.includes(item.id));
      this.typesLoadedInstant.emit(this.searchtypesIns);
    }); 
  }

  getMessageStatus(){
  }


  launchSearchInstant(){
    this.searchItem = true;
    this.modeDoc = false;
    this.hiddenSearchEngin = true;

    this.chosenFilterInstant = { 
      transmitterinstant: this.transmitterinstant,
      dateBeforeinstant: this.dateBeforeinstant,
      dateAfterinstant: this.dateAfterinstant,
      typeinstant: this.typeinstant,
      keyWordinstant: this.keyWordinstant,
      smartNumber: null
    };
    //this.getMessagesInstant();
    if(!this.transmitterinstant && !this.dateBeforeinstant && !this.dateAfterinstant && !this.typeinstant && !this.keyWordinstant){
      this.search = false;
    } else this.search = true;
    this.EventLaunchSearch.emit(this.chosenFilterInstant);
    this.searchMessagesInstant();
    //this.search = true;

  }


  launchSearch(filtre = null, search = null){
    this.searchface = search;
    this.modeDoc = false;
    this.notifiedmode = false;
    localStorage.setItem('notified', "all");
    var task = this.isTaskSearch;
    if(filtre) task = this.isTaskMode
    this.chosenFilter = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      copy: this.copy,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateAfter: this.dateAfter,
      dateDeadline: this.dateDeadline,
      dateDeadlineAfter: this.dateDeadlineAfter,
      tag: this.tag,
      statut: this.statut, 
      type: this.type,
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber,
      isGeneral: this.isGeneral,
      isThematic: this.isThematic,
      isTask: task
    };
    this.EventLaunchSearch.emit(this.chosenFilter);
    if(this.transmitter == null && this.recipient == null && this.copy == null && this.dateBefore  == null && this.dateAfter  == null && this.dateDeadline == null && this.dateDeadlineAfter == null && this.tag == null && this.statut == null && this.type == null && this.keyWord == null && this.smartNumber == null && this.isGeneral == null && this.isThematic == null && task == null){
      this.isSearch = false;
    } else this.isSearch = true;

  }

  launchSearchDocInstant(){
    if(this.typeinstant=="http") {
      alert("Vous ne pouvez pas sélectionner le type lien pour rechercher un document");
      return;
    }
    this.searchItem = true;
    this.modeDoc = true;
    this.hiddenSearchEngin = true;

    this.chosenFilterInstant = { 
      transmitterinstant: this.transmitterinstant,
      dateBeforeinstant: this.dateBeforeinstant,
      dateAfterinstant: this.dateAfterinstant,
      typeinstant: this.typeinstant,
      keyWordinstant: this.keyWordinstant,
      smartNumber: "projectinstant"
    };
    this.EventLaunchSearchDoc.emit(this.chosenFilterInstant);
    this.fcthiddenSearchEngin();
    this.searchinstant = false;
  }

  launchSearchDoc(){
    if(this.type=="http") {
      alert("Vous ne pouvez pas sélectionner le type lien pour rechercher un document");
      return;
    }
    this.modeDoc = true;

    this.chosenFilter = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      copy: this.copy,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateAfter: this.dateAfter,
      dateDeadline: this.dateDeadline,
      dateDeadlineAfter: this.dateDeadlineAfter,
      tag: this.tag,
      statut: this.statut,
      type: this.type, 
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber, 
      drive: this.drive
    };
    //this.fcthiddenSearchEngin();
    this.EventLaunchSearchDoc.emit(this.chosenFilter);

  }

  launchSearchInit(){

    this.modeDoc = false;
    //this.hiddenSearchEngin = true;

    this.chosenFilter = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      copy: this.copy,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateAfter: this.dateAfter,
      dateDeadline: this.dateDeadline,
      dateDeadlineAfter: this.dateDeadlineAfter,
      tag: this.tag,
      statut: this.statut, 
      type: this.type,
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber,
      isGeneral: this.isGeneral,
      isThematic: this.isThematic
    };
    //console.log(' launchSearch '+ JSON.stringify(this.chosenFilter) );
    //this.fcthiddenSearchEngin();
    this.EventLaunchSearch.emit(this.chosenFilter);

  }

  checkMsgBar(element){
    if ((this.authService.isNotified || this.authService.isAnsweredNotified) && (/*(element.recipient.id) && !element.answer 
          || */((this.userIsConcerned(element) == true) && (this.youNeedToMarkAsRead(element) == true))
          ) ){
      return true;
    } else return false;
  }

  public resetSearch(){
    this.notifiedmode = false;
    this.modeDoc = false;
    localStorage.setItem('notified', "all");
    this.transmitter = null;
    this.recipient = null;
    this.copy=null,
    this.projectId = null;
    this.dateBefore  = null;
    this.dateAfter  = null;
    this.dateDeadline = null;
    this.dateDeadlineAfter = null;
    this.tag = null;
    this.statut = null;
    this.type = null;
    this.keyWord = null;
    this.smartNumber = null;
    this.isSearch = false;
    this.isGeneral = null;
    this.isThematic = null;
    this.isTaskMsg = null;
    this.statusMsg = null;
    this.isMessage = false;
    this.isTache = false;
    this.isTaskSearch = null;
    this.isMessage = false;
    this.isDocument = false;
    this.isAlltype = true;
    this.searchface = null;
    //this.searchresLength = 0;
    this.resetSearchFace();
    this.launchSearchInit();
 
    this.getInfoProject();
    this.getTags();
    this.getProjectExp();
    this.getProjectDest();
    //this.getReceiver();
    this.getCopy();
    this.loadTypes();
    this.loadTypesBlocs();
    this.animateToValue(this.searchresLength);

  }

  public resetSearchInstant(){
    this.transmitterinstant = null;
    this.dateBeforeinstant  = null;
    this.dateAfterinstant  = null;
    this.typeinstant = null;
    this.keyWordinstant = "";
    this.search = false;
    this.modeDoc = false;
    this.animateToValueInst(this.searchresLengthInst);
    this.searchresLengthInst = this.resultsLengthIns;
    //this.hiddenSearchEngin = true;
    this.resetSearchIns();
    this.loadSendersIns();
    this.loadDocsSendersIns();
    this.loadTypesIns();

  }

  public projecthasChange(newIdProject){
    
    //console.log("project changed")
    //this.subscriptions.forEach(sub => sub.unsubscribe());
    //this.destroy$.next();
    //this.destroy$.complete();
    //this.cancelRequest$.next();
    //this.cancelRequest$.complete();
    //console.log("project changed stop old requests")
    //console.log(' projecthasChange => '+newIdProject);
    
    this.iDProjet = newIdProject;
    this.ID = newIdProject;
    this.facesent = false;
    this.transmitter = null;
    this.recipient = null;
    this.projectId = null;
    this.dateBefore  = null;
    this.dateAfter  = null;
    this.dateDeadline = null;
    this.dateDeadlineAfter = null;
    this.tag = null;
    this.statut = null;
    this.type = null;
    this.keyWord = null;
    this.smartNumber = null;
    this.resetSearchFace();
    this.resetforminstant();
  }

  public projectlibChanged(libelle){
    this.messagesInstant = [];
    this.projectFull.libelle = libelle;
  }

  public projectImageChanged(url){
    if(this.projectFull) this.projectFull.imageUrl = url;
  }

  public refreshInfoFilter(){  
    this.getInfoProject();
    this.getProjectExp();
    this.getProjectDest();
  }

  openDialogInfoWrite(){
    
    const dialogRef = this.dialog.open(infoWriteMessageDialog, {
      width: '900px',
      data:{}
    });

    dialogRef.afterClosed().subscribe(result => {
       
      if (result){ 
       
      }

    })

  }

  openDialogEcheance(){
    
    const dialogRef = this.dialog.open(DeadLineConvDialog, {
      width: '500px',
      data:{}
    });
 
    dialogRef.afterClosed().subscribe(result => {
       
      if (result){ 
      }

    })

  }

  selectType2(type: 'message' | 'tache') {
    this.selectedType = type;
  }
 
  goToStep(step: number) {
    this.currentStep = step;
  }
 
  togglePrivate() {
    this.private = !this.private;
  }
 
  browseFile(event: Event) {
    //event.stopPropagation();
    this.fileInput.nativeElement.click();
  }
 
  onFileSelected(event: any) {
    const files = event.target.files;
    //const input = event.target as HTMLInputElement;
    if (files && files.length > 0) {
      console.log('Fichier sélectionné:', files[0].name);
    }
  }
 
  submit() {
    if (!this.form.mission) {
      alert('Veuillez choisir un canal.');
      return;
    }
    if (!this.form.destinataire) {
      alert('Veuillez choisir un destinataire responsable.');
      return;
    }
    console.log('Formulaire soumis:', {
      type: this.selectedType,
      ...this.form,
      private: this.private
    });
  }



}

@Component({
  selector: 'messageTypeList-dialog',
  templateUrl: './messageTypeList-dialog.html',
  styleUrls: ['./messageTypeList-dialog.scss']
})
export class MessageTypeListeDialog {

  isAdmin = false;
  constructor(
    public dialogRef: MatDialogRef<SubjectListeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public  dialog: MatDialog)   {
      this.isAdmin = data.isAdmin;
  }

  selectType(type){
    this.dialogRef.close(type);
  }

  onNoClick(): void {
      this.dialogRef.close();
  }

}

@Component({
  selector: 'recipientList-dialog',
  templateUrl: './recipientList-dialog.html',
  styleUrls: ['./recipientList-dialog.scss']
})
export class RecipientListeDialog {

  filter = "noall";
  projectusers = [];
  recipients = [];
  usersSelected = [];
  projectusersInit = [];
  copiesSeelected = null;
  searchRecipient : any = null;
  ID : any;
  project: string;
  addingCopies = [];
  librecipient = "";
  subject = "";
  projectlib = "";
  currentUser = null;
  vibrantColors = [
    "#e7e0ff", // bleu très clair
    "#caf1ee", // vert très clair
    "#fff0d3", // orange clair
    "#fbd8dc", // rose clair  #fdc1c8
    "#d8fdd2", // violet clair
    "#f4ded1", // turquoise clair   fdc1c8
    "#d1e8ff", // mauve clair
    "#cbf2ef"
  ];

  colorMap: Record<string, string> = {
    '#e7e0ff': '#5d45de', // bleu → violet foncé
    '#caf1ee': '#008476', // vert → vert foncé
    '#fff0d3': '#9d6b2b', // orange → brun
    '#fbd8dc': '#cd0635', // rose → bordeaux
    '#d8fdd2': '#1c8555', // vert → vert foncé
    '#f4ded1': '#855436', // beige → marron
    '#d1e8ff': '#0060d3', // bleu → bleu foncé
    '#cbf2ef': '#008379'  // turquoise → turquoise foncé
  };

  constructor(
    public dialogRef: MatDialogRef<SubjectListeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public  dialog: MatDialog)   {
      this.ID = data.idProjet;
      this.project = '/api/projects/' + this.ID;
      this.projectusers = data.projectUsers;
      this.projectusersInit = data.projectUsers;
      this.subject = data.subject;
      this.projectlib = data.projectlib;
      this.recipients = data.usersSelected;
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      //console.log("leeeen : "+this.projectusers.length)
  }
  
  getInitials(libelle: string): string {
      const words = libelle.split(' ');
      //return "rrr";
      const getFirstChar = (word: string): string => {
        return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
      };
      const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point
      return initials;
  }

  darkenColor(bgColor: string) {
    if (!bgColor) return '#444';
    const key = bgColor.toLowerCase().substring(0, 7);
    return this.colorMap[key] || '#444'
  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  selectAll(){
    this.addingCopies = [];
    this.projectusers.forEach((item) => this.addingCopies.push(item.user));
  }

  fctCheckCopy(user){ 
    user.generic = false;
    this.dialogRef.close(user);
  }

  fctValidateRecipients(user){ 
    this.dialogRef.close(this.recipients);
  }

  fctCheckGeneric(){ 
    this.recipients = [];
    this.dialogRef.close("general");
  }

  fctCheckTeam(user){ 
    this.recipients = [];
    this.dialogRef.close("team");
  }

  fctRemoveCopy(userInfo){
    const index = this.addingCopies.indexOf(userInfo);
    if (index > -1) {
      this.addingCopies.splice(index, 1);
    }
  }

  fctCheckUser(userInfo){ 
    this.recipients = [];
    this.recipients.push(userInfo);
    this.dialogRef.close(this.recipients);
  }

  fctRemoveRecipient(userInfo) {
    const index = this.recipients.findIndex(user => user.id === userInfo.id);
    if (index > -1) {
      this.recipients.splice(index, 1);
    }
  }

  onSearch() {
    if (this.searchRecipient.trim() === '' || this.searchRecipient == null) {
      this.searchRecipient = null;
      this.projectusers = this.projectusersInit;
      this.filterProjects(this.filter);
    } else {
      var search = this.searchRecipient.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.projectusers = this.projectusersInit.filter(bank => bank.givenName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  validateCopies(){
    this.dialogRef.close(this.addingCopies);
  }

  onNoClick(): void {
      this.dialogRef.close();
  }

  filterProjects(val : any){
    this.filter = val;
    if(val == "date"){
        this.projectusers.sort((a, b) => {
          if ( a.user.createdAt > b.user.createdAt ){
            return -1;
          }
          if ( a.user.createdAt < b.user.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.projectusers.sort((a, b) => {
        if ( a.user.givenName.toLowerCase() < b.user.givenName.toLowerCase() ){
          return -1;
        }
        if ( a.user.givenName.toLowerCase() > b.user.givenName.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

}

@Component({
  selector: 'copyList-dialog',
  templateUrl: './copyList-dialog.html',
  styleUrls: ['./copyList-dialog.scss']
})
export class CopyListeDialog {

  filter = "noall";
  copyusers = [];
  copyusersInit = [];
  copiesSeelected = [];
  searchCopy : any = null;
  ID : any;
  project: string;
  addingCopies = [];
  userSelected = [];

  vibrantColors = [
    "#e7e0ff", // bleu très clair
    "#caf1ee", // vert très clair
    "#fff0d3", // orange clair
    "#fbd8dc", // rose clair  #fdc1c8
    "#d8fdd2", // violet clair
    "#f4ded1", // turquoise clair   fdc1c8
    "#d1e8ff", // mauve clair
    "#cbf2ef"
  ];

  colorMap: Record<string, string> = {
    '#e7e0ff': '#5d45de', // bleu → violet foncé
    '#caf1ee': '#008476', // vert → vert foncé
    '#fff0d3': '#9d6b2b', // orange → brun
    '#fbd8dc': '#cd0635', // rose → bordeaux
    '#d8fdd2': '#1c8555', // vert → vert foncé
    '#f4ded1': '#855436', // beige → marron
    '#d1e8ff': '#0060d3', // bleu → bleu foncé
    '#cbf2ef': '#008379'  // turquoise → turquoise foncé
  };

  constructor(
    public dialogRef: MatDialogRef<SubjectListeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public  dialog: MatDialog)   {
      this.ID = data.idProjet;
      this.project = '/api/projects/' + this.ID;
      this.copyusers = data.projectCopies;
      this.copyusersInit = data.projectCopies;
      this.addingCopies = data.userSelected;
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  getInitials(libelle: string): string {
      const words = libelle.split(' ');
      //return "rrr";
      const getFirstChar = (word: string): string => {
        return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
      };
      const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point
      return initials;
  }

  darkenColor(bgColor: string) {
    if (!bgColor) return '#444';
    const key = bgColor.toLowerCase().substring(0, 7);
    return this.colorMap[key] || '#444'
  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  selectAll(){
    if(this.addingCopies.length == this.copyusersInit.length){
      this.addingCopies = [];
    } else {
      this.addingCopies = [];
      this.copyusersInit.forEach((item) => this.addingCopies.push(item.user));
    }
  }

  fctCheckUser(userInfo){ 
    const exists = this.addingCopies && this.addingCopies.some(user => user.id === userInfo.id);
    if (this.addingCopies && !exists) {
      this.addingCopies.push(userInfo);
    } else {
      this.fctRemoveCopy(userInfo);
    }
  }

  fctRemoveCopy(userInfo) {
    const index = this.addingCopies.findIndex(user => user.id === userInfo.id);
    if (index > -1) {
      this.addingCopies.splice(index, 1);
    }
  }

  isUserChecked(id: any): boolean {
    return this.addingCopies.some(u => u.id === id);
  }

  onSearch() {
    if (this.searchCopy.trim() === '' || this.searchCopy == null) {
      this.searchCopy = null;
      this.copyusers = this.copyusersInit;
    } else {
      var search = this.searchCopy.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.copyusers = this.copyusersInit.filter(bank => bank.user.givenName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.user.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }

  validateCopies(){
    this.dialogRef.close(this.addingCopies);
  }

  onNoClick(): void {
      this.dialogRef.close();
  }

  filterProjects(val : any){
    this.filter = val;
    if(val == "all"){
        this.copyusers.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.copyusers.sort((a, b) => {
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

}

@Component({
  selector: 'subjectList-dialog',
  templateUrl: './subjectList-dialog.html',
  styleUrls: ['./subjectList-dialog.scss']
})
export class SubjectListeDialog implements OnInit{

  updclicked = false;
  general = false;
  isAdmin = false;
  isPrivate = false;
  searchProject : any = null;
  searchUser : any = null;
  searchTag : any = null;
  searchProj : any = null;
  filterRead = false;
  ID : any;
  projectTags = [];
  projectTagsInit = [];
  projectUsersInit = [];
  projectsInit = [];
  selectedUsers = [];
  updateSubject = "";
  filter = "date";
  filterproj = "alpha";
  step = 1;
  userStatus = null;
  namesubject = "";
  renameLength = 0;
  currentUser : any;
  ongletId = this.messageService.getOngletId();
  indexUpd = 0;
  subjectUpd : any;
  project: string;
  @ViewChild('tagname', {static: false}) missionname: ElementRef;
  tagnameLength = 0;
  projectLists: Array<any> = [];
  allprojects: Array<any> = [];
  projectId = null;
  addingSubject = [];
  tagsadded = [];
  tags = [];
  tagsinit = [];
  projectUsers = [];
  tagUserSelected = [];
  public projectCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  saveProject = null;
  currentProject = null;
  addingUsers = [];
  tag = null;
  projectlib = "";
  deadline = null;
  addsub = null;
  
  public minDate = new Date();

  constructor(
    public dialogRef: MatDialogRef<SubjectListeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private socketService: SocketService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public  dialog: MatDialog)   {
      this.ID = data.idProjet;
      this.project = '/api/projects/' + this.ID;
      this.projectTags = data.projectTags;
      this.projectUsers = data.projectUsers;
      this.projectlib = data.projectlib;
      this.projectUsersInit = data.projectUsers;
      this.general = data.general;
      this.isAdmin = data.isAdmin;
      this.isPrivate = data.isPrivate;
      this.addsub = data.addsub;
      if(this.addsub == true) this.step = 3;
      this.projectTags.sort((a, b) => {
        const aIsGeneral = a.libelle && a.libelle.toLowerCase() === 'general';
        const bIsGeneral = b.libelle && b.libelle.toLowerCase() === 'general';

        if (aIsGeneral && !bIsGeneral) {
          return -1;
        }
        if (!aIsGeneral && bIsGeneral) {
          return 1;
        }

        if (a.updatedAt > b.updatedAt) {
          return -1;
        }
        if (a.updatedAt < b.updatedAt) {
          return 1;
        }
        return 0;
      });

      this.projectTagsInit = data.projectTags;
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id'];
      for (let index = 0; index < this.projectTags.length; index++) {
          if(this.projectTags[index].libelle == 'general'){
          }

      }
    }

    onDateSelected(event: any): void {
      const selectedDate = event.value; // ✅ utiliser event.value, pas event.target.value

      if (selectedDate) {
        // Format avec moment
        this.deadline = moment(selectedDate).format('DD-MM-YYYY').toLocaleString();
      }
    }

    fctCheckUser(userInfo){ 
      if(this.addingUsers && !this.addingUsers.includes(userInfo)){
        this.addingUsers.push(userInfo);
      } else this.fctRemoveCopy(userInfo);
    }
    
    getInitials(libelle: string): string {
        const words = libelle.split(' ');
        //return "rrr";
        const getFirstChar = (word: string): string => {
          return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
        };
        const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point
        return initials;
    }

    getFormattedName(member: { givenName: string; familyName: string }): string {
      var firstInitial = "";
      if(member.familyName) firstInitial = member.familyName.charAt(0).toUpperCase();
      return `${member.givenName} .${firstInitial}`;
    }

    fctRemoveCopy(userInfo){
      const index = this.addingUsers.indexOf(userInfo);
      if (index > -1) {
        this.addingUsers.splice(index, 1);
      }
    }

    ngOnInit(): void {
      this.currentProject = this.project = '/api/projects/' + this.ID;
      this.projectCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterProject();
      });
    }

    updCheckUserTag(userId){
      const index = this.selectedUsers.indexOf(userId);
      if (index > -1) {
        this.selectedUsers.splice(index, 1); // déjà sélectionné → on retire
      } else {
        this.selectedUsers.push(userId); // pas encore sélectionné → on ajoute
      }
    }

    listTagMmebers(tag, i){
      this.subjectUpd = tag;
      this.indexUpd = i;
      this.updateSubject = tag.libelle;
      this.renameLength = this.updateSubject.length;
      this.tag = tag;
      let userStatus = []; 
      this.selectedUsers = [];
      for (let index = 0; index < tag.userTag.length; index++) {
          if(tag.userTag[index]['user'] && tag.userTag[index]['user']['id'] != this.currentUser){
            userStatus[tag.userTag[index]['user']['id']] = tag.userTag[index]['isAdmin'];
            this.selectedUsers.push(tag.userTag[index]['user']['id']);
          }

      }
      this.userStatus = userStatus;
      this.step = 6;
    }

    removeTagUser(user, index){
          for (let index = 0; index < this.tag.userTag.length; index++) {
            if(this.tag.userTag[index]['user']['id'] == user.user.id){
              var userTagId = this.tag.userTag[index]['id'];
              this.authService.deleteUserTag(userTagId).subscribe(res => {
                  this.tag.userTag.splice(index, 1);
                  delete this.userStatus[user.user.id];
                  //this.userStatus[user.user.id] = tag.userTag[index]['isAdmin']; 
              });
            }
            //userStatus[tag.userTag[index]['user']['id']] = tag.userTag[index]['isAdmin'];

        }
    }

    
  getSubject(subject){
    if(subject === "canal d'échange"){
      return "Thème d'échange";
      } else return subject;
  }
  
  getNewSubject(subject){
    if(subject === "Nouveau canal d'échange"){
      return "Nouveau Thème";
      } else return subject;
  }

    addTagUser(user, index){
      
      if(!this.tag) return false;
      this.authService.addUserTag("/api/tags/"+this.tag.id, user.id, null).subscribe(res => {
         if(res){
          var newUserTag = res;
          this.userStatus[res['user']['id']] = res['isAdmin'];
          this.tag.userTag.push(newUserTag);
         }
      },
      (error) => {
        if(error.error && error.error.violations){
          alert(error.error.violations[0].message);
        }
        else
        {
          alert(error.statusText);
        }
  
      });
    }

    protected filterProject() {
      if(this.saveProject == null){
        this.saveProject = this.allprojects;
      }
  
      let search = this.projectCtrl.value;
      if (!search) {
        this.allprojects = this.saveProject;
        return;
      } else {
        search = search.toLowerCase();
        this.allprojects = this.saveProject.filter(bank => bank.libelle.toLowerCase().indexOf(search) > -1);
      }
    }

    getAvatarlUrl(avatarLink){
      return environment.server_url+avatarLink;
    }

    getGroupData(idProject){
        this.step = 5;
        this.projectId = idProject;
        if(this.projectId != null) this.loadTags(idProject);
    }

    fctRemoveTag(lib_tag){
      const index = this.addingSubject.indexOf(lib_tag);
      if (index > -1) {
        this.addingSubject.splice(index, 1);
      }
    }
  
    addSubject(lib_tag){
      if(this.addingSubject.includes(lib_tag)){
        this.fctRemoveTag(lib_tag);
      } else this.addingSubject.push(lib_tag);
    }

    loadTags(id: string){
      this.addingSubject = [];
      this.authService.getDataDuplicated(id).subscribe(res => {
        this.tags = [];
        this.tags = this.tags.concat(res['tag']);
        this.tagsinit = this.tagsinit.concat(res['tag']);
        let userStatus = []; 
        let subjectGroup = []; 
          for (let index = 0; index < this.tags.length; index++) {
            if(this.tags[index]['libelle']){
              var tag = this.tags[index]['libelle'];
              this.addingSubject.push(tag);
              //var id = tag.substr(tag.lastIndexOf('/') + 1);
             // subjectGroup.push(tag);
            }
          }
          //this.subjectGroup = subjectGroup;
        //this.total_project = res['hydra:totalItems'];
      }); 
    }

  
    openDuppSubjectModal(action){
      //console.log('ID du project subject =>'+ this.ID);
      const urltmp = '/projects?perPage=100&page=1&order[motionAt]=desc';
      this.authService.getProjects(urltmp).subscribe((res) => {
        this.allprojects = this.projectLists.concat(res["hydra:member"]);
        this.projectsInit = this.allprojects;
      });
      this.step = 4;
    }

  onNoClick(): void {
      this.dialogRef.close();
  }

  submitTags(){
    this.addingSubject.forEach(element => {
      this.addTagToProject(element);
    });
  }


  addTagToProject(element){
    if(element == "" || element.trim().length == 0 || this.ID == null){
      alert("Canal vide");
      return;
    }
    this.authService.addTagToProject({
      libelle:element,
      project:this.currentProject
    }).then((res)=>{
      //this.getProjectInfo();
      const index = this.projectTags.findIndex(item => item.id === res["id"]);
      if (index == -1) {
        this.projectTags.push(res);
      }
      if(this.projectTags.length == this.addingSubject.length){
        this.step = 1;
      }
    }).catch(err=>{
      console.log(err)
    });
  }

  trierProject(){
    this.projectTags.sort((a, b) => {
        const aIsGeneral = a.libelle && a.libelle.toLowerCase() === 'general';
        const bIsGeneral = b.libelle && b.libelle.toLowerCase() === 'general';

        if (aIsGeneral && !bIsGeneral) {
          return -1;
        }
        if (!aIsGeneral && bIsGeneral) {
          return 1;
        }

        if (a.updatedAt > b.updatedAt) {
          return -1;
        }
        if (a.updatedAt < b.updatedAt) {
          return 1;
        }
        return 0;
      });
  }

  addProjectToArray(){
    // this.arraySubject.push({libelle:this.newProjectSubject})
    //var newProjectSubject = (<HTMLInputElement>document.getElementById("missionname")).value;
    var newProjectSubject = this.missionname.nativeElement.value;
    if(newProjectSubject.trim() == "" || newProjectSubject.trim().length == 0){
      alert("Veuillez entrer un canal");
      return;
    }
    if(newProjectSubject.trim() == "general"){
      alert("Ce nom du canal est reservé à l'espace général dans tout projet");
      return;
    }
    if(this.addingUsers.length == 0 && !this.isPrivate){
      alert("Veuillez sélectionner au moins un membre avant de créer le canal.");
      return;
    }
    this.tagUserSelected = [];
    var tagUser = [];
    tagUser.push({"user":"/api/users/"+this.currentUser});
    for (var i = 0; i < this.addingUsers.length; i++) {
      tagUser.push({"user":"/api/users/"+this.addingUsers[i].id});
    }
    this.addingUsers.map(item=> {
        //tagUser.push(item.id);
        this.tagUserSelected.push(item);
    })
    this.authService.addTagToProject({
      libelle:newProjectSubject,
      project:this.project,
      isGeneral: false
    }, tagUser, this.deadline).then((res)=>{
      this.missionname.nativeElement.value = "";
      //this.projectTags.push(res);
      const index = this.projectTags.findIndex(item => item.id === res["id"]);
      if (index == -1) {
        this.projectTags.push(res);
        //this.authService.subjectListAdd.emit(res);
        this.addingUsers = [];
        this.trierProject();
        this.selectSubject(res);
        //this.backToList();
        this.socketService.sendInstant({
          id: "",
          action: this.ID,
          type: "ADDSUBJECT",
          author: this.currentUser,
          recipient: this.ongletId,
          text: "",
          copy: "",
          private: false,
          res: res,
          date: ""
        });
      }
      //this.getProjectInfo();
    }).catch(err=>{
      console.log(err)
    });
  }

  backToList(){
    this.updclicked = false;
    this.updateSubject = "";
    this.subjectUpd = null;
    this.indexUpd = 0;
    this.step = 1;
  }

  confirmUpdate(){
    //this.updateSubject = (<HTMLInputElement>document.getElementById("updateSubject")).value;
    if (this.updateSubject.trim().length == 0) {
      alert("Veuillez entrer un canal");
      return;
    }
    const data = {
      libelle: this.updateSubject,
      users: this.selectedUsers,
      externalEmails: []
    };
    this.authService.updateTagDetails(this.subjectUpd.id, data).then((res)=>{
      //this.projectTags[this.indexUpd].libelle = this.updateSubject;
      this.projectTags[this.indexUpd] = res;
      this.authService.subjectListUpd.emit(res);
      //this.cancelUpdSubject();
      this.socketService.sendInstant({
        id: "",
        action: this.ID,
        type: "RENAMESUBJECT",
        author: this.currentUser,
        recipient: "",
        text: "",
        copy: "",
        private: false,
        res: res,
        date: ""
      });
      this.backToList();
      //this.dialogRef.close();
    }).catch(err=>console.log(err))
    return;
    this.authService.updateTag(this.subjectUpd.id,{libelle:this.updateSubject}).then((res)=>{
      this.projectTags[this.indexUpd].libelle = this.updateSubject;
      //this.authService.subjectListUpd.emit(this.projectTags);
      //this.cancelUpdSubject();
      this.socketService.sendInstant({
        id: "",
        action: this.ID,
        type: "RENAMESUBJECT",
        author: this.currentUser,
        recipient: "",
        text: "",
        copy: "",
        private: false,
        res: res,
        date: ""
      });
      this.backToList();
      //this.dialogRef.close();
    }).catch(err=>console.log(err))
  }

  filterTags(val : any){
    this.filter = val;
    if(val == "date"){
          this.trierProject();
    } else {
      this.projectTags.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
    //this.projectLists.filter(item => (this.projectMapFace[item.id] > 0));
  }

  goBack(){
    if(this.step == 5){
      this.step = 4;
    } else if(this.step == 0){
      this.step = 1;
    } else if(this.step == 4){
      this.step = 0;
    } else if(this.step == 6){
      this.step = 1;
      this.tag = null;
    } else this.step = 1;
  }

  filterProjects(val : any){
    this.filterproj = val;
    if(val == "date"){
        this.allprojects.sort((a, b) => {
          if ( a.dateCreated > b.dateCreated ){
            return -1;
          }
          if ( a.dateCreated < b.dateCreated ){
            return 1;
          }
          return 0;
        })
    } else {
      this.allprojects.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
    //this.projectLists.filter(item => (this.projectMapFace[item.id] > 0));
  }
      

  deleteTag(sub){
      const dialogRef = this.dialog.open(ConfirmdialogComponent, {
        data: { 
          message: 'Voulez vraiment suppprimer le canal '+sub.libelle,
          title: 'Confirmation'
        },
        panelClass: 'confirmclass',
        backdropClass: 'custom-backdrop'
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.authService.deleteTag(sub.id).then((res)=>{
            const index = this.projectTags.findIndex(item => item.id === sub.id);
                if (index !== -1) {
                  const elementAaa = this.projectTags.splice(index, 1)[0];
                  this.authService.subjectListDel.emit(sub.id);
                }
          }).catch(err=>console.log(err))
        } else {
        }
      });
  }

  showUpdateTag(sub, i){
    this.subjectUpd = sub;
    this.indexUpd = i;
    this.updateSubject = sub.libelle;
    this.renameLength = this.updateSubject.length;
    this.step = 2;
  }

  onSearchTag() {
    if (this.searchTag.trim() === '' || this.searchTag == null) {
      this.searchTag = null;
      this.tags = this.tagsinit;
      //this.filterProjects(this.filter);
    } else {
      var searchText = this.searchTag.trim().toLowerCase();
      this.tags = this.tagsinit.filter(it => 
        it.libelle.toLowerCase().includes(searchText)
      );
      //return this.projectTags.filter(it => it['libelle'].toLowerCase().includes(searchText));
    }
  }

  

  onSearchProject() {
    if (this.searchProj.trim() === '' || this.searchProj == null) {
      this.searchProj = null;
      this.projectsInit = this.projectsInit;
      this.filterProjects(this.filterproj);
    } else {
      var searchText = this.searchProj.trim().toLowerCase();
      this.allprojects = this.projectsInit.filter(it => 
        it.libelle.toLowerCase().includes(searchText)
      );
      //return this.projectTags.filter(it => it['libelle'].toLowerCase().includes(searchText));
    }
  }

  onSearch() {
    if (this.searchProject.trim() === '' || this.searchProject == null) {
      this.searchProject = null;
      this.projectTags = this.projectTagsInit;
      this.filterProjects(this.filter);
    } else {
      var searchText = this.searchProject.trim().toLowerCase();
      this.projectTags = this.projectTagsInit.filter(it => 
        it.libelle.toLowerCase().includes(searchText)
      );
      //return this.projectTags.filter(it => it['libelle'].toLowerCase().includes(searchText));
    }
  }

  onSearchUser() {
    if (this.searchUser.trim() === '' || this.searchUser == null) {
      this.searchUser = null;
      this.projectUsers = this.projectUsersInit;
    } else {
      var searchText = this.searchUser.trim().toLowerCase();
      this.projectUsers = this.projectUsersInit.filter(it => 
        it.user.fullName.toLowerCase().includes(searchText)
      );
      //return this.projectTags.filter(it => it['libelle'].toLowerCase().includes(searchText));
    }
  }

  selectAllUsers(){
    this.addingUsers = [];
    this.projectUsersInit.forEach((item) => this.addingUsers.push(item.user));
  }

  deselectAllUsers(){
    this.addingUsers = [];
  }

  calculateDate(date) {
    var result = 0;
    var today = new Date().setHours(0, 0, 0, 0);
    var yesterday = new Date(new Date().setDate(new Date().getDate()-1)).setHours(0, 0, 0, 0);
    date = new Date(date);
    if (date >= today) {
      result = 1;
    } else if (date >= yesterday) {
      result = 2;
    } else result = 3;
    return result;
  }

  selectSubject(subject){
    this.dialogRef.close(subject);
  }

  clickaddmission(){
    if(this.projectTags.length > 0 && this.step != 0){
      this.step = 3;
    } else this.step = 0;
  }

  duppTheme(){
    this.openDuppSubjectModal(2);
  }

  addTheme(){
    this.step = 3; 
  }

  updDialog(): void{
    this.updclicked = !this.updclicked;
  }
}

@Component({
  selector: 'memberListe-dialog',
  templateUrl: './memberListe-dialog.html',
  styleUrls: ['./memberListe-dialog.scss']
})
export class DialogMemberListe {
  
  userID = JSON.parse(localStorage.getItem('currentUser'))['id'];
  userAdmin = false;
  projectUsers = [];
  secteur ="";
  currentUserInfo: any;

  fname = '';
  lname = '';
  dob = '';
  jobT = '';
  email = '';
  gender = 'male';
  description = '';
  phone = '';
  img: any;
  contactInfo: any;
  
  currentUser : any;
  ID: any;
  dateCreated = null;
  libelle: '';
  mode = 1;
  userStatus = null;
  contacts = [];
  selectedUsers: any[] = [];
  selectedUsersObject: any[] = [];
  project_lib: string;
  addingMember = false;
  searchContact: any;
  addcontactshow = 0;
  selectedRole: string = 'collaborator';
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  showNewContactInput = false;
  @ViewChild('emailInput', {static: true}) emailInput: ElementRef;
  @ViewChild('emailInput0', {static: true}) emailInput0: ElementRef;
  username : any;
  isPrivate = false;

  constructor(
    public dialogRef: MatDialogRef<DialogMemberListe>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private messageService: MessageService,
    private socketService: SocketService,
    private router: Router,
    public dialog: MatDialog) {
      
      this.secteur = localStorage.getItem('secteur');
      var currentUserData = JSON.parse(localStorage.getItem('currentUser'));
      this.currentUserInfo = currentUserData.givenName + currentUserData.familyName;
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id']; 
      this.username = JSON.parse(localStorage.getItem('currentUser'))['givenName'] +" "+ JSON.parse(localStorage.getItem('currentUser'))['familyName']; 
      this.ID = data.idProjet;
      this.dateCreated = data.dateCreated;
      this.authService.getOneProject(data.idProjet)
      .subscribe(res => {
        var tmpArrayUser = res['userProject'];
        this.projectUsers = [];
        this.isPrivate = res['isPrivate'];
        this.libelle = res['libelle'];
        var users = tmpArrayUser.filter(a => a.user != null);
        users.sort((a, b) => {
          if (a.user.fullName.toLowerCase() < b.user.fullName.toLowerCase()){
            return -1;
          }
          if (a.user.fullName.toLowerCase() > b.user.fullName.toLowerCase() ){
            return 1;
          }
          return 0;
        });
        this.projectUsers = users.sort((a, b) => {
          // Admins en premier
          if (a.isCreator) return -1;
          if (b.isCreator) return 1;
        
          // Co-admins ensuite
          if (a.isAdmin && !a.isCreator) return -1;
          if (b.isAdmin && !b.isCreator) return 1;
        
          // Les autres membres à la fin
          return 0;
        });
        var invited = tmpArrayUser.filter(a => a.user == null);
        invited.sort((a, b) => {
          if (a.email < b.email){
            return -1;
          }
          if (a.email > b.email ){
            return 1;
          }
          return 0;
        });
        for (var i = 0; i < invited.length; i++) {
              this.projectUsers.push(invited[i]);
        }
        for (var i = 0; i < this.projectUsers.length; i++) {
          if((this.projectUsers[i].isAdmin == true) && (this.projectUsers[i].user.id == this.userID))
          {
            this.userAdmin = true;
          }
        }
         
      });


  }

  goBack(){
    this.mode = 1;
    this.addcontactshow = 0;
  }

  clearSearch() {
    this.searchContact = ''; // Vide le champ de recherche
  }

  getbackGroundColor(){
    if (this.data.projectAction) {
      return "#645994"
    }
    else if (this.data.projectMeetting){
      return "#5d97eb"
    }
    else
    {
      return "#57b031"
    }
  }

  loadContact(url?: string){
    url = url ? url : undefined;
    this.authService.getContacts(url).subscribe(res => {
      this.contacts = this.contacts.concat(res['hydra:member']);
    }); 
  }

  updCheckUserSelected(contact){
      const index = this.selectedUsers.indexOf(contact.id);
      if (index > -1) {
        this.selectedUsers.splice(index, 1); // déjà sélectionné → on retire
        this.selectedUsersObject.splice(index,1);
      } else {
        this.selectedUsers.push(contact.id); // pas encore sélectionné → on ajoute
        this.selectedUsersObject.push(contact)
      }
  }

  

  fctAdMember(userInfo){
    return this.authService.addUserProject("/api/projects/"+this.ID, userInfo.id, null).pipe(
      tap((res) => {
        if (res) {
          var newUser = res;
          this.userStatus[res['user']['id']] = res['status'];
          this.projectUsers.push(newUser);
          this.searchContact = "";
          this.socketService.sendInstant({
            id: "0",
            action: "0",
            type: "INVITATION",
            author: this.currentUser,
            recipient: this.username,
            text: res['user']['id'],
            copy: "",
            private: false,
            res: res,
            project_lib: this.project_lib,
            date: res['dateCreated']
          });
        }
      }),
      catchError((error) => {
        if (error.error && error.error.violations) {
          alert(error.error.violations[0].message);
        } else {
          alert(error.statusText);
        }
        // retourne un observable vide pour que forkJoin continue
        return of(null);
      })
    );
  }


  confirmAddmembers() {
    const requests = this.selectedUsersObject.map(user => this.fctAdMember(user));

    forkJoin(requests).subscribe({
      next: (results) => {
        const validResults = results.filter(r => r)
        alert("Vos membres sont ajoutés. Vous devez maintenant les affecter à un canal.");
        this.dialogRef.close(validResults);
      },
      error: (err) => console.error('Erreur lors de l’ajout des utilisateurs', err)
    });
  }

  fctAddMember() {
    this.authService.idProjectMember.emit(this.ID);
    this.loadContact();

    this.authService.getOneProject(this.ID)
      .subscribe(res => {
        this.project_lib = res['libelle'];
        var tmpArrayUser = res['userProject'];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].user){
            this.projectUsers.push(tmpArrayUser[i]);
          }
        }

        let userStatus = []; 
        for (let index = 0; index < this.projectUsers.length; index++) {
          if(this.projectUsers[index]['user'])
          userStatus[this.projectUsers[index]['user']['id']] = this.projectUsers[index]['status'];

        }
        this.userStatus = userStatus;
        this.data = "/api/projects/"+this.data;
      }, (error) => {
      });
    this.mode = 2;
    //alert("mode "+this.mode)
  }

  newContact(){
    if (this.showNewContactInput == true)  
      this.showNewContactInput = false;
    else
      this.showNewContactInput = true;
  }

  showEmailInvited(){
    this.addcontactshow = 1;
    this.emailFormControl.setValue('');
    
  }


   fctAddcontactByMail(){

      // Process checkout data here
      //console.log('Your order has been submitted', customerData);
       // stop here if form is invalid
      if (this.emailFormControl.status == 'INVALID') {
        return;
      }

      var result = this.emailFormControl.value;

      this.authService.addUserProjectWithRole("/api/projects/"+this.ID, result, this.selectedRole, true).subscribe(res => {
         //console.log('retour ajout membre mail => '+JSON.stringify(res));
        this.searchContact = "";
        alert('Invitation envoyé'); 
        this.addcontactshow = 0;
        
        if(res['user'] && res['user']['id']){
          var newUser = res;
          this.userStatus[res['user']['id']] = res['status'];
          this.projectUsers.push(newUser);
          this.messageService.needRefreshFiltre();
          var usersinvited = [];
          usersinvited.push(res['user']['id']);
          this.emailFormControl.setValue('');
          this.emailFormControl.reset();
          this.emailInput0.nativeElement.value = "";
          this.socketService.sendInstant({
            id: "0",
            action: "0",
            type: "INVITATIONPROJ",
            author: this.userID,
            recipient: "",
            text: "",
            copy: usersinvited,
            private: false,
            res: "",
            project_lib: this.libelle,
            date: result.dateCreated
          });
         }

         //this.emailFormControl.value = null;
      },
      (error) => {
        if (error.status === 402) {
          const errorDescription = JSON.parse(error.error['hydra:description']);
          this.openPackComponentDialog(2, errorDescription.subscriptionPack);
        } else if (error.status === 429) {
          this.openPackComponentDialog(3);
        } else if(error.error && error.error.violations){
          alert(error.error.violations[0].message);
        } else if(error.error && error.error['hydra:description']){
          alert(error.error['hydra:description']);
        } else
        {
          alert(error.statusText);
        }

      });

   }

   openPackComponentDialog(type = 0, currentPack = 'free'){
    const dialogRef = this.dialog.open(PackComponent, {
      panelClass: 'packclass',
      backdropClass: 'custom-backdrop-pack',
      height: "height: calc(-80px + 100vh);",
      data: { type: type, pack: currentPack}
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onSubmitForm(customerData) {

     // stop here if form is invalid
    if (this.emailFormControl.status == 'INVALID') {
      return;
    }

    this.authService.addUserProject("/api/projects/"+this.ID, customerData, true).subscribe(res => {
       //console.log('retour ajout membre mail => '+JSON.stringify(res));
      this.searchContact = "";
      alert('Invitation envoyé'); 
      
      if(res['user'] && res['user']['id']){
        var newUser = res;
        this.userStatus[res['user']['id']] = res['status'];
        this.projectUsers.push(newUser);
        this.messageService.needRefreshFiltre();
       }
    },
    (error) => {
     
      if(error.error && error.error.violations){
        alert(error.error.violations[0].message);
      }
      else
      {
        alert(error.statusText);
      }

    });

  }

  relaunchInvitation(userproject, id){
    //alert("value : "+userproject);
    this.authService.relaunchInvitation(userproject)
    .subscribe(res => {
      if(res) alert("invitation renvoyée avec succès");
      this.socketService.sendInstant({
          id: "0",
          action: "0",
          type: "INVITATION",
          author: this.currentUser,
          recipient: this.username,
          text: id,
          copy: "",
          private: false,
          res: res,
          project_lib: this.libelle,
          date: res['dateCreated']
        });
    });
  }

  updateListUser(contact,values){
    this.authService.updateUserProject(contact, values)
    .subscribe(res => {
      for (var i = 0; i < this.projectUsers.length; i++) {
        if(res['id'] ===  this.projectUsers[i]['id'])
          this.projectUsers[i] = res;
      }
    });
  }


  updateUserProject(contact, key){
    let values = null;
    switch (key) {
      case 1:
        values = {isAdmin: false};
        this.updateListUser(contact, values);
        this.socketService.sendInstant({
          id: "",
          action: this.ID,
          type: "DELETEADMIN",
          author: this.userID,
          recipient: this.currentUserInfo,
          text: "",
          copy: "",
          private: false,
          res: contact.user.id,
          date: ""
        });
        break;
      case 2:
        values = {isMember: false};
        this.updateListUser(contact, values);
        break;
      case 3:
        values = {isAdmin: true};
        this.updateListUser(contact, values);
        this.socketService.sendInstant({
          id: "",
          action: this.ID,
          type: "MARKADMIN",
          author: this.userID,
          recipient: this.currentUserInfo,
          text: "",
          copy: "",
          private: false,
          res: contact.user.id,
          date: ""
        });
        break;
      case 5:
        values = {isMember: true};
        this.updateListUser(contact, values);
        break;
      case 4:
        const fullname = contact.user ? contact.user.fullName : contact.email;
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: '350px',
          data: "Vous êtes sur le point de retirer "+fullname+" du projet ?"
        });
        dialogRef.afterClosed().subscribe(result => {
          if(result) {
            this.authService.deleteUserProject(contact)
            .subscribe(res => {
              for (var i = 0; i < this.projectUsers.length; i++) {
                if(contact['id'] ===  this.projectUsers[i]['id'])
                  this.projectUsers.splice(i, 1); 
              }
            });
          }
        });
        break;
      default:
        break;
    }
  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  closePopup(): void {
      this.dialogRef.close();
  }

  onNoClick(): void {
    if(this.mode == 1) this.dialogRef.close();
    else this.goBack();
  }

  showProfil2(idUser){
    this.getCurrentUser(idUser);
    this.mode = 3;
  }

  getCurrentUser(idUser){
    // console.log('getCurrentUser paramètre id ==> '+this.idUser);
     this.authService.getInfoContact(idUser)
     .subscribe( dataContact => {
       this.contactInfo = dataContact;
       this.img = (this.contactInfo.imageUrl ? this.getAvatarlUrl(this.contactInfo.imageUrl) : '../../../../assets/img/default-avatar.png');
       this.fname =  this.contactInfo.givenName;
       this.lname =  this.contactInfo.familyName;
       if(this.contactInfo.birthDate) {
         if (this.contactInfo.birthDate.date) 
         {
           this.dob = this.contactInfo.birthDate.date;
         }
         else
         {
           this.dob = this.contactInfo.birthDate;
         }
       }
       //this.dob =  this.contactInfo.birthDate;
       this.jobT =  this.contactInfo.jobTitle;
       this.email =  this.contactInfo.email;
       this.gender =  this.contactInfo.gender;
       this.description =  this.contactInfo.description;
       this.phone =  this.contactInfo.telephone;
 
     }, (error) => {
         alert('une erreur est survenue');
     });
 
   }

  showProfil(idUser): void{
    this.dialog.closeAll();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'contactpanel';
    dialogConfig.id = 'balchal718';
    dialogConfig.width = '550px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = { idUser: idUser};
    //const dialogRef = this.dialog.open(ProfileComponent, dialogConfig);
    const dialogRef = this.dialog.open(ProfileComponent, {
      //width: '350px',
      data: { idUser: idUser},
      panelClass: 'transferclass',
      backdropClass: 'custom-backdrop'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
    });
    //this.router.navigate(['/profile/'+idUser]);
    this.dialogRef.close();
    
  }


}
 

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'addMember-dialog',
  templateUrl: './profileupd-dialog.html',
  styleUrls: ['./profileupd-dialog.scss']
})
export class ProfileupdDialog implements OnInit{

  currentUser : any;
  firstFormGroupOne: FormGroup;
  img: any;
  imageFil = null;
  imggroupe = null;

  constructor(
    public dialogRef: MatDialogRef<ProfileupdDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private messageService: MessageService,
    private socketService: SocketService,
    private cd: ChangeDetectorRef,
    private router: Router,
    public dialog: MatDialog) {
      this.imggroupe = this.data.img;
      var currentUserData = JSON.parse(localStorage.getItem('currentUser'));
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id']; 

  }

  

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  ngOnInit(): void {
    this.firstFormGroupOne = new FormGroup({
      projetNameOne: new FormControl('')
   });
   this.firstFormGroupOne.get('projetNameOne').patchValue(this.data.libelle);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getbackGroundColor(){
    return "#57b031";
  }

  fileChangeEvent(event: any): void {
    const dialogRef = this.dialog.open(croppedimagedialog, {
      width: '700px',
      data: {event: event}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result !== null) {
        this.img = result.event;
        const reader = new FileReader();
        this.imageFil = result.fileToReturn;
        reader.readAsDataURL(this.imageFil);
          
        reader.onload = () => {
          this.cd.markForCheck();
        }; 
      }
    });
  }

  onProfilePicClick(): void {
    const fileInput = document.getElementById('fileInput') as HTMLElement;
    fileInput.click();
  }

  submit(customerData){
    this.authService.changeProjetName(customerData.projetNameOne, this.data.idProjet).subscribe(
      res => {
        if(this.imageFil) {
          this.authService.updateProject2(this.data.idProjet, this.imageFil).subscribe( data => {
             //console.log('retour saveProfile '+JSON.stringify(data));
             data['imagechanged'] = true;
            alert("Projet modifié avec succès");
            this.dialogRef.close(data);
              
          }, (error) => {
              //console.log('Uh-oh, an error occurred! : ' +JSON.stringify(error));
              alert('une erreur est survenue');
          });
        } else {
          res['imagechanged'] = false;
          alert("Projet modifié avec succès");
          this.dialogRef.close(res);
        }
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );
  }
}

@Component({
  selector: 'addMember-dialog',
  templateUrl: './addMember-dialog.html',
  styleUrls: ['./addMember-dialog.scss']
})
export class DialogAddMember implements AfterViewInit  {
 
  contacts = [];
  secteur = "";
  userStatus = null;
  showNewContactInput = false;
  searchContact: any;
  currentUser : any;
  username : any;
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  matcher = new MyErrorStateMatcher();
  addingMember = false;
  @ViewChild('emailInput', {static: true}) emailInput: ElementRef;
  @Input() data: string;
  projectUsers = [];
  project_lib: string;

  constructor(
     private authService: AuthService,
     private messageService: MessageService,
     private socketService: SocketService) {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id']; 
      this.username = JSON.parse(localStorage.getItem('currentUser'))['givenName'] +" "+ JSON.parse(localStorage.getItem('currentUser'))['familyName']; 
      
      this.contacts = [];
      this.secteur = localStorage.getItem('secteur');
      
  }

  ngAfterViewInit() {
    this.authService.idProjectMember.subscribe((res) => {
    this.loadContact();

      this.authService.getOneProject(this.data)
      .subscribe(res => {
        //console.log(res)
        this.project_lib = res['libelle'];
        var tmpArrayUser = res['userProject'];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].user){
            this.projectUsers.push(tmpArrayUser[i]);
          }
        }

        let userStatus = []; 
        for (let index = 0; index < this.projectUsers.length; index++) {
          if(this.projectUsers[index]['user'])
          userStatus[this.projectUsers[index]['user']['id']] = this.projectUsers[index]['status'];

        }
        this.userStatus = userStatus;
        this.data = "/api/projects/"+this.data;
      }, (error) => {
      });
    });
  }

  getbackGroundColor(){
    return "#57b031";
  }

  loadContact(url?: string){
    url = url ? url : undefined;
    this.authService.getContacts(url).subscribe(res => {
      this.contacts = this.contacts.concat(res['hydra:member']);
    }); 
  }


  newContact(){
    if (this.showNewContactInput == true)  
      this.showNewContactInput = false;
    else
      this.showNewContactInput = true;
  }


   fctAddcontactByMail(){

      // Process checkout data here
      //console.log('Your order has been submitted', customerData);
       // stop here if form is invalid
      if (this.emailFormControl.status == 'INVALID') {
        return;
      }

      var result = this.emailFormControl.value;

      this.authService.addUserProject(this.data, result, true).subscribe(res => {
         //console.log('retour ajout membre mail => '+JSON.stringify(res));
        this.searchContact = "";
        alert('Invitation envoyé'); 
        
        if(res['user'] && res['user']['id']){
          var newUser = res;
          this.userStatus[res['user']['id']] = res['status'];
          this.projectUsers.push(newUser);
          this.messageService.needRefreshFiltre();
         }

         //this.emailFormControl.value = null;
         this.emailInput.nativeElement.value = "";
      },
      (error) => {
       
        if(error.error && error.error.violations){
          alert(error.error.violations[0].message);
        } else if(error.error && error.error['hydra:description']){
          alert(error.error['hydra:description']);
        } else
        {
          alert(error.statusText);
        }

      });

   }

  onSubmitForm(customerData) {
     // Process checkout data here
    //console.log('Your order has been submitted', customerData);

     // stop here if form is invalid
    if (this.emailFormControl.status == 'INVALID') {
      return;
    }

    this.authService.addUserProject(this.data, customerData, true).subscribe(res => {
       //console.log('retour ajout membre mail => '+JSON.stringify(res));
      this.searchContact = "";
      alert('Invitation envoyé'); 
      
      if(res['user'] && res['user']['id']){
        var newUser = res;
        this.userStatus[res['user']['id']] = res['status'];
        this.projectUsers.push(newUser);
        this.messageService.needRefreshFiltre();
       }
    },
    (error) => {
     
      if(error.error && error.error.violations){
        alert(error.error.violations[0].message);
      }
      else
      {
        alert(error.statusText);
      }

    });

  }

  fctAdMember(userInfo){
    if(this.addingMember) return false;
    this.addingMember = true;
    this.authService.addUserProject(this.data, userInfo.id, null).subscribe(res => {
       if(res){
        var newUser = res;
        this.userStatus[res['user']['id']] = res['status'];
        this.projectUsers.push(newUser);
        this.searchContact = "";
        this.socketService.sendInstant({
          id: "0",
          action: "0",
          type: "INVITATION",
          author: this.currentUser,
          recipient: this.username,
          text: res['user']['id'],
          copy: "",
          private: false,
          res: res,
          project_lib: this.project_lib,
          date: res['dateCreated']
        });
       }
       this.addingMember = false;
    },
    (error) => {
      this.addingMember = false;
      if(error.error && error.error.violations){
        alert(error.error.violations[0].message);
      }
      else
      {
        alert(error.statusText);
      }

    });

  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  onNoClick(): void {
    //this.dialogRef.close();
  }

}


////////////////// dialog project info ////////////////////


@Component({
  selector: 'projectInfo-dialog',
  templateUrl: './projectInfo-dialog.html',
  styleUrls: ['./projectInfo-dialog.scss']
})
export class projectInfoDialog {
  
  imageFil = null;
  img = null;
  currentUser: any;
  secteur = "";
  isAdmin = false; 
  noChangeImage = true;
  modeChangeName = false;
  firstFormGroup: FormGroup;
  modeSupp = false;
  userData : any;
  nameproject = "";
  constructor(
    public dialogRef: MatDialogRef<projectInfoDialog>,
    @Inject(MAT_DIALOG_DATA) public projectData: any,
    private authService: AuthService,
    private messageService: MessageService,
    private cd: ChangeDetectorRef,
    private _formBuilder: FormBuilder) {
      this.isAdmin = true;
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id']; 
      this.secteur = localStorage.getItem('secteur');
      this.nameproject = this.projectData.name;

      this.firstFormGroup = this._formBuilder.group({
        projetName: ['', Validators.required]
      });

  }

  ChoseImage(event): void{  

    const reader = new FileReader();
    var files = event.files;

    // loop through files
    for (var i = 0; i < files.length; i++) {
      this.imageFil = files[i];
    }

    reader.readAsDataURL(this.imageFil);
      
    reader.onload = () => {
      // need to run CD since file load runs outside of zone
      this.cd.markForCheck();
      this.img = reader.result;
    }; 

  }
  
  onClickChangeName(): void{
    this.modeChangeName = true;
  }


  onClickAnnuler(): void{
    this.modeChangeName = false;
  }


  onClickValidate(): void{
    if(this.imageFil != null){
     this.authService.projectImage(this.projectData.id, this.imageFil)
     .subscribe(  
      (success) => {
        //console.log('retour image success => '+JSON.stringify(success));
        alert('Modification enregistré');
      },
      (error) => {
        alert('Erreur ! : ' + error)
      });
    }
    else
    {
      alert('Veuillez choisir une image pour le projet')
    }
  }


  onSubmitProjectName(customerData){
  
    //console.log('firstFormGroup ==>' , customerData);

    if (this.firstFormGroup.get('projetName').value.trim().length == 0 ){
      this.firstFormGroup.patchValue({
        projetName: '' 
      });
    }

     // stop here if form is invalid
    if (this.firstFormGroup.invalid) {
      return;
    }

     // Creation du projet
    this.authService.changeProjetName(customerData.projetName, this.projectData.id).subscribe(
      res => {
        //console.log('retour firstFormGroup ==>'+ res);
        //this.stepper.selectedIndex = 1;
        this.projectData = res;
        this.dialogRef.close(res);
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );

     this.modeChangeName = true;

  }

  onClickdelete(): void {
    this.modeSupp = true;
  }

  onClickCancelSupp(): void{
    this.modeSupp = false;
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }

  onClickConfirmeDelete(): void{
    this.authService.deleteProject(this.projectData.id).subscribe(
      res => {   
        //this.messageService.messageUpdated();
        this.authService.obRefreshProjet.next();
        this.dialogRef.close({deleteReturn: true});
        //this.stepper.selectedIndex = 1;
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );
  }

}

////////////////// dialog transfert ///////////////////

@Component({
  selector: 'dialogTransfert',
  templateUrl: 'transfertdialog.html',
  styleUrls: ['./transfertdialog.scss']
})
export class transfertdialog {

  submitted = false;
  sendMessageForm: FormGroup;
  recipient = null;
  contacts = [];
  recipientValue: string = '';
  currentUser = null;
  filteredContacts: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<transfertdialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
     private authService: AuthService) {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.getAllContacts();
      this.sendMessageForm = this.formBuilder.group({
        Destinataire: ['', Validators.required],
        EnCopie: '',
        message:  ''
     });
  }

  selectRecipient(){
    if(this.recipient != "" && this.recipient != null && this.recipient != undefined){
      this.sendMessageForm.get('Destinataire').setValue(this.recipient.email); 
    }
  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }
  
  searchContact() {
    const filter = this.recipientValue.toLowerCase();
    this.filteredContacts = this.contacts.filter(contact =>
      contact.fullName.toLowerCase().includes(filter)
    );
  }

  onSubmitForm(customerData) {

     // Process checkout data here
    // console.log(JSON.stringify(this.files));
    
    //console.log('Your order has been submitted', customerData);

    this.submitted = true;
     // stop here if form is invalid
    if (this.sendMessageForm.invalid) {
      return;
    }
    
    this.sendTransfert(customerData);

    this.submitted = false;
    //this.sendMessageForm.reset();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getbackGroundColor(){
    if (this.data.projectAction) {
      return "#6e73b2"
    }
    else if (this.data.projectMeetting){
      return "#5d97eb"
    }
    else
    {
      return "#57b031"
    }
  }

  getErrorMessage() {
    return this.sendMessageForm.controls.Destinataire.hasError('required') ? 'Veuillez entrer une adresse email' :
        this.sendMessageForm.controls.Destinataire.hasError('email') ? 'Email non valide' : '';
  }

  sendTransfert(customerData){
    this.authService.transfertByMail(customerData, this.data.message).subscribe(  
    (success) => {
      alert('Message transferé');
      this.dialogRef.close();
    },
    (error) => {
      alert('Erreur ! : Veuillez vérifier le mail')
    });
  }
  
  getAllContacts(){
    this.authService.getMyContacts(this.currentUser['compId']).subscribe(res => {
        this.contacts = this.contacts.concat(res['hydra:member']);
        this.contacts = this.contacts.sort(function (a, b) {
          if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) { return -1; }
          if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) { return 1; }
          return 0;
        })
        this.filteredContacts = this.contacts;
      })
  }


}

////////////////// dialog change subject ///////////////////



@Component({
  selector: 'subjectInfo-dialog',
  templateUrl: './subjectInfo-dialog.html',
  styleUrls: ['./subjectInfo-dialog.scss']
})
export class subjectInfodialog {
  
 
  currentUser: any;
  projectTag = [];
  isAdmin = false; 
  renameSubject = '';
  newSubject = '';
  editeSubjectMode = false;
  addSubjectMode = false;
  tagInfo: any;

  constructor(
    public dialogRef: MatDialogRef<subjectInfodialog>,
    @Inject(MAT_DIALOG_DATA) public dataGet: any,
    private authService: AuthService,
    private messageService: MessageService,
    private cd: ChangeDetectorRef,
    private _formBuilder: FormBuilder) {
     
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id']; 
      if(this.dataGet.projectData.creator.id == this.currentUser) {
        this.isAdmin = true;
      }

      this.projectTag = this.dataGet.projectData['tags'];

  }

  fctChangeSubject(element){
    this.renameSubject = '';
    this.tagInfo = element;
    this.editeSubjectMode = true;
  }

  doTextareaValueChange(ev) {
    this.renameSubject = ev.target.value;
  }

  validerModif(tag){

    if (this.renameSubject.trim() != '') {
      this.authService.changeSubjectName(this.renameSubject, tag.id)
        .subscribe(res => {
          tag.libelle = this.renameSubject;
          if (tag.id == this.dataGet.sendMessageForm.controls.subProject.value.libelle ) {
            this.dataGet.sendMessageForm.patchValue({
              subProject: tag
            });
          }
          this.tagInfo = null;
          this.editeSubjectMode = false;
          this.renameSubject = '';
          //this.envoyerObs.next();
          this.messageService.messageRefreshConv();
          //this.messageService.messageUpdated();
          this.messageService.needRefreshFiltre();

        }, (error) => {
      }); 
    }
    else
    {
      this.tagInfo = null;
      this.editeSubjectMode = false;
      this.renameSubject = '';
    }

  }
  
  fctChoseTag(tag): void {
    this.dialogRef.close(tag);
  }

  fctaddSubjectMode(): void {
    this.addSubjectMode = true;  
  }

  addSubjectCancel(): void {
    this.addSubjectMode = false; 
  }

  addSubject(): void {

    this.authService.addNewSubject(this.newSubject, this.dataGet.projectData.id)
      .subscribe(res => {
        //console.log('res tagg => '+JSON.stringify(res));
        this.projectTag.push(res);
        this.messageService.messageRefreshConv();
        //this.messageService.messageUpdated();
        this.messageService.needRefreshFiltre();
        this.newSubject = '';
        this.addSubjectMode = false; 
      }, (error) => {
       alert('Erreur');
    }); 
  }

  onSelectNewSubProject(newSubProjetName){
    //console.log('newSubProjetName => '+newSubProjetName);
    this.newSubject = newSubProjetName;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

////////////////// dialog info write message ///////////////////


@Component({
  selector: 'infoWriteMessageDialog',
  templateUrl: 'infoWriteMessageDialog.html',
   styleUrls: ['infoWriteMessageDialog.scss']
})
export class infoWriteMessageDialog implements OnInit{
  lang='fr';

  constructor(
    public dialogRef: MatDialogRef<infoWriteMessageDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private messageService: MessageService,
    private _formBuilder: FormBuilder) {
     
  }

  ngOnInit() {
    this.messageService.getTranslate().subscribe((data) => {
      this.lang= data;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

////////////////// dialog info conv ///////////////////

@Component({
  templateUrl: './deadLineConvDialog.html',
  styleUrls: ['./deadLineConvDialog.scss'],
  providers: [DatePipe]
})
export class DeadLineConvDialog {
  
  deadline: Date | null;
  deadlineRelanceOne: Date | null;
  deadlineReLanceTwo: Date | null;
  deadlineReLanceTree: Date | null;
  public minDate = new Date();

  constructor(
    public dialogRef: MatDialogRef<DeadLineConvDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private router: Router,
    public dialog: MatDialog,
    private datePipe: DatePipe) {


  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  
  validate(): void {

    if (!this.deadline) {
      alert('veuillez choisir un délai de réponse');
      return;
    }

    var deadLineJson : any = {
      'deadline': this.deadline,
      'Relance1': this.deadlineRelanceOne,
      'Relance2': this.deadlineReLanceTwo,
      'Relance3': this.deadlineReLanceTree,
    };

    this.dialogRef.close(deadLineJson);
  
  }
 

}



